(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["account-login"]) return;
  try {
    
function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
  
window.addEventListener("load", function (event) {
  if(location.hash == '#recover') {
    var recover_password_button = document.querySelector('#forgot-password-link');
    if(recover_password_button) recover_password_button.click();
  }
  var return_path_value = getCookie('return_path');
  if(return_path_value) {
    var customer_login_form_return_input = document.querySelector('main#MainContent form#customer_login input[name="return_to"]');
    customer_login_form_return_input.value = return_path_value;
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["account-offcanvas"]) return;
  try {
    
window.addEventListener("load", function (event) {
  var account_offcanvas_bs = new bootstrap.Offcanvas('#account-offcanvas');
  var account_offcanvas = document.querySelector('#account-offcanvas');
  if(location.hash == '#showAccount') {
    if(account_offcanvas.classList.contains('logged-in') && !account_offcanvas.classList.contains('dont-show')) account_offcanvas_bs.show();
  }
});

function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
function countdown(cdown) {
  var repeatHour = parseInt(cdown.dataset.repeatHour);
  
  var now = new Date();
  var maxTime = new Date(cdown.dataset.countdown+cdown.dataset.countdownTimezone);
  var hour = maxTime.getHours();
  var minute = maxTime.getMinutes();
  var second = maxTime.getSeconds();

  if (now > maxTime && repeatHour > 0) {
    var extraDay = 0;
    var extraHour = 0;
    if(repeatHour > 24) {
      extraDay = Math.floor(repeatHour / 24);
      var extraFullDaysHours = extraDay * 24;
      if(repeatHour > extraFullDaysHours) extraHour = repeatHour - extraFullDaysHours;
    } else extraHour = repeatHour;

    maxTime = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate() + extraDay,
      hour + extraHour,
      minute,
      second,
    );
  }

  var countDownDate = maxTime.getTime();
  var timeleft = countDownDate - new Date().getTime();
  if(timeleft > 0) {
    var days = Math.floor(timeleft / (1000 * 60 * 60 * 24));
    var hours = Math.floor((timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    if(cdown.dataset.showDay == 'false') hours = (days * 24) + hours;
    var minutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((timeleft % (1000 * 60)) / 1000);
  
    if(hours<10) hours = '0' + hours;
    if(days<10) days = '0' + days;
    if(minutes<10) minutes = '0' + minutes;
    if(seconds<10) seconds = '0' + seconds;
  
    cdown.querySelector('.days span').innerHTML = days;
    cdown.querySelector('.hours span').innerHTML = hours;
    cdown.querySelector('.minutes span').innerHTML = minutes;
    cdown.querySelector('.seconds span').innerHTML = seconds;
    
    var cdownWrapper = cdown.closest('div.position-absolute');
    if(cdownWrapper.classList.contains('d-none')) cdownWrapper.classList.remove('d-none');
  
    var cdownId = cdown.getAttribute('id');
    try {
      eval('CDTimer' + cdownId );
    } catch (e) {
      eval('CDTimer' + cdownId + '=setInterval(countdown, 1000, cdown);');
    }
  }
} 

var accbars = document.querySelector('#announcement-bars');
if(accbars) {
  if(accbars.dataset.stickyAcc == 'true') accbars.closest('section').classList.add('sticky-top');
  var countdowns =  document.querySelectorAll('section.announcement-bar div[data-countdown]');
  countdowns.forEach((item)=>{
    countdown(item);
  });
  var klaviyoPopups = document.querySelectorAll('a[data-klaviyo-formid]');
  klaviyoPopups.forEach((item)=>{
    item.addEventListener("click", function() {
      window._klOnsite = window._klOnsite || []; 
      window._klOnsite.openForm(item.dataset.klaviyoFormid); 
    }); 
  });
  var discountCodes = document.querySelectorAll('a[data-acc-discount-code]');
  discountCodes.forEach((item)=>{
    item.addEventListener("click", function() {
      var carousel_item = item.closest('.carousel-item');
      var button_desktop = carousel_item.querySelector('button.desktop-btn[data-acc-discount-code]');
      var button_mobile = carousel_item.querySelector('button.mobile-btn[data-acc-discount-code]');
      var smallText = button_mobile.querySelector('small');
      smallText.innerHTML = "Applying...";
      button_desktop.innerHTML = "Applying...";
      fetch('/discount/'+item.dataset.accDiscountCode, {
        method: "get"
      }).then(response => {
        smallText.innerHTML = "Applied to the cart!";
        button_desktop.innerHTML = "Applied to the cart!" 
      });
    });
  });
} else {
  document.querySelector('section.announcement-bar').classList.add('d-none'); 
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article-video"] && !window.DesignMode) return;
  try {
    
var youtube_video_section = document.querySelector('section.article-video div.article-youtube-video');
var youtube_video = youtube_video_section.querySelector('iframe');
var main_video = youtube_video_section.querySelector('.main-video');
var next_video = youtube_video_section.querySelector('.next-story');
var youtube_video_id = youtube_video.dataset.youtubeId;
var youtube_video_trailer_start = parseInt(youtube_video.dataset.trailerStart);
var youtube_video_trailer_duration = parseInt(youtube_video.dataset.trailerDuration)*1000;
var body = document.body;

function restartTrailer(trailer, start) {
  trailer.contentWindow.postMessage('{"event":"command","func":"seekTo","args":['+start+',true]}', '*');
}

function startTrailer() {
  youtube_video.contentWindow.postMessage('{"event":"command","func":"seekTo","args":['+youtube_video_trailer_start+',true]}', '*');
  youtube_video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
  youtube_video.contentWindow.postMessage('{"event":"command","func":"mute","args":""}', '*');
  trailerInterval = setInterval(restartTrailer, youtube_video_trailer_duration, youtube_video, youtube_video_trailer_start);
}

window.addEventListener("load", (event) => {
  if(location.hash == '#watch') {
    playVideo();
  } else {
    startTrailer();
  }
});

var close_button = document.querySelector('div.close-button button.btn-close');
if(close_button) {
  close_button.addEventListener("click", function() {
    body.classList.remove('playing');
    startTrailer();
  });
}

function playVideo() {
  // youtube_video.contentWindow.postMessage('{"event":"command","func":"seekTo","args":""}', '*');
  youtube_video.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
  youtube_video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
  youtube_video.contentWindow.postMessage('{"event":"command","func":"unMute","args":""}', '*');
  youtube_video_section.classList.remove('trailer');
  body.classList.add('playing');
}

var watch_now_btns = document.querySelectorAll('section.article-video button.watch-now');
watch_now_btns.forEach((item)=>{
  item.addEventListener("click", function() {
    clearInterval(trailerInterval);
    playVideo();
  });
});

var sliders = document.querySelectorAll('.slider-carousel');
sliders.forEach((slider) => {
  var swiper_button_next = slider.querySelector('.swiper-button-next');
  var swiper_button_prev = slider.querySelector('.swiper-button-prev');
  var swiper_scrollbar = slider.querySelector('.swiper-scrollbar');
  var pagination = slider.querySelector('.swiper-pagination');  
  var slider_options = {
    slidesPerView: slider.dataset.slidesPerRowMobile,
    loop: (slider.dataset.slidesLoop === 'true'),
    centeredSlides: (slider.dataset.slidesCentered === 'true'),
    mousewheel: {
      forceToAxis: true
    },
    breakpoints: { 
      768: {
        slidesPerView: slider.dataset.slidesPerRowDesktop
      }
    },
    navigation: {
      nextEl: swiper_button_next,
      prevEl: swiper_button_prev,
    },
    scrollbar: {
      el: swiper_scrollbar,
      draggable: true,
    },
    pagination: {
      el: pagination,
      dynamicBullets: true
    }
  };
  var carousel_swiper = new Swiper(slider, slider_options);
  slider.addEventListener("mouseover", (event) => {
    var target_element = event.target;
    if(target_element.classList.contains('related-video')) {
      var column = target_element.closest('.col');
      column.classList.add('hovered');
      var trailer_video = column.querySelector('iframe');
      var related_trailer_start = trailer_video.dataset.trailerStart;
      var related_trailer_duration = parseInt(trailer_video.dataset.trailerDuration)*1000;
      trailer_video.contentWindow.postMessage('{"event":"command","func":"seekTo","args":['+related_trailer_start+',true]}', '*');
      trailer_video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
      trailer_video.contentWindow.postMessage('{"event":"command","func":"mute","args":""}', '*');
      relatedTrailerInterval = setInterval(restartTrailer, related_trailer_duration, trailer_video, related_trailer_start);
    }
  });
  slider.addEventListener("mouseout", (event) => {
    var target_element = event.target;
    if(target_element.classList.contains('related-video')) {
      clearInterval(relatedTrailerInterval);
      var column = target_element.closest('.col');
      column.querySelector('img').classList.remove('d-none');
      column.classList.remove('hovered');
      var trailer_video = column.querySelector('iframe');
      trailer_video.classList.add('d-none');
      trailer_video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
    }
  });
});
  
window.addEventListener('message', function (event) {
  if(event.origin == 'https://www.youtube.com') {
    event_data = JSON.parse(event.data);
    if(event_data.event == 'infoDelivery') {
      if(event_data.info.videoData) {
        if(event_data.info.videoData.video_id == youtube_video_id && event_data.info.playerState == 1 && !body.classList.contains('playing')) youtube_video_section.classList.add('trailer');
        if(event_data.info.playerState == 1) {
          var slider_column = document.querySelector('.related-videos-carousel .col.hovered[data-youtube-id="'+event_data.info.videoData.video_id+'"]');
          if(slider_column) {
            slider_column.querySelector('img').classList.add('d-none');
            slider_column.querySelector('iframe').classList.remove('d-none');
          }
        }
        if(event_data.info.videoData.video_id == youtube_video_id && event_data.info.playerState == 0 && body.classList.contains('playing')) {
          if(next_video) {
            main_video.classList.add('d-none');
            next_video.classList.remove('d-none');
            next_video_a = next_video.querySelector('a');
            next_video_a.querySelector('span').classList.add('count-animation');
            setTimeout(function(){
              window.location.replace(next_video_a.getAttribute('href'));
            }, 5000);
          }
        }
      }
    }
  }
}, false);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-video"] && !window.DesignMode) return;
  try {
    
var youtube_video_section = document.querySelector('section.blog-video div.article-youtube-video');
var youtube_video = youtube_video_section.querySelector('iframe');
var youtube_video_id = youtube_video.dataset.youtubeId;
var youtube_video_trailer_start = parseInt(youtube_video.dataset.trailerStart);
var youtube_video_trailer_duration = parseInt(youtube_video.dataset.trailerDuration)*1000;

function restartTrailer(trailer, start) {
  trailer.contentWindow.postMessage('{"event":"command","func":"seekTo","args":['+start+',true]}', '*');
}

window.addEventListener("load", (event) => {
  youtube_video.contentWindow.postMessage('{"event":"command","func":"seekTo","args":['+youtube_video_trailer_start+',true]}', '*');
  youtube_video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
  youtube_video.contentWindow.postMessage('{"event":"command","func":"mute","args":""}', '*');
  trailerInterval = setInterval(restartTrailer, youtube_video_trailer_duration, youtube_video, youtube_video_trailer_start);
});

window.addEventListener('message', function (event) {
  if(event.origin == 'https://www.youtube.com') {
    event_data = JSON.parse(event.data);
    if(event_data.event == 'infoDelivery') {
      if(event_data.info.videoData) {
        if(event_data.info.videoData.video_id == youtube_video_id && event_data.info.playerState == 1) youtube_video_section.classList.add('trailer');
      }
    }
  }
}, false);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carousel-videos"] && !window.DesignMode) return;
  try {
    
function restartTrailer(trailer, start) {
  trailer.contentWindow.postMessage('{"event":"command","func":"seekTo","args":['+start+',true]}', '*');
}

var sliders = document.querySelectorAll('.slider-carousel');
sliders.forEach((slider) => {
  var swiper_button_next = slider.querySelector('.swiper-button-next');
  var swiper_button_prev = slider.querySelector('.swiper-button-prev');
  var swiper_scrollbar = slider.querySelector('.swiper-scrollbar');
  var pagination = slider.querySelector('.swiper-pagination');  
  var slider_options = {
    slidesPerView: slider.dataset.slidesPerRowMobile,
    loop: (slider.dataset.slidesLoop === 'true'),
    centeredSlides: (slider.dataset.slidesCentered === 'true'),
    mousewheel: {
      forceToAxis: true
    },
    breakpoints: { 
      768: {
        slidesPerView: slider.dataset.slidesPerRowDesktop
      }
    },
    navigation: {
      nextEl: swiper_button_next,
      prevEl: swiper_button_prev,
    },
    scrollbar: {
      el: swiper_scrollbar,
      draggable: true,
    },
    pagination: {
      el: pagination,
      dynamicBullets: true
    }
  };
  var carousel_swiper = new Swiper(slider, slider_options);
  slider.addEventListener("mouseover", (event) => {
    var target_element = event.target;
    if(target_element.classList.contains('related-video')) {
      var column = target_element.closest('.col');
      column.classList.add('hovered');
      var trailer_video = column.querySelector('iframe');
      var related_trailer_start = trailer_video.dataset.trailerStart;
      var related_trailer_duration = parseInt(trailer_video.dataset.trailerDuration)*1000;
      trailer_video.contentWindow.postMessage('{"event":"command","func":"seekTo","args":['+related_trailer_start+',true]}', '*');
      trailer_video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
      trailer_video.contentWindow.postMessage('{"event":"command","func":"mute","args":""}', '*');
      relatedTrailerInterval = setInterval(restartTrailer, related_trailer_duration, trailer_video, related_trailer_start);
    }
  });
  slider.addEventListener("mouseout", (event) => {
    var target_element = event.target;
    if(target_element.classList.contains('related-video')) {
      clearInterval(relatedTrailerInterval);
      var column = target_element.closest('.col');
      column.classList.remove('hovered');
      column.querySelector('img').classList.remove('d-none');
      var trailer_video = column.querySelector('iframe');
      trailer_video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
      trailer_video.classList.add('d-none');
    }
  });
});

window.addEventListener('message', function (event) {
  if(event.origin == 'https://www.youtube.com') {
    event_data = JSON.parse(event.data);
    if(event_data.event == 'infoDelivery') {
      if(event_data.info.videoData) {
        if(event_data.info.playerState == 1) {
          var slider_column = document.querySelector('.related-videos-carousel .col.hovered[data-youtube-id="'+event_data.info.videoData.video_id+'"]');
          if(slider_column) {
            slider_column.querySelector('img').classList.add('d-none');
            slider_column.querySelector('iframe').classList.remove('d-none');
          }
        }
      }
    }
  }
}, false);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carousel"] && !window.DesignMode) return;
  try {
    
var carousels = document.querySelectorAll('.collection-carousel');
carousels.forEach((carousel) => {
  var swiper_button_next = carousel.querySelector('.swiper-button-next');
  var swiper_button_prev = carousel.querySelector('.swiper-button-prev');
  var swiper_scrollbar = carousel.querySelector('.swiper-scrollbar');
  var carousel_options = {
    slidesPerView: carousel.dataset.slidesPerRowMobile,
    mousewheel: {
      forceToAxis: true
    },
    breakpoints: {
      768: {
        slidesPerView: carousel.dataset.slidesPerRowDesktop
      }
    },
    navigation: {
      nextEl: swiper_button_next,
      prevEl: swiper_button_prev,
    },
    scrollbar: {
      el: swiper_scrollbar,
      draggable: true,
    }
  };
  var carousel_swiper = new Swiper(carousel, carousel_options);
});

var tab_buttons = document.querySelectorAll('section.collection-carousel-section button[data-bs-toggle="pill"]');
tab_buttons.forEach((item)=>{
  item.addEventListener('shown.bs.tab', event => {
    var targetElement = event.target;
    var targetSection = targetElement.closest('section.collection-carousel-section');
    var tab_content = targetSection.querySelector(targetElement.dataset.bsTarget + ' .swiper-initialized');
    if(tab_content) tab_content.swiper.scrollbar.enable();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-offcanvas"]) return;
  try {
    
var cart_offcanvas = document.querySelector('#cart-offcanvas');

var cart_form = cart_offcanvas.querySelector("#cart-offcanvas-form");

function cart_form_submit() { 
  var cart_impact_products = cart_form.querySelectorAll('#cart-items input[data-impact-product]');
  cart_impact_products.forEach((item)=>{
    item.value = 0;
  });  
  loading.classList.remove('d-none');
  loading.classList.add('d-flex');
  fetch(cart_form.action, {
    method: "post", 
    body: new FormData(cart_form)
  }).then(response => {
    if(response.ok) cart_update();
  });
}

cart_form.onclick = function (e) {
  var q_input;
  var q_action = '';
  var target_classList = e.target.classList;
  if(target_classList.contains('increase')) {
    q_input = e.target.previousElementSibling;
    q_action = 'increase';
  } 
  if(target_classList.contains('increase-icon')) {
    q_input = e.target.closest('button').previousElementSibling;
    q_action = 'increase';
  }
  if(target_classList.contains('decrease')) { 
    q_input = e.target.nextElementSibling;
    q_action = 'decrease';
  }
  if(target_classList.contains('decrease-icon')) {
    q_input = e.target.closest('button').nextElementSibling;
    q_action = 'decrease';  
  }
  if(q_input && q_action != '') {
    if(q_action == 'increase') q_input.value = parseInt(q_input.value) + 1;
    else if(q_action == 'decrease') q_input.value = parseInt(q_input.value) - 1;
    e.preventDefault();
    cart_form_submit(); 
  }
} 

cart_form.onsubmit = function (e) {
  e.preventDefault();
  cart_form_submit();
}

var cart_section_id = cart_form.dataset.sectionId;
var cart_items = cart_form.querySelector('#cart-items');
var free_shipping_bar = cart_offcanvas.querySelector('#free-shipping-bar');
var checkout_bar = cart_offcanvas.querySelector('#checkout-bar');
var complementary_products = cart_offcanvas.querySelector('#complementary-products-cart-wrapper');
var loading = cart_offcanvas.querySelector('#loading');
var html = document.createElement('div');
var cart_btn_icon = document.querySelector('header button#cart-btn #cart-not-empty');
function cart_update(){
  loading.classList.remove('d-none'); 
  loading.classList.add('d-flex'); 
  fetch('/cart?section_id='+cart_section_id)
  .then(function(response) { 
    return response.text();
  })
  .then(function(response_body) {
    html.innerHTML = response_body;
    cart_items.innerHTML = html.querySelector('#cart-offcanvas #cart-offcanvas-form #cart-items').innerHTML;
    cart_items_length = html.querySelectorAll('#cart-offcanvas #cart-offcanvas-form #cart-items div').length;
    var newSubtotal = html.querySelector('#cart-offcanvas #cart-offcanvas-form').dataset.cartSubtotal;
    cart_form.setAttribute('data-cart-subtotal',newSubtotal);
    if(cart_items_length > 0) cart_btn_icon.classList.remove('d-none');
    else cart_btn_icon.classList.add('d-none');
    free_shipping_bar.innerHTML = html.querySelector('#free-shipping-bar').innerHTML;
    checkout_bar.innerHTML = html.querySelector('#checkout-bar').innerHTML;
    complementary_products.innerHTML = html.querySelector('#complementary-products-cart-wrapper .complementary-products-carousel-cart').innerHTML;
    
    var productRecommendationsSection = document.querySelector('.complementary-products-carousel-cart');
    if(productRecommendationsSection.querySelector('.swiper-wrapper')) {
      var swiper_button_next = productRecommendationsSection.querySelector('.swiper-button-next');
      var swiper_button_prev = productRecommendationsSection.querySelector('.swiper-button-prev');
      var swiper_scrollbar = productRecommendationsSection.querySelector('.swiper-scrollbar');
  
      var recommendations_carousel_options = {
        slidesPerView: productRecommendationsSection.dataset.slidesPerRowMobile,
        mousewheel: {
          forceToAxis: true
        },
        breakpoints: {
          768: {
            slidesPerView: productRecommendationsSection.dataset.slidesPerRowDesktop
          }
        },
        navigation: {
          nextEl: swiper_button_next,
          prevEl: swiper_button_prev,
        },
        scrollbar: {
          el: swiper_scrollbar,
          draggable: true,
        }
      };
      
      var recommendations_carousel_swiper = new Swiper(productRecommendationsSection, recommendations_carousel_options);
    }
    
    loading.classList.add('d-none');
    loading.classList.remove('d-flex'); 

    var cart_offcanvas_target = document.querySelector('#cart-offcanvas'); 
    var broken_products = false;
    var cart_impact_products = cart_form.querySelectorAll('#cart-items input[data-impact-product]');
    if(cart_impact_products.length>0) broken_products = true; 
    if(broken_products == true) cart_form_submit();
    var is_free_code = html.querySelector('div[data-freeshipping-code]');
    if(is_free_code) apply_free_code(is_free_code.dataset.freeshippingCode);
  });
}

function apply_free_code(discount_code) {
  fetch('/discount/'+discount_code, {
    method: "get"
  }).then(response => {
    
  });
}
  
cart_offcanvas.addEventListener('show.bs.offcanvas', event => {
  cart_update();
  // if(event.target.classList.contains("load-the-cart")) {
  //   cart_update();
  //   event.target.classList.remove('load-the-cart');
  // } 
}); 

var complementary_products = cart_offcanvas.querySelector('.complementary-products-carousel-cart');
complementary_products.onclick = function(e) {
  if(e.target.classList.contains('add-to-cart')) {
    e.preventDefault();
    var complementary_product_form = e.target.closest('form');
    complementary_product_form.classList.add('loading');
    fetch(complementary_product_form.action, {
      method: "post", 
      body: new FormData(complementary_product_form)
    }).then(response => {
      if(response.ok) cart_update();
    });
  }
}

checkout_bar.onclick = function(e) {
  var targetElement = e.target;
  if(targetElement.nodeName == "SPAN") targetElement = targetElement.closest('button');
  if(targetElement.classList) {
    if(targetElement.classList.contains('free-gift-add-button')) {
      if(!targetElement.disabled) {
        targetElement.querySelector('span').classList.add('d-none');
        targetElement.classList.add('loading');
        targetElement.setAttribute('disabled','true');
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({
            id: targetElement.dataset.freeGiftId,
            quantity: 1,
            properties: {
              _free_gift: 'yes'
            }
          })
        })
        .then(response => {
          cart_update();
        })
        .catch((error) => {
          console.error('Error:', error);
        });
      }
    }
  }
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-page-content"]) return;
  try {
    
var section_cart_page = document.querySelector('section.cart-page');
var loading = section_cart_page.querySelector("#loading"); 
var cart_form = section_cart_page.querySelector("#cart-form");
var checkout_bar = section_cart_page.querySelector('#checkout-bar');
var cart_section_id = cart_form.dataset.sectionId;
var html = document.createElement('div');
var cart_items = cart_form.querySelector('#cart-items');
var free_shipping_bar = section_cart_page.querySelector('#free-shipping-bar');
var complementary_products = document.querySelector('section.cart-page #complementary-products-cart-wrapper');

function cart_form_submit(e) {
  var cart_items_bundles = cart_form.querySelectorAll('#cart-items input[data-bundle-id]'); 
  cart_items_bundles.forEach((item)=>{
    var bundle_id = item.dataset.bundleId;
    if(!cart_form.querySelector('input[data-bundle-id="'+bundle_id+'"][data-main-product]')) item.value = 0;
  });
  loading.classList.remove('d-none')
  loading.classList.add('d-flex');
  fetch(cart_form.action, {
    method: "post", 
    body: new FormData(cart_form)
  }).then(response => {
    if(response.ok) cart_update();
  });
}  

cart_form.onclick = function (e) {
  var q_input;
  var q_action = '';
  var target_classList = e.target.classList;
  if(target_classList.contains('increase')) {
    q_input = e.target.previousElementSibling;
    q_action = 'increase';
  } 
  if(target_classList.contains('increase-icon')) {
    q_input = e.target.closest('button').previousElementSibling;
    q_action = 'increase';
  }
  if(target_classList.contains('decrease')) { 
    q_input = e.target.nextElementSibling;
    q_action = 'decrease';
  }
  if(target_classList.contains('decrease-icon')) {
    q_input = e.target.closest('button').nextElementSibling;
    q_action = 'decrease';  
  }
  if(q_input && q_action != '') {
    if(q_action == 'increase') q_input.value = parseInt(q_input.value) + 1;
    else if(q_action == 'decrease') q_input.value = parseInt(q_input.value) - 1;
    if(q_input.dataset.bundleId) {
      var other_accs = cart_form.querySelectorAll('input[type="hidden"][data-bundle-id="'+q_input.dataset.bundleId+'"]');
      other_accs.forEach((item)=>{
        if(q_action == 'increase') item.value = parseInt(item.value) + 1;
        else if(q_action == 'decrease') item.value = parseInt(item.value) - 1;
      });
    }
    e.preventDefault();
    cart_form_submit(); 
  }
}

cart_form.onsubmit = function (e) { 
  e.preventDefault();
  cart_form_submit();
}

var productRecommendationsSection = document.querySelector('section.cart-page .complementary-products-carousel-cart');
if(productRecommendationsSection.querySelector('.swiper-wrapper')) {
  var swiper_button_next = productRecommendationsSection.querySelector('.swiper-button-next');
  var swiper_button_prev = productRecommendationsSection.querySelector('.swiper-button-prev');
  var swiper_scrollbar = productRecommendationsSection.querySelector('.swiper-scrollbar');

  var recommendations_carousel_options = {
    slidesPerView: productRecommendationsSection.dataset.slidesPerRowMobile,
    breakpoints: {
      768: {
        slidesPerView: productRecommendationsSection.dataset.slidesPerRowDesktop
      }
    },
    navigation: {
      nextEl: swiper_button_next,
      prevEl: swiper_button_prev,
    },
    scrollbar: {
      el: swiper_scrollbar,
      draggable: true,
    }
  };
  
  var recommendations_carousel_swiper = new Swiper(productRecommendationsSection, recommendations_carousel_options);
} 
  
function cart_update(){
  loading.classList.remove('d-none')
  loading.classList.add('d-flex');
  fetch('/cart?section_id='+cart_section_id)
  .then(function(response) {
    return response.text();
  })
  .then(function(response_body) {
    html.innerHTML = response_body;
    cart_items.innerHTML = html.querySelector('section.cart-page form#cart-form #cart-items').innerHTML;
    free_shipping_bar.innerHTML = html.querySelector('#free-shipping-bar').innerHTML;
    checkout_bar.innerHTML = html.querySelector('#checkout-bar').innerHTML;
    complementary_products.innerHTML = html.querySelector('#complementary-products-cart-wrapper .complementary-products-carousel-cart').innerHTML;
    
    var productRecommendationsSection = document.querySelector('section.cart-page .complementary-products-carousel-cart');
    if(productRecommendationsSection.querySelector('.swiper-wrapper')) {
      var swiper_button_next = productRecommendationsSection.querySelector('.swiper-button-next');
      var swiper_button_prev = productRecommendationsSection.querySelector('.swiper-button-prev');
      var swiper_scrollbar = productRecommendationsSection.querySelector('.swiper-scrollbar');
  
      var recommendations_carousel_options = {
        slidesPerView: productRecommendationsSection.dataset.slidesPerRowMobile,
        breakpoints: {
          768: {
            slidesPerView: productRecommendationsSection.dataset.slidesPerRowDesktop
          }
        },
        navigation: {
          nextEl: swiper_button_next,
          prevEl: swiper_button_prev,
        },
        scrollbar: {
          el: swiper_scrollbar,
          draggable: true,
        }
      };
      
      var recommendations_carousel_swiper = new Swiper(productRecommendationsSection, recommendations_carousel_options);
    }
    
    loading.classList.add('d-none');
    loading.classList.remove('d-flex');

    var cart_offcanvas_target = document.querySelector('#cart-offcanvas'); 
    var cart_items_bundles = cart_offcanvas_target.querySelectorAll('#cart-items input[data-bundle-id]'); 
    var broken_products = false;
    cart_items_bundles.forEach((item)=>{
      var bundle_id = item.dataset.bundleId; 
      if(!cart_offcanvas_target.querySelector('input[data-bundle-id="'+bundle_id+'"][data-main-product]')) broken_products = true;
    });
    if(broken_products == true) cart_form_submit();
  });
}   

var complementary_products = section_cart_page.querySelector('.complementary-products-carousel-cart');
complementary_products.onclick = function(e) {
  if(e.target.classList.contains('add-to-cart')) {
    e.preventDefault();
    var complementary_product_form = e.target.closest('form');
    complementary_product_form.classList.add('loading');
    var formData = new FormData(complementary_product_form);
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      body: formData
    }).then(response => {
      if(response.ok) cart_update();
    });
  }
}  
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-grid"] && !window.DesignMode) return;
  try {
    
var view_all_buttons = document.querySelectorAll('button.view-all-button');
view_all_buttons.forEach((item)=>{
  item.addEventListener('click', (e) => {
    var collection_grid_section = item.closest('section.collection-grid-section');
    collection_grid_section.querySelectorAll('.product-card-wrapper.d-none').forEach((item)=>{
      item.classList.remove('d-none');
    });
    item.classList.add('d-none');
    collection_grid_section.querySelector('.view-less-button').classList.remove('d-none');
    if(ScrollTrigger) ScrollTrigger.refresh();
  });
});

var view_less_buttons = document.querySelectorAll('button.view-less-button');
view_less_buttons.forEach((item)=>{
  item.addEventListener('click', (e) => {
    var collection_grid_section = item.closest('section.collection-grid-section');
    collection_grid_section.querySelectorAll('.product-card-wrapper.inside-view-all-products').forEach((item)=>{
      item.classList.add('d-none');
    });
    item.classList.add('d-none');
    collection_grid_section.querySelector('button.view-all-button').classList.remove('d-none');
    collection_grid_section.scrollIntoView();
    if(ScrollTrigger) ScrollTrigger.refresh();
  });
});

var cart_offcanvas = new bootstrap.Offcanvas('#cart-offcanvas');
var products = document.querySelectorAll('.collection-grid');
products.forEach((item) => {
  item.addEventListener('click', (e) => {
    if(e.target.classList.contains('add-to-cart')){
      e.preventDefault();
      add_to_cart(e);
    } else if(e.target.classList.contains('product-color-link')){
      e.preventDefault();
      var productUrl = e.target.getAttribute('href');
      if(e.target.nodeName == 'IMG') productUrl = e.target.closest('a').getAttribute('href');
      fetch(productUrl)
      .then(function(response) {
        return response.text();
      })
      .then(function(response_body) {
        var response_body = new DOMParser().parseFromString(response_body, "text/html");
        var newCard = response_body.querySelector('#quick-add-card .product-card');
        newCard.classList.remove('d-none');
        var productCard = e.target.closest('.product-card');
        productCard.innerHTML = newCard.innerHTML;
      });
    } else if(e.target.classList.contains('size-selector')) {
      var itemForm = e.target.closest('form');
      clearPreorderProperties(itemForm);
      var preorder_product = itemForm.querySelector('input[data-preorder-product]');
      if(preorder_product) {
        preorder_product.checked = true;
        var preorder_shipping_date = itemForm.querySelector('input[name="items[1][properties][Shipping Pre-order]"]');
        preorder_shipping_date.removeAttribute('disabled');
      }
      var preorder_property = itemForm.querySelector('input.shipping-preorder[data-variant-estimated-delivery="'+e.target.dataset.variantEstimatedDelivery+'"]');
      if(preorder_property) preorder_property.removeAttribute('disabled');
    }
  });
});

function clearPreorderProperties(itemForm) {
  var preorder_product = itemForm.querySelector('input[data-preorder-product]');
  if(preorder_product) {
    preorder_product.checked = false;
    var preorder_shipping_date = itemForm.querySelector('input[name="items[1][properties][Shipping Pre-order]"]:not(disabled)');
    preorder_shipping_date.setAttribute('disabled','true');
  }
  var preorder_properties = itemForm.querySelectorAll('input.shipping-preorder[data-variant-estimated-delivery]');
  preorder_properties.forEach((item)=>{
    item.setAttribute('disabled','true');
  });
}

function add_to_cart(e) {
  var product_form = e.target.closest('form');
  product_form.classList.add('loading');
  var formData = new FormData(product_form);
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    body: formData
  })
  .then(response => {
    product_form.classList.remove('loading');
    product_form.reset();
    cart_offcanvas._element.classList.add('load-the-cart');
    cart_offcanvas.show();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

var urlParams = new URLSearchParams(window.location.search);
var orderParam = urlParams.get('orderP');

if(orderParam) {
    orderParam = orderParam.toLowerCase().split('|');
    var orderParamLength = orderParam.length;

    var products = document.querySelectorAll('section.collection-grid-section .collection-grid .product-card-wrapper');
    products.forEach((item) => {
        var productTitle = item.dataset.productTitle;
        if(!productTitle) return false;
        productTitle = productTitle.trim().replace(/(\r\n|\n|\r)/gm, " ").toLowerCase();
        var orderIndex = -1;
        orderParam.forEach((param,index) => {
            if(productTitle.indexOf(param)>-1) orderIndex = index;
        });
        if(orderIndex >= 0) {
          item.style.order = orderIndex-orderParamLength;
          item.classList.remove('d-none','inside-view-all-products');
        }
    });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-product-grid"] && !window.DesignMode) return;
  try {
    
var collection_grid = document.querySelector('.collection-product-grid');
var price_slider = collection_grid.querySelector('#price-slider');
var collection_grid_section_id = collection_grid.dataset.sectionId;
 
if(price_slider) price_slider_init(price_slider);
function price_slider_init(price_slider) {
  var price_slider_start = parseInt(price_slider.dataset.start);
  var price_slider_end = parseInt(price_slider.dataset.end);
  var searchParams = new URLSearchParams(window.location.search);
  var priceGte = searchParams.get('price.gte');
  var priceLte = searchParams.get('price.lte');
  if(priceGte) price_slider_start = parseInt(priceGte);
  if(priceLte) price_slider_end = parseInt(priceLte);
  noUiSlider.create(price_slider, {
    start: [price_slider_start, price_slider_end],
    connect: true,
    range: {
      'min': 0,
      'max': parseInt(price_slider.dataset.max)
    },
    tooltips: [
      { to: function(value) { return price_slider.dataset.currencySymbol + String(value).split('.')[0]; } },
      { to: function(value) { return price_slider.dataset.currencySymbol + String(value).split('.')[0]; } }
    ],
  }).on('change',function(e){
    var selected_price_start = e[0];
    var selected_price_end = e[1];
    searchParams.set("price.gte", selected_price_start);
    searchParams.set("price.lte", selected_price_end);
    var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + searchParams.toString();
    window.history.pushState({prevPath: window.location.pathname, path: newurl}, '', newurl);
  });
}

var filters_sort = collection_grid.querySelector('#filters-sort');
filters_sort.addEventListener('click', (e) => {
  var searchParams = new URLSearchParams(window.location.search);
  var targetElement = e.target;
  if(targetElement.nodeName == 'A') {
    if(targetElement.classList.contains('reload-page')) return false; 
    e.preventDefault();
    var newurl = targetElement.href;
    if(newurl.indexOf('apparel')<0) {
      if(targetElement.dataset.withFilters != null) {
        searchParams.set("filter.v.availability","1");
        newurl = newurl + '?' + searchParams.toString()
      } else {
        if(newurl.indexOf('filter.v.availability') > 0) {
         
        } else {
          if(newurl.indexOf('?') > 0) newurl = newurl + '&filter.v.availability=1';
          else newurl = newurl + '?filter.v.availability=1';
          newurl = newurl;
        }
      }
    }
    window.history.pushState({prevPath: window.location.pathname, path: targetElement.href}, '', newurl);
    updateCollectionGrid();
  }
});

var filters_sort_offcanvas = collection_grid.querySelector('#filters-offcanvas');
var clear_all = filters_sort_offcanvas.querySelector('#clear-all');
var searchParams = new URLSearchParams(window.location.search);
filters_sort_offcanvas.addEventListener('click', (e) => {
  var newurl = window.location.pathname;
  var targetElement = e.target;
  if(targetElement.nodeName == 'svg' || targetElement.nodeName == 'circle') targetElement = e.target.closest('a');
  if(targetElement.nodeName == 'A') {
    if(targetElement.classList.contains('reload-page')) return false;
    e.preventDefault();
    if(targetElement.classList.contains('clear-all')) {
      newurl = newurl;
      active_filters = filters_sort_offcanvas.querySelectorAll('.filter-active:not(.sort-item)').forEach((item)=>{
        item.classList.remove('filter-active');
      });
    } else if(targetElement.classList.contains('sort-item')) {
      searchParams.set(targetElement.dataset.filterParam,targetElement.dataset.filterValue);
      newurl = newurl + '?' + searchParams.toString();
      filters_sort_offcanvas.querySelector('.sort-item.filter-active').classList.remove('filter-active');
      targetElement.classList.add('filter-active');
    } else {
      targetElement.classList.toggle('filter-active');
      if(targetElement.classList.contains('filter-active')) searchParams.append(targetElement.dataset.filterParam,targetElement.dataset.filterValue);
      else searchParams.delete(targetElement.dataset.filterParam,targetElement.dataset.filterValue);
      if(newurl.indexOf('apparel')<0 && targetElement.dataset.withFilters != null) searchParams.set("filter.v.availability","1");
      newurl = newurl + '?' + searchParams.toString();
    }
    window.history.pushState({prevPath: window.location.pathname, path: newurl}, '', newurl);
  }
});
  
var oldPushState = history.pushState;
history.pushState = function pushState() {
    var ret = oldPushState.apply(this, arguments);
    window.dispatchEvent(new Event('pushstate'));
    window.dispatchEvent(new Event('locationchange'));
    return ret;
};

window.addEventListener('popstate', () => {
    window.dispatchEvent(new Event('locationchange'));
});

var currentPage = 1;

function loadingAnimation(animation_state) {
  var loading = document.querySelector('section#shopify-section-'+collection_grid_section_id+' .loading');
  if(animation_state == true) {
    loading.classList.remove('d-none');
    loading.classList.add('d-block');
  } else {
    loading.classList.add('d-none');
    loading.classList.remove('d-block');
  }
}

// var banner = document.querySelector('section[id$="__banner"]');
var banner = document.querySelector('main section:first-child'); // because the sale banner has been changed.
function changeBanner() {
  var section_id = banner.getAttribute('id').replace('shopify-section-','');
  var searchParams = new URLSearchParams(window.location.search);
  searchParams.set("section_id", section_id);
  var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + searchParams.toString();
  fetch(newurl)
  .then(function(response) {
    return response.text();
  })
  .then(function(response_body) {
    var response_body = new DOMParser().parseFromString(response_body, "text/html");
    banner.innerHTML = response_body.querySelector('section').innerHTML;
  });
}

var compare_products = document.querySelector('section.compare-products');
function changeCompareProducts() {
  if(compare_products) {
    var section_id = compare_products.getAttribute('id').replace('shopify-section-','');
    var searchParams = new URLSearchParams(window.location.search);
    searchParams.set("section_id", section_id);
    var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + searchParams.toString();
    fetch(newurl)
    .then(function(response) {
      return response.text();
    })
    .then(function(response_body) {
      var response_body = new DOMParser().parseFromString(response_body, "text/html");
      compare_products.innerHTML = response_body.querySelector('section').innerHTML;
    });
  }
}

var otherCollectionGrid = document.querySelector('section.collection-grid-section');
var otherElements = document.querySelectorAll('section.collection-product-grid-section ~ section.collection-grid-section');
var filtersApplied = false;

window.addEventListener('locationchange', function (e) {
  if(window.location.hash) return false;
  filtersApplied = true;
  clear_all.classList.remove('d-none');
});

filters_sort_offcanvas.addEventListener('hidden.bs.offcanvas', event => {
  if(filtersApplied == true) updateCollectionGrid();
});

filters_sort_offcanvas.addEventListener('show.bs.offcanvas', event => {
  filtersApplied = false;
});

function updateCollectionGrid() {
  loadingAnimation(true);
  currentPage = 1;
  var searchParams = new URLSearchParams(window.location.search);
  searchParams.set("section_id", collection_grid_section_id);
  var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + searchParams.toString();
  if(window.history.state != null){
    if(window.history.state.prevPath != window.location.pathname) {
      changeBanner();
      changeCompareProducts();
    }
  }
  fetch(newurl)
  .then(function(response) {
    return response.text();
  })
  .then(function(response_body) {
    var response_body = new DOMParser().parseFromString(response_body, "text/html");
    var priceGte = searchParams.get('price.gte');
    var priceLte = searchParams.get('price.lte');
    if(priceGte && priceLte) {
      response_body.querySelectorAll("#products .product-card-wrapper[data-real-price]").forEach((item)=>{
        if(parseInt(item.dataset.realPrice) > parseInt(priceLte)) item.remove();
        if(parseInt(item.dataset.realPrice) < parseInt(priceGte)) item.remove();
      });
    }
    document.querySelector("#products").replaceWith(response_body.querySelector("#products"));
    document.querySelector("#sticky-menu").replaceWith(response_body.querySelector("#sticky-menu"));
    document.querySelector("#breadcrumb").replaceWith(response_body.querySelector("#breadcrumb"));
    var active_sticky_menu = document.querySelector('#sticky-menu .active');
    if(active_sticky_menu) active_sticky_menu.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "start" });
    document.querySelector("#product-count").replaceWith(response_body.querySelector("#product-count"));
    collection_grid.scrollIntoView();
    loadingAnimation(false);
    if(otherCollectionGrid) {
      if(window.location.search == '?filter.v.availability=1') {
        document.querySelector("#products").classList.add('d-none');
        otherElements.forEach((item)=>{
          item.classList.remove('d-none');
        });
      } else {
        document.querySelector("#products").classList.remove('d-none');
        otherElements.forEach((item)=>{
          item.classList.add('d-none');
        });
      }
    }
  });
}

window.addEventListener("scroll", (event) => {
  var next_products_wrapper = document.querySelector('#next-products');
  if(!next_products_wrapper) return false;
  var top = document.querySelector('#next-products').getBoundingClientRect().top;
  var left = document.querySelector('#next-products').getBoundingClientRect().left;
  var bottom = document.querySelector('#next-products').getBoundingClientRect().bottom;
  var right = document.querySelector('#next-products').getBoundingClientRect().right;
  var innerHeight = window.innerHeight;
  var innerWidth = window.innerWidth;
  var isVisible = ((top > 0 && top < innerHeight) || (bottom > 0 && bottom < innerHeight)) && ((left > 0 && left < innerWidth) || (right > 0 && right < innerWidth));
  if(isVisible) {
    currentPage++;
    var searchParams = new URLSearchParams(window.location.search);
    document.querySelector("#next-products").remove();
    searchParams.set("page", currentPage);
    searchParams.set("section_id", collection_grid_section_id);
    var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + searchParams.toString();
    
    fetch(newurl)
    .then(function(response) {
      return response.text();
    })
    .then(function(response_body) {
      var response_body = new DOMParser().parseFromString(response_body, "text/html");
      var new_products = response_body.querySelector('#products');
      if(!document.querySelector('body').classList.contains('sd')) {
        new_products.querySelectorAll('input[name$="[_sd]"]').forEach((item)=>{
          item.setAttribute('disabled','true');
        });
      }  
      var priceGte = searchParams.get('price.gte');
      var priceLte = searchParams.get('price.lte');
      if(priceGte && priceLte) {
        if(!document.querySelector("#products .product-card-wrapper:last-child")) {
          createProductWrapper = document.createElement("div");
          createProductWrapper.classList.add('product-card-wrapper','temp');
          document.querySelector("#products").appendChild(createProductWrapper);
        }
        new_products.querySelectorAll("#products .product-card-wrapper[data-real-price]").forEach((item)=>{
          if(parseInt(item.dataset.realPrice) > parseInt(priceLte)) item.remove();
          if(parseInt(item.dataset.realPrice) < parseInt(priceGte)) item.remove();
        });
      }
      document.querySelector("#products .product-card-wrapper:last-child").insertAdjacentHTML("afterend", new_products.innerHTML);
      document.querySelector("#products .product-card-wrapper.loading").remove();
      var tempwrapper = document.querySelector("#products .product-card-wrapper.temp");
      if(tempwrapper) tempwrapper.remove();
    });
  }
});

var products_grid = document.querySelector('.collection-product-grid');
var cart_offcanvas = document.querySelector('#cart-offcanvas');
var only_colors = products_grid.dataset.onlyColors;
products_grid.addEventListener('click', (e) => {
  if(e.target.classList.contains('add-to-cart')){
    e.preventDefault();
    add_to_cart(e);
  } else if(e.target.classList.contains('product-color-link')){
    e.preventDefault();
    var productUrl = e.target.getAttribute('href');
    if(e.target.nodeName == 'IMG') productUrl = e.target.closest('a').getAttribute('href');
    fetch(productUrl)
    .then(function(response) {
      return response.text();
    })
    .then(function(response_body) {
      var response_body = new DOMParser().parseFromString(response_body, "text/html");
      var newCard = response_body.querySelector('#quick-add-card .product-card');
      var productCard = e.target.closest('.product-card');
      if(only_colors == "true"){
        newCard.querySelector('.product-colors:not(.only-colors)').classList.add('d-none');
        newCard.querySelector('.product-colors.only-colors').classList.remove('d-none');
      }
      newCard.classList.remove('d-none');
      productCard.innerHTML = newCard.innerHTML;
    });
  } else if(e.target.classList.contains('size-selector')) {
      var itemForm = e.target.closest('form');
      clearPreorderProperties(itemForm);
      var preorder_product = itemForm.querySelector('input[data-preorder-product]');
      if(preorder_product) {
        preorder_product.checked = true;
        var preorder_shipping_date = itemForm.querySelector('input[name="items[1][properties][Shipping Pre-order]"]');
        preorder_shipping_date.removeAttribute('disabled');
      }
      var preorder_property = itemForm.querySelector('input.shipping-preorder[data-variant-estimated-delivery="'+e.target.dataset.variantEstimatedDelivery+'"]');
      if(preorder_property) preorder_property.removeAttribute('disabled');
    }
});

function clearPreorderProperties(itemForm) {
  var preorder_product = itemForm.querySelector('input[data-preorder-product]');
  if(preorder_product) {
    preorder_product.checked = false;
    var preorder_shipping_date = itemForm.querySelector('input[name="items[1][properties][Shipping Pre-order]"]:not(disabled)');
    preorder_shipping_date.setAttribute('disabled','true');
  }
  var preorder_properties = itemForm.querySelectorAll('input.shipping-preorder[data-variant-estimated-delivery]');
  preorder_properties.forEach((item)=>{
    item.setAttribute('disabled','true');
  });
}

function add_to_cart(e) {
  var product_form = e.target.closest('form');
  product_form.classList.add('loading');
  var formData = new FormData(product_form);
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    body: formData
  })
  .then(response => {
    product_form.classList.remove('loading');
    var cart_offcanvasB = new bootstrap.Offcanvas(cart_offcanvas);
    cart_offcanvasB.show();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

var urlParams = new URLSearchParams(window.location.search);
var orderParam = urlParams.get('orderP');

if(orderParam) {
    orderParam = orderParam.toLowerCase().split('|');
    var orderParamLength = orderParam.length;

    var products = document.querySelectorAll('section div.collection-product-grid .product-card-wrapper');
    products.forEach((item) => {
        var productTitle = item.dataset.productTitle;
        if(!productTitle) return false;
        productTitle = productTitle.trim().replace(/(\r\n|\n|\r)/gm, " ").toLowerCase();
        var orderIndex = -1;
        orderParam.forEach((param,index) => {
            if(productTitle.indexOf(param)>-1) orderIndex = index;
        });
        if(orderIndex >= 0) item.style.order = orderIndex-orderParamLength;
    });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-search"] && !window.DesignMode) return;
  try {
    
var collection_grid = document.querySelector('.collection-grid');
var price_slider = collection_grid.querySelector('#price-slider');
var collection_grid_section_id = collection_grid.dataset.sectionId;
 
if(price_slider) price_slider_init(price_slider);
function price_slider_init(price_slider) {
  var price_slider_start = parseInt(price_slider.dataset.start);
  var price_slider_end = parseInt(price_slider.dataset.end);
  var searchParams = new URLSearchParams(window.location.search);
  var priceGte = searchParams.get('price.gte');
  var priceLte = searchParams.get('price.lte');
  if(priceGte) price_slider_start = parseInt(priceGte);
  if(priceLte) price_slider_end = parseInt(priceLte);
  noUiSlider.create(price_slider, {
    start: [price_slider_start, price_slider_end],
    connect: true,
    range: {
      'min': 0,
      'max': parseInt(price_slider.dataset.max)
    },
    tooltips: [
      { to: function(value) { return price_slider.dataset.currencySymbol + String(value).split('.')[0]; } },
      { to: function(value) { return price_slider.dataset.currencySymbol + String(value).split('.')[0]; } }
    ],
  }).on('change',function(e){
    var selected_price_start = e[0];
    var selected_price_end = e[1];
    searchParams.set("price.gte", selected_price_start);
    searchParams.set("price.lte", selected_price_end);
    var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + searchParams.toString();
    window.history.pushState({prevPath: window.location.pathname, path: newurl}, '', newurl);
  });
}

var filters_sort = collection_grid.querySelector('#filters-sort-search');
filters_sort.addEventListener('click', (e) => {
  var searchParams = new URLSearchParams(window.location.search);  
  if(e.target.nodeName == 'A') {
    if(e.target.classList.contains('reload-page')) return false; 
    e.preventDefault();
    var newurl = e.target.href;
    if(newurl.indexOf('apparel')<0) {
      if(e.target.dataset.withFilters != null) {
        searchParams.set("filter.v.availability","1");
        newurl = newurl + '?' + searchParams.toString()
      } else {
        if(newurl.indexOf('filter.v.availability') > 0) {
         
        } else {
          if(newurl.indexOf('?') > 0) newurl = newurl + '&filter.v.availability=1';
          else newurl = newurl + '?filter.v.availability=1';
          newurl = newurl
        }
      }
    }
    window.history.pushState({prevPath: window.location.pathname, path: e.target.href}, '', newurl);
  } else if(e.target.classList.contains('sort-item')) {
    if(e.target.nodeName == 'INPUT') searchParams.set("sort_by", e.target.parentNode.dataset.sortValue);
    else searchParams.set("sort_by", e.target.dataset.sortValue);
    var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + searchParams.toString();
    window.history.pushState({prevPath: window.location.pathname, path: newurl}, '', newurl);
  }
});
  
var oldPushState = history.pushState;
history.pushState = function pushState() {
    var ret = oldPushState.apply(this, arguments);
    window.dispatchEvent(new Event('pushstate'));
    window.dispatchEvent(new Event('locationchange'));
    return ret;
};

window.addEventListener('popstate', () => {
    window.dispatchEvent(new Event('locationchange'));
});

var currentPage = 1;

function loadingAnimation(animation_state) {
  var loading = document.querySelector('section#shopify-section-'+collection_grid_section_id+' .loading');
  if(animation_state == true) {
    loading.classList.remove('d-none');
    loading.classList.add('d-block');
  } else {
    loading.classList.add('d-none');
    loading.classList.remove('d-block');
  }
}

var compare_products = document.querySelector('section.compare-products');
function changeCompareProducts() {
  if(compare_products) {
    var section_id = compare_products.getAttribute('id').replace('shopify-section-','');
    var searchParams = new URLSearchParams(window.location.search);
    searchParams.set("section_id", section_id);
    var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + searchParams.toString();
    fetch(newurl)
    .then(function(response) {
      return response.text();
    })
    .then(function(response_body) {
      var response_body = new DOMParser().parseFromString(response_body, "text/html");
      compare_products.innerHTML = response_body.querySelector('section').innerHTML;
    });
  }
}

window.addEventListener('locationchange', function (e) {
  if(window.location.hash) return false;
  loadingAnimation(true);
  currentPage = 1;
  var searchParams = new URLSearchParams(window.location.search);
  searchParams.set("section_id", collection_grid_section_id);
  var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + searchParams.toString();
  if(window.history.state != null){
    if(window.history.state.prevPath != window.location.pathname) {
      changeCompareProducts();
    }
  }
  fetch(newurl)
  .then(function(response) {
    return response.text();
  })
  .then(function(response_body) {
    var response_body = new DOMParser().parseFromString(response_body, "text/html");
    document.querySelectorAll('#filters-offcanvas .filter').forEach((item)=>{
      var filter_item = response_body.querySelector("#filters-offcanvas .filter#"+item.getAttribute('id'));
      if(filter_item && item.classList.contains('show')) {
        filter_item.closest('.accordion-item').querySelector('h2 button').classList.remove('collapsed');
        filter_item.classList.add('show');
      }
    });
    document.querySelector("#filters-offcanvas .offcanvas-body").replaceWith(response_body.querySelector("#filters-offcanvas .offcanvas-body"));
    var new_price_slider = document.querySelector('#price-slider');
    if(new_price_slider) price_slider_init(new_price_slider);
    var priceGte = searchParams.get('price.gte');
    var priceLte = searchParams.get('price.lte');
    if(priceGte && priceLte) {
      response_body.querySelectorAll("#products .product-card-wrapper[data-real-price]").forEach((item)=>{
        if(parseInt(item.dataset.realPrice) > parseInt(priceLte)) item.remove();
        if(parseInt(item.dataset.realPrice) < parseInt(priceGte)) item.remove();
      });
      document.querySelector("#filters-offcanvas .offcanvas-body #clear-all").classList.remove('d-none');
    }
    if(!document.querySelector('body').classList.contains('sd')) {
      response_body.querySelectorAll('input[name$="[_sd]"]').forEach((item)=>{
        item.setAttribute('disabled','true');
      });
    } 
    document.querySelector("#products").replaceWith(response_body.querySelector("#products"));
    document.querySelector("#breadcrumb").replaceWith(response_body.querySelector("#breadcrumb"));
    var active_sticky_menu = document.querySelector('#sticky-menu .active');
    if(active_sticky_menu) active_sticky_menu.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "start" });
    document.querySelector("#product-count").replaceWith(response_body.querySelector("#product-count"));
    collection_grid.scrollIntoView();
    loadingAnimation(false); 
  });
});

window.addEventListener("scroll", (event) => {
  var next_products_wrapper = document.querySelector('#next-products');
  if(!next_products_wrapper) return false;
  var top = document.querySelector('#next-products').getBoundingClientRect().top;
  var left = document.querySelector('#next-products').getBoundingClientRect().left;
  var bottom = document.querySelector('#next-products').getBoundingClientRect().bottom;
  var right = document.querySelector('#next-products').getBoundingClientRect().right;
  var innerHeight = window.innerHeight;
  var innerWidth = window.innerWidth;
  var isVisible = ((top > 0 && top < innerHeight) || (bottom > 0 && bottom < innerHeight)) && ((left > 0 && left < innerWidth) || (right > 0 && right < innerWidth));
  if(isVisible) {
    currentPage++;
    var searchParams = new URLSearchParams(window.location.search);
    document.querySelector("#next-products").remove();
    searchParams.set("page", currentPage);
    searchParams.set("section_id", collection_grid_section_id);
    var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + searchParams.toString();
    
    fetch(newurl)
    .then(function(response) {
      return response.text();
    })
    .then(function(response_body) {
      var response_body = new DOMParser().parseFromString(response_body, "text/html");
      var new_products = response_body.querySelector('#products');
      if(!document.querySelector('body').classList.contains('sd')) {
        new_products.querySelectorAll('input[name$="[_sd]"]').forEach((item)=>{
          item.setAttribute('disabled','true');
        });
      }  
      var priceGte = searchParams.get('price.gte');
      var priceLte = searchParams.get('price.lte');
      if(priceGte && priceLte) {
        if(!document.querySelector("#products .product-card-wrapper:last-child")) {
          createProductWrapper = document.createElement("div");
          createProductWrapper.classList.add('product-card-wrapper','temp');
          document.querySelector("#products").appendChild(createProductWrapper);
        }
        new_products.querySelectorAll("#products .product-card-wrapper[data-real-price]").forEach((item)=>{
          if(parseInt(item.dataset.realPrice) > parseInt(priceLte)) item.remove();
          if(parseInt(item.dataset.realPrice) < parseInt(priceGte)) item.remove();
        });
      }
      document.querySelector("#products .product-card-wrapper:last-child").insertAdjacentHTML("afterend", new_products.innerHTML);
      var tempwrapper = document.querySelector("#products .product-card-wrapper.temp");
      if(tempwrapper) tempwrapper.remove();
    });
  }
});

var products_grid = document.querySelector('.collection-grid');
var cart_offcanvas = new bootstrap.Offcanvas('#cart-offcanvas');
var only_colors = products_grid.dataset.onlyColors;
products_grid.addEventListener('click', (e) => {
  if(e.target.classList.contains('add-to-cart')){
    e.preventDefault();
    add_to_cart(e);
  } else if(e.target.classList.contains('product-color-link')){
    e.preventDefault();
    var productUrl = e.target.getAttribute('href');
    if(e.target.nodeName == 'IMG') productUrl = e.target.closest('a').getAttribute('href');
    fetch(productUrl)
    .then(function(response) {
      return response.text();
    })
    .then(function(response_body) {
      var response_body = new DOMParser().parseFromString(response_body, "text/html");
      var newCard = response_body.querySelector('#quick-add-card .product-card');
      // if(!document.querySelector('body').classList.contains('sd')) {
      //   newCard.querySelectorAll('input[name$="[_sd]"]').forEach((item)=>{
      //     item.setAttribute('disabled','true');
      //   });
      // }
      var productCard = e.target.closest('.product-card');
      if(only_colors == "true"){
        newCard.querySelector('.product-colors:not(.only-colors)').classList.add('d-none');
        newCard.querySelector('.product-colors.only-colors').classList.remove('d-none');
      }
      newCard.classList.remove('d-none');
      productCard.innerHTML = newCard.innerHTML;
    });
  } else if(e.target.classList.contains('size-selector')) {
      var itemForm = e.target.closest('form');
      clearPreorderProperties(itemForm);
      var preorder_product = itemForm.querySelector('input[data-preorder-product]');
      if(preorder_product) {
        preorder_product.checked = true;
        var preorder_shipping_date = itemForm.querySelector('input[name="items[1][properties][Shipping Pre-order]"]');
        preorder_shipping_date.removeAttribute('disabled');
      }
      var preorder_property = itemForm.querySelector('input.shipping-preorder[data-variant-estimated-delivery="'+e.target.dataset.variantEstimatedDelivery+'"]');
      if(preorder_property) preorder_property.removeAttribute('disabled');
    }
});

function clearPreorderProperties(itemForm) {
  var preorder_product = itemForm.querySelector('input[data-preorder-product]');
  if(preorder_product) {
    preorder_product.checked = false;
    var preorder_shipping_date = itemForm.querySelector('input[name="items[1][properties][Shipping Pre-order]"]:not(disabled)');
    preorder_shipping_date.setAttribute('disabled','true');
  }
  var preorder_properties = itemForm.querySelectorAll('input.shipping-preorder[data-variant-estimated-delivery]');
  preorder_properties.forEach((item)=>{
    item.setAttribute('disabled','true');
  });
}

function add_to_cart(e) {
  var product_form = e.target.closest('form');
  product_form.classList.add('loading');
  var formData = new FormData(product_form);
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    body: formData
  })
  .then(response => {
    product_form.classList.remove('loading');
    product_form.reset();
    cart_offcanvas._element.classList.add('load-the-cart');
    cart_offcanvas.show();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

var urlParams = new URLSearchParams(window.location.search);
var orderParam = urlParams.get('orderP');

if(orderParam) {
    orderParam = orderParam.toLowerCase().split('|');
    var orderParamLength = orderParam.length;

    var products = document.querySelectorAll('section div.collection-grid .product-card-wrapper');
    products.forEach((item) => {
        var productTitle = item.dataset.productTitle;
        if(!productTitle) return false;
        productTitle = productTitle.trim().replace(/(\r\n|\n|\r)/gm, " ").toLowerCase();
        var orderIndex = -1;
        orderParam.forEach((param,index) => {
            if(productTitle.indexOf(param)>-1) orderIndex = index;
        });
        if(orderIndex >= 0) item.style.order = orderIndex-orderParamLength;
    });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown"] && !window.DesignMode) return;
  try {
    
function countdown(cdown) {
  var repeatHour = parseInt(cdown.dataset.repeatHour);
  
  var now = new Date();
  var maxTime = new Date(cdown.dataset.countdown+cdown.dataset.countdownTimezone);
  var hour = maxTime.getHours();
  var minute = maxTime.getMinutes();
  var second = maxTime.getSeconds();

  if (now > maxTime && repeatHour > 0) {
    var extraDay = 0;
    var extraHour = 0;
    if(repeatHour > 24) {
      extraDay = Math.floor(repeatHour / 24);
      var extraFullDaysHours = extraDay * 24;
      if(repeatHour > extraFullDaysHours) extraHour = repeatHour - extraFullDaysHours;
    } else extraHour = repeatHour;

    maxTime = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate() + extraDay,
      hour + extraHour,
      minute,
      second,
    );
  }

  var countDownDate = maxTime.getTime();
  var timeleft = countDownDate - new Date().getTime();
  if(timeleft > 0) {
    var days = Math.floor(timeleft / (1000 * 60 * 60 * 24));
    var hours = Math.floor((timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    if(cdown.dataset.showDay == 'false') hours = (days * 24) + hours;
    var minutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((timeleft % (1000 * 60)) / 1000);

    cdown.querySelector('.hours').style.setProperty('--percentage', Math.round((hours*100)/24));
    if(hours<10) hours = '0' + hours;
    cdown.querySelector('.days').style.setProperty('--percentage', Math.round((days*100)/30));
    if(days<10) days = '0' + days;
    cdown.querySelector('.minutes').style.setProperty('--percentage', Math.round((minutes*100)/60));
    if(minutes<10) minutes = '0' + minutes;
    cdown.querySelector('.seconds').style.setProperty('--percentage', Math.round((seconds*100)/60));
    if(seconds<10) seconds = '0' + seconds;
  
    cdown.querySelector('.days span').innerHTML = days;
    cdown.querySelector('.days').style.setProperty('--percentage', 10);
    cdown.querySelector('.hours span').innerHTML = hours;
    cdown.querySelector('.minutes span').innerHTML = minutes;
    cdown.querySelector('.seconds span').innerHTML = seconds;
  
    var cdownId = cdown.getAttribute('id');
    try {
      eval('SCDTimer' + cdownId );
    } catch (e) {
      eval('SCDTimer' + cdownId + '=setInterval(countdown, 1000, cdown);');
    }
  }
}

var countdowns =  document.querySelectorAll('section.countdown div[data-countdown]');
countdowns.forEach((item)=>{
  countdown(item);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["crowdfunding-bar"] && !window.DesignMode) return;
  try {
    
var batches = document.querySelectorAll('strong[data-batch-duration]');
var now = new Date();
var duration = 0;
var batch_enabled = false;
batches.forEach((item)=>{
  duration = parseInt(item.dataset.batchDuration) + duration;
  var start_date = item.dataset.batchStartDate;
  var start_date_timezone = item.dataset.batchTimeZone;
  var maxTime = new Date(start_date+start_date_timezone);
  maxTime = new Date(
    maxTime.getFullYear(),
    maxTime.getMonth(),
    maxTime.getDate() + duration,
    maxTime.getHours(),
    maxTime.getMinutes(),
    maxTime.getSeconds()
  );
  if(maxTime > now && batch_enabled == false) {
    countdown(item, maxTime);
    batch_enabled = true;
  }
});

function countdown(item, maxTime) {
  var countDownDate = maxTime.getTime();
  var timeleft = countDownDate - new Date().getTime();
  if(timeleft > 0) {
    var days = Math.floor(timeleft / (1000 * 60 * 60 * 24));
    var hours = Math.floor((timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((timeleft % (1000 * 60)) / 1000);
  
    if(hours<10) hours = '0' + hours;
    // if(days<10) days = '0' + days;
    if(minutes<10) minutes = '0' + minutes;
    if(seconds<10) seconds = '0' + seconds;
  
    item.innerHTML = days + 'd ' + hours + ':' + minutes + ":" + seconds + " left";
  
    var cdownId = item.getAttribute('id');
    try {
      eval('CDTimer' + cdownId );
    } catch (e) {
      eval('CDTimer' + cdownId + '=setInterval(countdown, 1000, item, maxTime);');
    }
    if(item.closest('.d-none')) item.closest('.d-none').classList.remove('d-none');
  }
}
var crowdfunding_progress = document.querySelector('.crowdfunding-progress[data-url-to-load]');
if(crowdfunding_progress) {
  var url_to_load = crowdfunding_progress.dataset.urlToLoad;
  fetch(url_to_load)
  .then(function(response) {
    return response.text();
  })
  .then(function(response_body) {
    var response_body = new DOMParser().parseFromString(response_body, "text/html");
    crowdfunding_progress.querySelector('.progress').innerHTML = response_body.querySelector('.crowdfunding-progress .progress').innerHTML;
    crowdfunding_progress.querySelector('.goal-achived').innerHTML = response_body.querySelector('.crowdfunding-progress .goal-achived').innerHTML.replaceAll('€','$');
    crowdfunding_progress.querySelector('.backers').innerHTML = response_body.querySelector('.crowdfunding-progress .backers').innerHTML;
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["details"] && !window.DesignMode) return;
  try {
    
var detailsModals = document.querySelectorAll('.details-modal');
detailsModals.forEach((item)=>{
  item.addEventListener('show.bs.modal', event => {
    item.querySelector('.carousel-item.active').classList.remove('active');
    item.querySelector('.carousel-item[data-detail-number="'+event.relatedTarget.dataset.detailNumber+'"]').classList.add('active');
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["discount-apply-to-cart"] && !window.DesignMode) return;
  try {
    
var discounts = document.querySelectorAll('.discount-apply-to-cart');
discounts.forEach((item)=>{
  fetch('/discount/'+item.dataset.discountCode, {
    method: "get" 
  }).then(response => {
    
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grid"] && !window.DesignMode) return;
  try {
    
var youtubeModals = document.querySelectorAll('.youtube-modal');
youtubeModals.forEach((item)=>{
  item.addEventListener('show.bs.modal', event => {
    var youtubeURL = event.relatedTarget.dataset.youtubeVideo;
    if(youtubeURL.includes('?')) youtubeURL = youtubeURL + '&autoplay=1&rel=0';
    else youtubeURL = youtubeURL + '?autoplay=1&rel=0';
    item.querySelector('iframe').setAttribute('src',youtubeURL);
  });
  item.addEventListener('hide.bs.modal', event => {
    item.querySelector('iframe').setAttribute('src','');
  });
});

var copyTextButton = document.querySelector("button#copyTextButton");
if(copyTextButton) {
  copyTextButton.onclick = function(){
    var copyText = copyTextButton.getAttribute("data-text-to-copy");
    var copiedText = copyTextButton.getAttribute("data-copied-text");
    navigator.clipboard.writeText(copyText);
    if(copiedText) copyTextButton.innerHTML = copiedText;
  }
}

var product_forms = document.querySelectorAll("div.grid_product form.shopify-product-form");
var cart_offcanvas = document.querySelector('#cart-offcanvas');
if(cart_offcanvas) {
  var cart_offcanvas_B = new bootstrap.Offcanvas('#cart-offcanvas');
  product_forms.forEach((item)=>{
    item.onsubmit = function (e) {
      e.preventDefault();
      item.classList.add('loading');
      var formData = new FormData(item);
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => {
        item.classList.remove('loading');
        cart_offcanvas_B._element.classList.add('load-the-cart');
        cart_offcanvas_B.show();
      })
      .catch((error) => {
        console.error('Error:', error);
      }); 
    }
  });
}

var videoModals = document.querySelectorAll('.grid-video-modal');
videoModals.forEach((item)=>{
  var video_in_modal = item.querySelector('video');
  item.addEventListener('show.bs.modal', event => {
    video_in_modal.play();
  });
  item.addEventListener('hide.bs.modal', event => {
    video_in_modal.pause();
    video_in_modal.currentTime = 0;
  });
});
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gsap-animations"] && !window.DesignMode) return;
  try {
    
var gsap_animations = document.querySelectorAll("section.gsap-animation");
var screenWidth = window.matchMedia("(max-width: 575.98px)");
gsap_animations.forEach((item)=>{
  if(item.classList.contains('parallax')) {
    var parallaxTimeline = gsap.timeline({ paused: true });

    var background = item.querySelector('.background');
    if(background.dataset.animationScale < 1) {
      var backgroundAnimationDuration = parseFloat(background.dataset.animationDuration);
      parallaxTimeline.from(background, {scale: background.dataset.animationScale, duration: backgroundAnimationDuration/2});
      parallaxTimeline.to(background, {scale: 1, duration: backgroundAnimationDuration/2});
    }
    
    item.querySelectorAll('.parallax-content').forEach((content_item) => {
      var itemKeyframes = {};
      itemKeyframes["0%"] = { x: content_item.dataset.appearingX, y: content_item.dataset.appearingY, opacity: content_item.dataset.appearingOpacity };
      itemKeyframes["30%"] = { x: 0, y: 0, opacity: 1 };
      itemKeyframes["70%"] = { x: 0, y: 0, opacity: 1 };
      itemKeyframes["100%"] = { x: content_item.dataset.disappearingX, y: content_item.dataset.disappearingY, opacity: content_item.dataset.disappearingOpacity };
      parallaxTimeline.to(content_item, {keyframes: itemKeyframes, duration: content_item.dataset.animationDuration});
    });
  
    var animationSpeed = parseInt(background.dataset.animationSpeedDesktop);
    if(screenWidth.matches == true) animationSpeed = parseInt(background.dataset.animationSpeedMobile);
    
    var scrollTriggerParallax = ScrollTrigger.create({
      trigger: item,
      start: "top top",
      pin: true,
      scrub: 1,
      animation: parallaxTimeline,
      end: "+=" + (window.innerHeight * animationSpeed)
    });
  } else if(item.classList.contains('scroll-sequence-canvas-container')) {
    var canvases = document.querySelectorAll("canvas.scroll-sequence-canvas");
    canvases.forEach((item)=>{
      var loadedFrame = 50;
      var currentFrameDesktop = item.dataset.currentFrameDesktop;
      if(item.dataset.currentFrameMobile) var currentFrameMobile = item.dataset.currentFrameMobile;
      var frameFolderDesktop = currentFrameDesktop.split('_000.jpg')[0];
      var frameFolderMobile = currentFrameMobile.split('_000.jpg')[0];
      var context = item.getContext("2d");

      var second_color_canvas = item.nextElementSibling;
      if(second_color_canvas) var second_color_canvas_enabled = second_color_canvas.classList.contains('scroll-sequence-canvas-second');
      if(second_color_canvas_enabled) {
        var currentFrameSecondColorDesktop = second_color_canvas.dataset.currentFrameDesktop;
        if(second_color_canvas.dataset.currentFrameMobile) var currentFrameSecondColorMobile = second_color_canvas.dataset.currentFrameMobile;
        var frameFolderSecondColorDesktop = currentFrameSecondColorDesktop.split('_000.jpg')[0];
        var frameFolderSecondColorMobile = currentFrameSecondColorMobile.split('_000.jpg')[0];
        var context_second_color = second_color_canvas.getContext("2d");
      }
    
      var scrollSequenceSection = item.closest('section.scroll-sequence-canvas-container');
      scrollSequenceSection.style.setProperty('--background-scroll', 'url(' + currentFrameDesktop + ')');
      scrollSequenceSection.style.setProperty('--background-scroll-mobile', 'url(' + currentFrameMobile + ')');
    
      var animationSpeed = parseInt(item.dataset.animationSpeedDesktop);
      if(screenWidth.matches == true) {
        animationSpeed = parseInt(item.dataset.animationSpeedMobile);
        item.width = 1080;
        item.height = 1920;
        if(second_color_canvas_enabled) {
          second_color_canvas.width = 1080;
          second_color_canvas.height = 1920;
        }
      } else {
        item.width = 1920;
        item.height = 1080;
        if(second_color_canvas_enabled) {
          second_color_canvas.width = 1920;
          second_color_canvas.height = 1080;
        }
      }
      
      var frameCount = parseInt(item.dataset.frameCount);
      var currentFrameDesktop = (index) => frameFolderDesktop + '_' + (index + 1).toString().padStart(3, "0") + '.jpg';
      var currentFrameMobile = (index) => frameFolderMobile + '_' + (index + 1).toString().padStart(3, "0") + '.jpg';

      if(second_color_canvas_enabled) {
        var currentFrameSecondColorDesktop = (index) => frameFolderSecondColorDesktop + '_' + (index + 1).toString().padStart(3, "0") + '.jpg';
        var currentFrameSecondColorMobile = (index) => frameFolderSecondColorMobile + '_' + (index + 1).toString().padStart(3, "0") + '.jpg';
      }
      
      var images = [];
      var sequence_scrolling = {
        frame: 0
      };

      if(second_color_canvas_enabled) var images_second_color = [];
      
      for (var i = 0; i < loadedFrame; i++) {
        var img = new Image();
        if(second_color_canvas_enabled) var img_second_color = new Image();
        if(screenWidth.matches == true) {
          img.src = currentFrameMobile(i);
          images.push(img);
          if(second_color_canvas_enabled) {
            img_second_color.src = currentFrameSecondColorMobile(i);
            images_second_color.push(img_second_color);
          }
        } else {
          img.src = currentFrameDesktop(i);
          images.push(img);
          if(second_color_canvas_enabled) {
            img_second_color.src = currentFrameSecondColorDesktop(i);
            images_second_color.push(img_second_color);
          }
        }
      }
      
      var scrollTimeline = gsap.timeline({ paused: true });
    
      scrollTimeline.to(sequence_scrolling, {
        frame: frameCount - 1,
        snap: "frame",
        ease: "steps(" + frameCount + ")",
        onUpdate: scrollSequenceRender,
        onUpdateParams: [context, images, context_second_color, second_color_canvas_enabled, images_second_color, sequence_scrolling, screenWidth, frameCount, currentFrameDesktop, currentFrameSecondColorDesktop, currentFrameMobile, currentFrameSecondColorMobile, loadedFrame]
      });
      
      scrollSequenceSection.querySelectorAll('.scroll-sequence-content').forEach((content_item) => {
        var itemKeyframes = {};
        if(content_item.dataset.appearingStart!="0") itemKeyframes["0%"] = { opacity: 0 };
        itemKeyframes[content_item.dataset.appearingStart+"%"] = { x: content_item.dataset.appearingX, y: content_item.dataset.appearingY, opacity: content_item.dataset.appearingOpacity };
        itemKeyframes[content_item.dataset.appearingEnd+"%"] = { x: 0, y: 0, opacity: 1 };
        itemKeyframes[content_item.dataset.disappearingStart+"%"] = { x: 0, y: 0, opacity: 1 };
        itemKeyframes[content_item.dataset.disappearingEnd+"%"] = { x: content_item.dataset.disappearingX, y: content_item.dataset.disappearingY, opacity: content_item.dataset.disappearingOpacity };
        scrollTimeline.to(content_item, {keyframes: itemKeyframes, ease: "steps(" + frameCount + ")"}, 0);
      });
    
      var scrollTiggerSequence = ScrollTrigger.create({
        trigger: scrollSequenceSection,
        start: "top top",
        pin: true,
        scrub: 1,
        animation: scrollTimeline,
        end: "+=" + (window.innerHeight * animationSpeed)
      });
    });
  } else if(item.classList.contains('slider')) {
    var animation_active = item.querySelector('.background').dataset.gsapAnimation;
    if(animation_active == 'false') return false;
    item.classList.remove('position-relative');
    item.classList.add('overflow-y-hidden');
    var sliderTimeline = gsap.timeline({ paused: true });

    var slider_scrolling = {
      frame: 0
    };
    
    var slider = item.querySelector('.slider-carousel');
    var sliderSwiper = slider.querySelector('.swiper-wrapper');
    var slidesVisible = 1;
    if(screenWidth.matches == true) slidesVisible = (sliderSwiper.offsetWidth) * parseInt(slider.dataset.slidesCount-1);
    else slidesVisible = (sliderSwiper.offsetWidth/3) * parseInt(slider.dataset.slidesCount-3);
    var frameCount = slidesVisible;

    var scrollTiggerSlider = ScrollTrigger.create({
        trigger: item,
        start: "top top",
        pin: true,
        scrub: 1,
        animation: sliderTimeline,
        end: "+=" + (window.innerHeight * 4),
        onRefresh: () => {
          var terra_path = document.querySelector('.terra-animation');
          if(terra_path) {
            var last_module = document.querySelector('#last-module');
            var last_module_section = last_module.closest('section');
          
            var bodyRect = document.body.getBoundingClientRect();
            var elemRect = last_module_section.getBoundingClientRect();
            var offset = elemRect.top - bodyRect.top - last_module.offsetHeight;

            var scaleRatio = offset/8000;
            terra_path.setAttribute('style', '--animation-scale: '+scaleRatio);
            terra_path.dataset.offsetY = offset;

            terra_path.classList.add('path-ready');
          }
        }
    });
    
    sliderTimeline.to(slider_scrolling, {
        frame: frameCount - 1,
        snap: "frame",
        ease: "steps(" + frameCount + ")",
        onUpdate: scrollSliderRender,
        onUpdateParams: [sliderSwiper, scrollTiggerSlider, slider_scrolling]
      });
  }
  
});

function scrollSliderRender(slider, triggerScroll, slider_scrolling) {
  var is_scrolling = triggerScroll.scroller.ScrollTrigger.isScrolling();
  var scrolling_direction = triggerScroll.animation.scrollTrigger.direction;
  if(is_scrolling == true) {
    frame = (parseInt(slider_scrolling.frame) * -1) + 'px';
    slider.style.transform = "translate3d("+ frame +", 0px, 0px)";
  }
}
  
function scrollSequenceRender(canvasContext, images, canvasSecondContext, second_color_canvas_enabled, images_second_color, sequence_scrolling, screenWidth, frameCount, currentFrameDesktop, currentFrameSecondColorDesktop, currentFrameMobile, currentFrameSecondColorMobile, loadedFrame) {
  var canvasWidth = 1920;
  var canvasHeight = 1080;
  if(screenWidth.matches == true) {
    canvasWidth = 1080;
    canvasHeight = 1920;
  }
  if(images.length != frameCount) {
    for (var i = loadedFrame; i < frameCount; i++) {
      var img = new Image();
      if(second_color_canvas_enabled) var img_second_color = new Image();
      if(screenWidth.matches == true) {
        img.src = currentFrameMobile(i);
        images.push(img);
        if(second_color_canvas_enabled) {
          img_second_color.src = currentFrameSecondColorMobile(i);
          images_second_color.push(img_second_color);
        }
      } else {
        img.src = currentFrameDesktop(i);
        images.push(img);
        if(second_color_canvas_enabled) {
          img_second_color.src = currentFrameSecondColorDesktop(i);
          images_second_color.push(img_second_color);
        }
      }
    }
  }
  canvasContext.clearRect(0, 0, canvasWidth, canvasHeight);
  var image = images[sequence_scrolling.frame];
  canvasContext.drawImage(image, canvasWidth / 2 - image.width / 2, canvasHeight / 2 - image.height / 2);
  if(second_color_canvas_enabled) {
    canvasSecondContext.clearRect(0, 0, canvasWidth, canvasHeight);
    var image_second_color = images_second_color[sequence_scrolling.frame];
    canvasSecondContext.drawImage(image_second_color, canvasWidth / 2 - image_second_color.width / 2, canvasHeight / 2 - image_second_color.height / 2);
  }
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

var cameFromAd = getCookie('camefromad_sd_summer');
if(cameFromAd == 'yes') {
  var bodyElement = document.querySelector('body');
    fetch('/discount/SUMMERDEALS', {
      method: "get"
    }).then(response => {
    });
  bodyElement.classList.add('sd');
}

document.addEventListener("DOMContentLoaded", function(){
  var header_element = document.querySelector('header.sticky-top'); 
  var acc_bar_sticky = document.querySelector('section.announcement-bar.sticky-top');
  if(acc_bar_sticky) document.documentElement.style.setProperty('--acc-sticky', '55px'); 
  else document.documentElement.style.setProperty('--acc-sticky', '0px'); 
  if(header_element){
    var last_scroll_top = 0;
    window.addEventListener('scroll', function() {
      var scroll_top = window.scrollY;
      if(scroll_top < last_scroll_top) {
        header_element.classList.remove('scrolled-down');
        header_element.classList.add('scrolled-up');
        document.documentElement.style.setProperty('--sticky-top-desktop', 'var(--header-height)');
        document.documentElement.style.setProperty('--sticky-top-mobile', 'var(--header-height-mobile)');
      }
      else {
        header_element.classList.remove('scrolled-up');
        header_element.classList.add('scrolled-down');
        document.documentElement.style.setProperty('--sticky-top-desktop', '0px');
        document.documentElement.style.setProperty('--sticky-top-mobile', '0px');
      }
      if(scroll_top <= 0) {
        header_element.classList.add('on-top');
        header_element.classList.remove('scrolled-down');
        document.documentElement.style.setProperty('--sticky-top-desktop', '0px');
        document.documentElement.style.setProperty('--sticky-top-mobile', '0px');
      } else {
        header_element.classList.remove('on-top');
      }
      last_scroll_top = scroll_top;
    }); 
  }
}); 
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["map-store-locator"] && !window.DesignMode) return;
  try {
    
var tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
var tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-with-text-overlay"] && !window.DesignMode) return;
  try {
    
var copy_buttons = document.querySelectorAll(".promocode button[data-text-to-copy]");
if(copy_buttons) {
  copy_buttons.forEach((item)=>{
    var copyText = item.dataset.textToCopy;
    // fetch('/discount/'+copyText, {
    //   method: "get"
    // }).then(response => {
      
    // });
    item.onclick = function(){
      var copiedText = item.dataset.copiedText;
      navigator.clipboard.writeText(copyText);
      if(copiedText) item.querySelector('small').innerHTML = copiedText;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["menu"]) return;
  try {
    
var screenWidth = window.matchMedia("(max-width: 575.98px)");
if(screenWidth.matches == false) {
  var header_menu = document.querySelector('#shopify-section-menu');
  var main_menu_sublinks = header_menu.querySelectorAll('.menu-sub-link');
  var main_menu_offcanvas = header_menu.querySelector('#main-menu-offcanvas');
  main_menu_sublinks.forEach((item)=>{
    item.addEventListener("mouseover", (e) => {
      var targetOffcanvasID = e.target.getAttribute('data-offcanvas-id');
      var targetOffcanvas = header_menu.querySelector(targetOffcanvasID);
      hideAllSubmenus();
      if(targetOffcanvas && !targetOffcanvas.classList.contains('show')) {
        targetOffcanvas.classList.add('show');
        e.target.classList.add('hovered');
      }
      main_menu_offcanvas.classList.add('hide-main-banner');
    });
  });
  
  var allsubmenus = header_menu.querySelectorAll('.submenu-offcanvas');
  function hideAllSubmenus(){
    var hoveredA = header_menu.querySelector('a.hovered');
    if(hoveredA) hoveredA.classList.remove('hovered');
    allsubmenus.forEach((item)=>{
      item.classList.remove('show');
    })
  }
  
  main_menu_offcanvas.addEventListener('hide.bs.offcanvas', event => {
    hideAllSubmenus();
    main_menu_offcanvas.classList.remove('hide-main-banner');
    header_menu.classList.remove('menu-shown');
  });

  main_menu_offcanvas.addEventListener('show.bs.offcanvas', event => {
    header_menu.classList.add('menu-shown');
  });
} 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meta-events"]) return;
  try {
    
  window.addEventListener('load', function() {
    var metaEvents = document.querySelectorAll('.meta-event');
    metaEvents.forEach((item)=>{ 
      if(item.dataset.eventType="viewContent") { 
        if(typeof fbq == 'function') {
          fbq('track', 'ViewContent', { 
            content_ids: item.dataset.contentIds.split(',').map(Number),
            content_category: item.dataset.contentCategory,
            content_name: item.dataset.contentName,
            content_type: item.dataset.contentType,
            currency: item.dataset.currency, 
            value: item.dataset.productValue
          }); 
        }
      }
    }); 
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp"] && !window.DesignMode) return;
  try {
    
function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

var body_product_template = document.querySelector('body.template-product');
var product_forms = body_product_template.querySelectorAll("#product-info form.shopify-product-form");
selectYourSize(product_forms);

function selectYourSize(product_forms) {
  var selectedGender = getCookie('selected_gender');
  if(selectedGender != "") {
    product_forms.forEach((item)=>{
      var input_gender = item.querySelector('input[data-gender="'+selectedGender+'"]');
      if(input_gender) input_gender.checked = true;
    });
  }
  
  var selectedApparel = getCookie('selected_apparel');
  if(selectedApparel != "") {
    product_forms.forEach((item)=>{
      var input_selected_apparel = item.querySelector('input[data-selected-apparel-size="'+selectedApparel+'"]');
      if(input_selected_apparel) input_selected_apparel.checked = true;
    });
  }
  
  var selectedSneaker = getCookie('selected_sneaker');
  if(selectedSneaker != "") {
    product_forms.forEach((item)=>{
      var input_selected_sneaker = item.querySelector('input[data-selected-sneaker-size="'+selectedSneaker+'"]');
      if(input_selected_sneaker) input_selected_sneaker.checked = true;
    });
  }

  var radio_inputs = body_product_template.querySelectorAll('form.shopify-product-form input[type="radio"]');
  radio_inputs.forEach((item)=>{
    item.addEventListener('change', (event) => {
      if(item.dataset.selectedGender) setCookie('selected_gender',item.dataset.selectedGender,7);
      if(item.dataset.selectedSneakerSize) setCookie('selected_sneaker',item.dataset.selectedSneakerSize,7);
      if(item.dataset.selectedApparelSize) setCookie('selected_apparel',item.dataset.selectedApparelSize,7);
    });
  });
}

var estimated_delivery = body_product_template.querySelectorAll('span strong.estimated-delivery');
if(estimated_delivery.length > 0) calculateEstimatedDelivery(estimated_delivery, '');
var current_country = Shopify.country;
  
function calculateEstimatedDelivery(estimated_delivery_element, calculated_estimated_delivery) {
  if(calculated_estimated_delivery != '') {
    estimated_delivery_element.forEach((item)=>{
      item.innerHTML = calculated_estimated_delivery;
    });
  } else {
    ShipupETA.init({ publicApiKey: 'M7FgKbRMmERpYu3hE61Djw', estimationMode: 'range' }).fetchPredictions({
      destination: {
        country_code: current_country,
      }
    })
    .then(predictions => {
      var delivery_date = '';
      var safe_date = '';
      var date_format_options = { weekday: 'short', day: 'numeric', month: 'short' };
      if(predictions) {
        if(current_country == 'HK' || current_country == 'JP' || current_country == 'SG' || current_country == 'AU' || current_country == 'CA') {
          delivery_date = new Date(predictions[0].delivery_date);
          safe_date = new Date(predictions[0].safe_delivery_date);
        } else if(current_country == 'GB') {
          delivery_date = new Date(predictions[18].delivery_date);
          safe_date = new Date(predictions[18].safe_delivery_date);
        } else if(current_country == 'US') {
          delivery_date = new Date(predictions.bestEstimation.delivery_date);
          safe_date = new Date(predictions[11].safe_delivery_date);
        } else {
          delivery_date = new Date(predictions[5].delivery_date);
          safe_date = new Date(predictions[5].safe_delivery_date);
        }
      }
      estimated_delivery_calculation = delivery_date.toLocaleDateString("en-US", date_format_options) + ' - ' + safe_date.toLocaleDateString("en-US", date_format_options);
      setCookie('estimated_delivery', estimated_delivery_calculation, 1);
      estimated_delivery_element.forEach((item)=>{
        item.innerHTML = estimated_delivery_calculation;
      });
    })
    .catch(error => {
      console.error('Error', error);
    });
  }
}

var screenWidth = window.matchMedia("(max-width: 749px)");

var product_reviews_section = body_product_template.querySelector('#product-reviews');
var pdp_section = body_product_template.querySelector('div.section-pdp');
pdp_section.addEventListener('click', (e) => {
  if(e.target.classList.contains('product-color-link')){
    e.preventDefault();
    var productAnchor = e.target;
    if(e.target.nodeName == 'IMG') productAnchor = e.target.closest('a');
    if(e.target.nodeName == 'STRONG') productAnchor = e.target.closest('a');
    var productUrl = productAnchor.getAttribute('href');
    var productTitle = productAnchor.dataset.productTitle;
    // window.location.replace(productUrl); 
    history.replaceState({}, productTitle, productUrl);
    changePdP(productUrl);
  }
  if(e.target.classList.contains('product-reviews-button')) {
    if(!screenWidth.matches) product_reviews_section.scrollIntoView();
  }
});

var gallery_height = 0;
var pdp_gallery_section = pdp_section.querySelector('div.pdp-gallery-section');
var pdp_info_section = pdp_section.querySelector('div.pdp-info-section');
var floating_button_money = body_product_template.querySelector('.floating-sticky-menu .money');
function changePdP(url) {
  var section_id = pdp_section.getAttribute('id').replace('shopify-section-','');
  var newurl = url + '?section_id=' + section_id;
  fetch(newurl)
  .then(function(response) {
    return response.text();
  })
  .then(function(response_body) {
    var response_body = new DOMParser().parseFromString(response_body, "text/html");
    var ratings_html = pdp_info_section.querySelector('.ruk_rating_snippet');
    pdp_gallery_section.innerHTML = response_body.querySelector('div.pdp-gallery-section').innerHTML;
    pdp_info_section.innerHTML = response_body.querySelector('div.pdp-info-section').innerHTML;
    var new_ratings_html = pdp_info_section.querySelectorAll('.ruk_rating_snippet');
    new_ratings_html.forEach((item)=>{
      item.innerHTML = ratings_html.innerHTML;
    });
    var estimated_delivery = pdp_section.querySelectorAll('span strong.estimated-delivery');
    if(estimated_delivery.length > 0) calculateEstimatedDelivery(estimated_delivery, getCookie('estimated_delivery'));
    var product_forms = pdp_section.querySelectorAll('form.shopify-product-form');
    addToCartPdP(product_forms);
    selectYourSize(product_forms);
    var product_gallery = pdp_section.querySelector('#product-gallery');
    var product_gallery_thumbs = pdp_section.querySelector("#product-gallery-thumbs");
    var horizontal_scroll_galleries = pdp_section.querySelectorAll('.horizontal-scroll-gallery');
    gallery_initialize(product_gallery_thumbs, product_gallery, horizontal_scroll_galleries, gallery_height);
    // var productRecommendationsSection = document.querySelector('.related-products-carousel');
    // if(productRecommendationsSection) reloadRelatedProducts(productRecommendationsSection);
    if(screenWidth.matches == true) makeButtonDraggable(pdp_info_section.querySelector('#product-info'));
    if(floating_button_money) floating_button_money.innerHTML = response_body.querySelector('span.money').innerHTML;
  });
}

addToCartPdP(product_forms);

function addToCartPdP(product_forms) {
  var cart_offcanvas = new bootstrap.Offcanvas('#cart-offcanvas');
  var sizeSelectorOffcanvas = body_product_template.querySelector('#sizeSelectorOffcanvas');
  if(sizeSelectorOffcanvas) sizeSelectorOffcanvasB = new bootstrap.Offcanvas('#sizeSelectorOffcanvas');
  
  product_forms.forEach((item)=>{
    item.onsubmit = function (e) {
      e.preventDefault();
      item.classList.add('loading');
      var formData = new FormData(item);
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => {
        item.classList.remove('loading');
        if(sizeSelectorOffcanvas) sizeSelectorOffcanvasB.hide();
        cart_offcanvas._element.classList.add('load-the-cart');
        cart_offcanvas.show();
      })
      .catch((error) => {
        console.error('Error:', error);
      }); 
    } 
  });
}

// Gallery
var header = body_product_template.querySelector('header.section-header');
var screenWidth = window.matchMedia("(max-width: 749px)");

var product_gallery_thumbs = body_product_template.querySelector("#product-gallery-thumbs");
var product_gallery = body_product_template.querySelector('#product-gallery');
var horizontal_scroll_galleries = body_product_template.querySelectorAll('.horizontal-scroll-gallery');
var product_reviews = body_product_template.querySelector('#product-reviews');
var next_section = body_product_template.querySelector('section.shopify-section.grid');
gallery_initialize(product_gallery_thumbs, product_gallery, horizontal_scroll_galleries, 0);

function gallery_initialize(product_gallery_thumbs, product_gallery, horizontal_scroll_galleries, gallery_height) {
  if(product_gallery_thumbs) {
    if(screenWidth.matches == true) {
      var diffTouches = 0;
      var product_gallery_swiper = new Swiper(product_gallery, {
        direction: "horizontal",
        autoHeight: true,
        slidesPerView: 1,
        mousewheel: false,
        pagination: {
          el: ".swiper-pagination-product-gallery",
          dynamicBullets: true
        },
        on: {
          afterInit: function (swiper) {
            resizeDots(swiper);
          },
          touchEnd: function (swiper) {
            if(horizontal_scroll_galleries.length==0) {
              if(swiper.slides.length == (swiper.realIndex + 1) && swiper.touchesDirection == 'next' && diffTouches != swiper.touches.diff && screenWidth.matches == true) {
                openStickyContent();
              }
              diffTouches = swiper.touches.diff;
            }
          }
        }
      });
    } else {
      var product_gallery_thumbs_swiper = new Swiper(product_gallery_thumbs, {
        direction: "vertical",
        slidesPerView: "auto",
        autoHeight: true,
        freeMode: true,
        watchSlidesProgress: true,
        mousewheel: true
      });

      if(gallery_height != 0) {
        var product_gallery_swiper = new Swiper(product_gallery, {
          direction: "vertical",
          autoHeight: true,
          height: gallery_height,
          slidesPerView: 1,
          mousewheel: false,
          thumbs: {
            swiper: product_gallery_thumbs_swiper
          }
        });
      } else {
        var product_gallery_swiper = new Swiper(product_gallery, {
          direction: "vertical",
          autoHeight: true,
          slidesPerView: 1,
          mousewheel: false,
          thumbs: {
            swiper: product_gallery_thumbs_swiper
          }
        });
      }
      
    }
  } else {
    if(screenWidth.matches == true) {
      var diffTouches = 0;
      var product_gallery_swiper = new Swiper(product_gallery, {
        direction: "horizontal",
        autoHeight: true,
        slidesPerView: 1,
        mousewheel: false,
        pagination: {
          el: ".swiper-pagination-product-gallery",
          dynamicBullets: true
        },
        on: {
          afterInit: function (swiper) {
            resizeDots(swiper);
          },
          touchEnd: function (swiper) {
            if(horizontal_scroll_galleries.length==0) {
              if(swiper.slides.length == (swiper.realIndex + 1) && swiper.touchesDirection == 'next' && diffTouches != swiper.touches.diff && screenWidth.matches == true) {
                openStickyContent();
              }
              diffTouches = swiper.touches.diff;
            }
          }
        }
      });
    } else {
      var product_gallery_swiper = new Swiper(product_gallery, {
        direction: "vertical",
        autoHeight: true,
        slidesPerView: 1,
        mousewheel: false
      });
    }
  }
  
  horizontal_scroll_galleries.forEach((item)=>{
    var next_button = item.querySelector('.swiper-button-next');
    var prev_button = item.querySelector('.swiper-button-prev');
    var pagination = item.querySelector('.swiper-pagination');
    var horizontal_gallery_swiper = new Swiper(item, {
      slidesPerView: 1,
      autoHeight: true,
      loop: (screenWidth.matches !== true),
      navigation: {
        nextEl: next_button,
        prevEl: prev_button
      },
      pagination: {
        el: pagination,
        dynamicBullets: true
      }
    });
  });

  var indicator = new WheelIndicator({
    elem: product_gallery,
    callback: function(e){
      if(e.direction == 'up') {
        product_gallery_swiper.slidePrev();
      } else {
        var slideNext = product_gallery_swiper.slideNext();
        if(!slideNext) next_section.scrollIntoView();
      }
    }
  });
}

function resizeDots(swiper) {
  var product_gallery = body_product_template.querySelector('#product-gallery');
  var product_gallery_real_size = product_gallery.offsetHeight;
  var outside_height = window.innerHeight - 200;
  var swiper_pagination_bottom = window.innerHeight - 270;
  // if(acc_bar && !acc_bar.classList.contains('d-none')) swiper_pagination_bottom = swiper_pagination_bottom + 35;
  if(product_gallery_real_size > outside_height) swiper.el.style.setProperty('--swiper-pagination-top', swiper_pagination_bottom + 'px');
}

// Zoom-in ECom images 
var zoomInModal = body_product_template.querySelector('#zoomin-modal'); 
if (zoomInModal) {
  zoomInModal.addEventListener('show.bs.modal', event => {
    var modalBody = zoomInModal.querySelector('.modal-body');
    modalBody.innerHTML = '';
    modalBody.insertAdjacentHTML('beforeEnd', event.relatedTarget.innerHTML);
    modalBody.insertAdjacentHTML('beforeEnd', event.relatedTarget.innerHTML);
    modalBody.querySelector('img:first-child').classList.add('h-auto','d-none','d-md-block');
    modalBody.querySelector('img:last-child').classList.add('w-auto','d-md-none');
    pinchZoom(modalBody.querySelector('img:last-child'));
  }); 

  var pinchZoom = (imageElement) => {
    var imageElementScale = 1;
  
    var start = {};
  
    // Calculate distance between two fingers
    var distance = (event) => {
      return Math.hypot(event.touches[0].pageX - event.touches[1].pageX, event.touches[0].pageY - event.touches[1].pageY);
    };
  
    imageElement.addEventListener('touchstart', (event) => {
      
      if (event.touches.length === 2) {
        event.preventDefault(); // Prevent page scroll
  
        // Calculate where the fingers have started on the X and Y axis
        start.x = (event.touches[0].pageX + event.touches[1].pageX) / 2;
        start.y = (event.touches[0].pageY + event.touches[1].pageY) / 2;
        start.distance = distance(event);
      }
    });
  
    imageElement.addEventListener('touchmove', (event) => {
      
      if (event.touches.length === 2) {
        event.preventDefault(); // Prevent page scroll
        var scale;
  
        // Safari provides event.scale as two fingers move on the screen
        // For other browsers just calculate the scale manually
        if (event.scale) {
          scale = event.scale;
        } else {
          var deltaDistance = distance(event);
          scale = deltaDistance / start.distance;
        }
  
        imageElementScale = Math.min(Math.max(1, scale), 4);
  
        // Calculate how much the fingers have moved on the X and Y axis
        var deltaX = (((event.touches[0].pageX + event.touches[1].pageX) / 2) - start.x) * 2; // x2 for accelarated movement
        var deltaY = (((event.touches[0].pageY + event.touches[1].pageY) / 2) - start.y) * 2; // x2 for accelarated movement
  
        // Transform the image to make it grow and move with fingers
        var transform = `translate3d(${deltaX}px, ${deltaY}px, 0) scale(${imageElementScale})`;
        imageElement.style.transform = transform;
        imageElement.style.WebkitTransform = transform;
        imageElement.style.zIndex = "9999"; 
      }
    }); 
  
    imageElement.addEventListener('touchend', (event) => {
      // Reset image to it's original format 
      // imageElement.style.transform = "";
      // imageElement.style.WebkitTransform = "";
      // imageElement.style.zIndex = "";
    });
  }
}

// Related Products
function reloadRelatedProducts(productRecommendationsSection) {
  var url = productRecommendationsSection.dataset.url;

  fetch(url)
    .then(response => response.text())
    .then(text => {
      var html = document.createElement('div');
      html.innerHTML = text;
      var recommendations = html.querySelector('#shopify-section-pdp-related-products .related-product-cards');
 
      if (recommendations && recommendations.innerHTML.trim().length) {
        productRecommendationsSection.querySelector('.swiper-wrapper').innerHTML = recommendations.innerHTML;
        
        var swiper_button_next = productRecommendationsSection.querySelector('.swiper-button-next');
        var swiper_button_prev = productRecommendationsSection.querySelector('.swiper-button-prev');
        var swiper_scrollbar = productRecommendationsSection.querySelector('.swiper-scrollbar');
        var recommendations_carousel_options = {
          slidesPerView: productRecommendationsSection.dataset.slidesPerRowMobile,
          mousewheel: {
            forceToAxis: true
          },
          breakpoints: {
            768: {
              slidesPerView: productRecommendationsSection.dataset.slidesPerRowDesktop
            }
          },
          navigation: {
            nextEl: swiper_button_next,
            prevEl: swiper_button_prev,
          },
          scrollbar: {
            el: swiper_scrollbar,
            draggable: true,
          }
        };
        var recommendations_carousel_swiper = new Swiper(productRecommendationsSection, recommendations_carousel_options);
        
      }
    })
    .catch(e => {
      console.error(e);
    });
};

var productRecommendationsSection = document.querySelector('.related-products-carousel');
if(productRecommendationsSection) reloadRelatedProducts(productRecommendationsSection);

// Mobile Swipe Up and Down
var product_info_section = body_product_template.querySelector('#product-info');
var section = new URLSearchParams(location.search).get('section');
var mainContentSection = body_product_template.querySelector('main#MainContent');
var mainContentSectionRow = mainContentSection.querySelector('.pdp-section>section.row');
var acc_bar = body_product_template.querySelector('section.announcement-bar');
var body = body_product_template.querySelector('body');
var product_gallery_wrapper = body_product_template.querySelector('#product-gallery');
var footer = body_product_template.querySelector('footer.footer');
if (screenWidth.matches) {
  // if(acc_bar) acc_bar.classList.add('d-none'); 
  footer.classList.add('d-none');
  body_product_template.classList.add('overflow-hidden');
  // Put reviews in modal
  var reviewsModal = body_product_template.querySelector('#reviews-modal');
  if(reviewsModal) {
    reviewsModal.addEventListener('show.bs.modal', event => {
      var product_reviews = body_product_template.querySelector('#ReviewsWidget');
      var reviews_modal_body = reviewsModal.querySelector('#reviews-modal .modal-body');
      reviews_modal_body.appendChild(product_reviews);
    });
  }

  var last_scroll_top = 0;
  window.addEventListener('scroll', function() {
    var scroll_top = window.scrollY;
    if(scroll_top <= 0) {
      closeStickyContent();
    }
    last_scroll_top = scroll_top;
  });
  
  var stickyOpened = false;
  var countOpen = 0;

  makeButtonDraggable(product_info_section);
  makeButtonDraggable(pdp_gallery_section);

} else {
  header.classList.add('position-static');
  mainContentSectionRow.classList.add('m-auto');
  resizeProductInfo();
  window.addEventListener("resize", resizeProductInfo); 
}

function openStickyContent() {
  stickyOpened = true;
  var product_info_wrapper = body_product_template.querySelector('.product-info');
  product_info_wrapper.classList.remove('sticky-bottom-sm');
  mainContentSection.classList.add('opened');
  footer.classList.remove('d-none');
  body_product_template.classList.remove('overflow-hidden');
  var product_info_section = body_product_template.querySelector('#product-info');
  if(acc_bar) {
    window.scrollTo({
      behavior: 'smooth',
      top:
        product_info_section.getBoundingClientRect().top -
        document.body.getBoundingClientRect().top -
        acc_bar.offsetHeight,
    });
  } else {
    window.scrollTo({
      behavior: 'smooth',
      top:
        product_info_section.getBoundingClientRect().top -
        document.body.getBoundingClientRect().top
    });
  }
  countOpen++;
}

function closeStickyContent() {
  stickyOpened = false;
  var product_info_wrapper = body_product_template.querySelector('.product-info');
  product_info_wrapper.classList.add('sticky-bottom-sm');
  mainContentSection.classList.remove('opened');
  footer.classList.add('d-none');
  body_product_template.classList.add('overflow-hidden');
  setTimeout(function() {
    window.scrollTo(0,0);
  }, 100);
}

function makeButtonDraggable(elmnt) {
  var pos1 = 0,
      pos2 = 0,
      pos3 = 0,
      pos4 = 0
      contentScreenPosition = 0;

  elmnt.ontouchstart = dragMouseDown; //added touch event

  function dragMouseDown(e) {
    e = e || window.event;
    var whatIsTarget = e.target.nodeName;
    var targetClassList = e.target.classList;
    if(stickyOpened == false) {
      if(whatIsTarget != 'BUTTON' && whatIsTarget != 'IMG' && whatIsTarget != 'A' && whatIsTarget != 'SPAN' && !targetClassList.contains('offcanvas-backdrop') && !targetClassList.contains('gift-card-send-form') && !targetClassList.contains('gender-selector')) e.preventDefault();
    }
   
    if (e.type == 'touchstart' || e.type == 'touchmove' || e.type == 'touchend' || e.type == 'touchcancel') {
      var evt = (typeof e.originalEvent === 'undefined') ? e : e.originalEvent;
      var touch = evt.touches[0] || evt.changedTouches[0];
      y = touch.pageY;
      pos1 = touch.clientY;
    }

    pos4 = y;
    document.ontouchend = closeDragElement;
    document.ontouchmove = elementDrag;
  }

  function elementDrag(e) {
      e = e || window.event;
      whatIsTarget = e.target.nodeName;
      if(stickyOpened == false) {
        if(whatIsTarget != 'BUTTON' && whatIsTarget != 'IMG') e.preventDefault();
      }

      if (e.type == 'touchstart' || e.type == 'touchmove' || e.type == 'touchend' || e.type == 'touchcancel') {
        var evt = (typeof e.originalEvent === 'undefined') ? e : e.originalEvent;
        var touch = evt.touches[0] || evt.changedTouches[0];
        y = touch.pageY;
        pos3 = touch.clientY;
      }
      
      pos2 = pos4 - y;
      pos4 = y;

      yDiff = pos3 - pos1;
      if ( yDiff > 0 ) {
          // if(stickyOpened == true) {
          //   if(yDiff > 50) {
          //     closeStickyContent();
          //   }
          // }
      } else {
          if(stickyOpened == false) {
            if(yDiff < -50) {
              if(sizeSelectorOffcanvas) {
                if(!sizeSelectorOffcanvas.classList.contains('show')) openStickyContent();
              } else {
                openStickyContent();
              }
            }
          }
      }
  }

  function closeDragElement() {
      document.ontouchcancel = null; //added touch event
      document.ontouchend = null; //added touch event
      document.ontouchmove = null; //added touch event
  }
}

function resizeProductInfo() {
  var visibleArea = 0;
  if(acc_bar) visibleArea = window.innerHeight - (header.offsetHeight + acc_bar.offsetHeight);
  else visibleArea = window.innerHeight - (header.offsetHeight);
  var productGalleryHeight = product_gallery_wrapper.offsetHeight;
  if(visibleArea < productGalleryHeight) {
    product_gallery_wrapper.style.height = visibleArea + 'px'; 
    var newWidthGallery = (visibleArea*4)/5;
    var newWidth = (newWidthGallery * 100)/53.47;
    mainContentSectionRow.style.width = newWidth + 'px';
  }
  gallery_height = product_gallery_wrapper.offsetHeight;
}

var bisModal = document.querySelector('#backInStockModal');
if(bisModal) {
  var bisform = bisModal.querySelector('#back-in-stock-form');
  var entered_email = bisform.querySelector('input[type="email"]');
  var buttonSubmit = bisform.querySelector('button.btn-primary');
  var buttonLoading = bisform.querySelector('button.btn-secondary');
  var notify_form = bisModal.querySelector('#notify-form');
  var notify_success = bisModal.querySelector('#notify-success');

  bisModal.addEventListener('show.bs.modal', event => {
    var targetButton = event.relatedTarget;
    var variantId = targetButton.dataset.variantId;
    
    bisform.onsubmit = function (e) {
      e.preventDefault();
      
      if(entered_email.value!="" && variantId) {
        buttonLoading.classList.remove('d-none');
        buttonSubmit.classList.add('d-none');
        var payload = {
          "data": {
            "type": "back-in-stock-subscription",
            "attributes": {
              "profile": {
                "data": {
                    "type": "profile",
                    "attributes": {
                        "email": entered_email.value,
                    }
                  }
              },
              "channels": ["EMAIL"],
            },
            "relationships": {
              "variant": {
                "data": {
                  "type": "catalog-variant",
                  "id": "$shopify:::$default:::" + variantId
                }
              }
            }
          }
        }
        
        var requestOptions = {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
            "revision":"2024-06-15"
          },
          body: JSON.stringify(payload),
        };
        
        fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=UQuVPh",requestOptions)
          .then(result => {
            closeForm();
          })
          .catch(error => {
            closeForm();
            console.log('error', error);
          });
      }
  
      function closeForm(){
        notify_form.classList.add('d-none');
        notify_success.classList.remove('d-none');
        
        var bisModal_closeButton = bisModal.querySelector('.btn-close');
        setTimeout(function() { bisModal_closeButton.click() }, 1500);
      }
    }
  });
  
  bisModal.addEventListener('hidden.bs.modal', event => {
    notify_form.classList.remove('d-none');
    notify_success.classList.add('d-none');
    buttonLoading.classList.add('d-none');
    buttonSubmit.classList.remove('d-none');
  });
}
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popups"]) return;
  try {
    
function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

var passwordModal = document.querySelector('.password-modal');
var bodyElement = document.querySelector('body');
if(passwordModal) {
  var passwordModalCookieName = passwordModal.dataset.cookieName;
  var passwordActive = getCookie(passwordModalCookieName);
  if(passwordActive == 'yes') bodyElement.classList.add('sd');
  var passwordModalB = new bootstrap.Modal(passwordModal);
  var passwordModalShow = passwordModal.dataset.showPopup;
  var passwordModalClosed = getCookie('dontshowblackpopup'); 
  var passwordModalRedirect = passwordModal.dataset.popupRedirect;
  if(passwordModalClosed == 'yes') passwordModalShow = 'false';
  if(passwordActive == 'yes') passwordModalShow = 'false';
  if(passwordModalRedirect != "" && passwordActive != 'yes') passwordModalShow = 'true';
  if(Shopify.designMode) passwordModalShow = 'false';;
  if(passwordModalShow == 'true') passwordModalB.show();
  var beforePasswordContent = passwordModal.querySelector('.before-password-content');
  var passwordContent = passwordModal.querySelector('.password-content');
  var needPasswordBtn = passwordContent.querySelector('.btn[data-button-answer="need-password"]');
  var password = passwordModal.dataset.password;
  var passwordForm = passwordModal.querySelector('form#modal-form');
  var passwordInput = passwordForm.querySelector('input[type="text"]');
  var urlParams = new URLSearchParams(window.location.search);
  var passwordQS = urlParams.get('password');
  if(passwordQS) {
    passwordInput.value = passwordQS;
    if(beforePasswordContent) beforePasswordContent.classList.add('d-none');
    passwordContent.classList.remove('d-none');
    if(passwordQS == password) {
      setCookie(passwordModalCookieName, 'yes', 13);
      bodyElement.classList.add('sd');
      passwordModal.setAttribute('data-signed-up','true');
      enterDS();
    }
  }
  
  window.addEventListener("klaviyoForms", function(e) {
    var klaviyo_form_detail = e.detail;
    if(klaviyo_form_detail.type == 'submit' && klaviyo_form_detail.formId == passwordModal.dataset.klaviyoFormId) {
      if(beforePasswordContent) beforePasswordContent.classList.add('d-none');
      passwordContent.classList.remove('d-none');
      passwordModal.setAttribute('data-signed-up','true');
      passwordInput.value = "BLACKTROPIC";
      setCookie(passwordModalCookieName, 'yes', 13);
      bodyElement.classList.add('sd');
      if(needPasswordBtn) needPasswordBtn.classList.add('d-none');
    }
  });
  
  passwordModal.addEventListener("click", function(e) {
    var targetElement = e.target;
    if(targetElement.classList.contains('btn')) {
      if(targetElement.dataset.buttonAnswer=="have-password") {
        passwordInput.value = "";
        if(beforePasswordContent) beforePasswordContent.classList.add('d-none');
        passwordContent.classList.remove('d-none');
        if(needPasswordBtn) needPasswordBtn.classList.remove('d-none');
      } else if(targetElement.dataset.buttonAnswer=="need-password") {
        if(beforePasswordContent) beforePasswordContent.classList.remove('d-none');
        passwordContent.classList.add('d-none');
      }
    }
  });
  
  var passwordModalAus = document.querySelector('.password-modal-aus');

  passwordModal.addEventListener('hide.bs.modal', event => {
    if(window.location.href.indexOf('products')>0) return false;
    if(passwordModal.dataset.signedUp != 'true') {
      event.preventDefault();
      passwordModalAus.classList.add('show');
      passwordModalAus.style.display = "block";
      passwordModal.style.filter = "brightness(0.5)";
    }
  });

  passwordModalAus.addEventListener("click", function(e) {
    var targetElement = e.target;
    if(targetElement.classList.contains('btn')) {
      passwordModalAus.classList.remove('show');
      passwordModalAus.style.display = "none";
      passwordModal.style.filter = "brightness(1)";
      if(targetElement.dataset.buttonAnswer=="yes" || targetElement.dataset.buttonAnswer=="no") {
        passwordModal.setAttribute('data-signed-up','true');
        setCookie('dontshowblackpopup', 'yes', 1);
      }
    }
  });
    
  var passwordErrorText = passwordForm.querySelector('.form-text');
  var modalContent = passwordModal.querySelector('.modal-content');

  passwordForm.onsubmit = function (e) {
    e.preventDefault();
    passwordErrorText.classList.add('d-none');
    passwordInput.classList.remove('border-danger');
    modalContent.classList.remove('shake-animation');
    var passwordInputValue = passwordInput.value.toUpperCase();
    if(password === passwordInputValue){
      setCookie(passwordModalCookieName, 'yes', 13);
      passwordModal.setAttribute('data-signed-up','true');
      // if(passwordModalRedirect) location.href = passwordModalRedirect;
      // else { 
        passwordModalB.hide();
        enterDS();
        if(window.location.pathname == "/") location.href = "/collections/black-friday";
      // }
    } else {
      passwordErrorText.classList.remove('d-none');
      passwordInput.classList.add('border-danger');
      modalContent.classList.add('shake-animation');
    }
  }; 

  passwordInput.onfocus = function (e) {
    passwordErrorText.classList.add('d-none');
    passwordInput.classList.remove('border-danger');
    modalContent.classList.remove('shake-animation');
    // if(passwordInput.value != "") passwordInput.value = '';
  };

  if(passwordActive == 'yes') {
    enterDS();
  }
}

function enterDS() {
  bodyElement.classList.add('sd');
  document.querySelectorAll('input[name$="[_sd]"]').forEach((item)=>{
    item.removeAttribute('disabled'); 
  });
  var rewards_sections = document.querySelectorAll('section.rewards');
  rewards_sections.forEach((item)=>{
    var checked_color = item.querySelector('input[id^="R-"]:checked');
    if(checked_color) {
      checked_color.checked = false;
      item.querySelector('label[for="'+checked_color.getAttribute('id')+'"]').click();
    }
  });
}

var promocodeModal = document.querySelector('.promo-code-modal');
if(promocodeModal) {
  var promocodeModalB = new bootstrap.Modal(promocodeModal);
  var promocodeModalCookieName = promocodeModal.dataset.cookieName;
  var promocodeModalDiscountUrl = promocodeModal.dataset.discountUrl;
  var promocodeModalDelay = promocodeModal.dataset.popupDelay;
  var promocodeModalActive = getCookie(promocodeModalCookieName); 
  // promocodeModalActive = 'no';  
  // document.cookie = promocodeModalCookieName + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;'; 
  var acc_bar = document.querySelector('section.announcement-bar'); 
  var acc_bar_button = acc_bar.querySelector('a.announcement-bar-button');
  
  var showPopup = false;
  var includedParameters = promocodeModal.dataset.includedParameters;
  if(includedParameters) {
    var url = new URL(window.location.href);
    includedParameters.split('|').forEach((item) => {
      if(item.includes('=')) {
        var qitem = item.split('=');
        if(url.searchParams.get(qitem[0]) == qitem[1]) showPopup = true;
      } else {
        if(url.searchParams.has(item)) showPopup = true;
      }
    });
    var cameFromAd = getCookie('camefromad_sd_summer');
    if(showPopup == true) if(cameFromAd != 'yes') setCookie('camefromad_sd_summer', 'yes', 7);
  } else showPopup = true;

  function showPopupFn(){
    promocodeModalB.show();
  }
  
  if(promocodeModalActive != 'yes') {
    if(Shopify.designMode) showPopup = 'false';  
    if(showPopup == true) {
      if(promocodeModalDelay) {
        setTimeout(showPopupFn, parseInt(promocodeModalDelay));
      } else showPopupFn();
    }
  
    var applyButton = promocodeModal.querySelector('.promo-code-apply-button');
    if(applyButton) {
      applyButton.addEventListener('click', (e) => {
        bodyElement.classList.add('sd');
        applyButton.innerHTML = applyButton.dataset.clickedText;  
        if(acc_bar_button.innerHTML.includes('Apply')) acc_bar_button.querySelector('small').innerHTML = 'Applied to the cart!';
        setTimeout(function () { promocodeModalB.hide(); }, 500);
      });  
    }

    promocodeModal.addEventListener('hide.bs.modal', event => {
      setCookie(promocodeModalCookieName, 'yes', 1);
    });
  }

  if(promocodeModalDiscountUrl) {
    if(includedParameters) {
      var cameFromAd = getCookie('camefromad_sd_summer');
      if(cameFromAd == 'yes') {
        fetch(promocodeModalDiscountUrl, {
          method: "get"
        }).then(response => {
          bodyElement.classList.add('sd');
          if(acc_bar_button.innerHTML.includes('Apply')) acc_bar_button.querySelector('small').innerHTML = 'Applied to the cart!'; 
        });
      }
    } else {
      fetch(promocodeModalDiscountUrl, {
        method: "get"
      }).then(response => {
        if(acc_bar_button.innerHTML.includes('Apply')) acc_bar_button.querySelector('small').innerHTML = 'Applied to the cart!'; 
      });
    }
  }
}

var duelreferralModal = document.querySelector('.duel-referral-modal');
if(duelreferralModal) {
  var duelreferralModalShow = false;
  var duelreferralModalB = new bootstrap.Modal(duelreferralModal);
  var duelreferralModalCookieName = duelreferralModal.dataset.cookieName;
  var duelreferralModalActive = getCookie(duelreferralModalCookieName);
  var duelreferralDiscount = getCookie('discount_code');
  if(duelreferralDiscount.indexOf('DUELREF')>=0) duelreferralModalShow = true;
  else if(duelreferralDiscount.indexOf('DUEL10')>=0) duelreferralModalShow = true;
  if(duelreferralModalActive == 'yes') duelreferralModalShow = false;
  if(duelreferralModalShow == true) {
    bodyElement.classList.add('hide-klaviyo-popup');
    duelreferralModalB.show();
  }

  duelreferralModal.addEventListener('hide.bs.modal', event => {
    setCookie(duelreferralModalCookieName, 'yes', 1);
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pre-order-line"] && !window.DesignMode) return;
  try {
    
var preorderlines = document.querySelectorAll('section.pre-order-line div[data-batch-start-date]');
preorderlines.forEach((preorderlineitem)=>{
  var batches = preorderlineitem.querySelectorAll('div[data-batch-duration]');
  var now = new Date();
  var duration_desktop = 0;
  var duration_mobile = 0;
  var batch_enabled_desktop = false;
  var batch_enabled_mobile = false;
  batches.forEach((item)=>{
    var start_date = preorderlineitem.dataset.batchStartDate;
    var start_date_time = new Date(start_date);
    var start_date_timezone = preorderlineitem.dataset.batchTimeZone;
    var maxTime = new Date(start_date+start_date_timezone);
    var blockId = item.dataset.blockId;
    var itemSection = preorderlineitem;
    var itemHeading = itemSection.querySelector('.heading[data-block-id="'+blockId+'"]');
    var itemProgressDesktop = itemSection.querySelector('.progress:not(.d-md-none) .progress-bar[data-block-id="'+blockId+'"]');
    var itemProgressMobile = itemSection.querySelector('.progress.d-md-none .progress-bar[data-block-id="'+blockId+'"]');
    
    if(item.classList.contains('d-md-none')) {
      duration_mobile = parseInt(item.dataset.batchDuration) + duration_mobile;
      maxTime = new Date(
        maxTime.getFullYear(),
        maxTime.getMonth(),
        maxTime.getDate() + duration_mobile,
        maxTime.getHours(),
        maxTime.getMinutes(),
        maxTime.getSeconds()
      );
  
      var timeleft = maxTime.getTime() - new Date().getTime();
      var days = Math.floor(timeleft / (1000 * 60 * 60 * 24));
      var percentage = 100 - ((100 * days) / parseInt(item.dataset.batchDuration));

      if(start_date_time > now) {
        item.querySelector('.starting-soon').classList.remove('d-none');
        itemHeading.classList.add('opacity-25');
      } else {
        if(maxTime > now && batch_enabled_mobile == false) {
          countdown(item, maxTime);
          batch_enabled_mobile = true;
          itemHeading.querySelector('h5').classList.add('fw-bold');
          itemProgressMobile.style.width = percentage + '%';
        } else {
          if(batch_enabled_mobile == true) {
            item.querySelector('.starting-soon').classList.remove('d-none');
            itemHeading.classList.add('opacity-25');
          } else {
            item.querySelector('.finished').classList.remove('d-none');
            itemHeading.classList.add('text-decoration-line-through');
            itemProgressMobile.style.width = '100%';
          }
        }
      }
    } else {
      duration_desktop = parseInt(item.dataset.batchDuration) + duration_desktop;
      maxTime = new Date(
        maxTime.getFullYear(),
        maxTime.getMonth(),
        maxTime.getDate() + duration_desktop,
        maxTime.getHours(),
        maxTime.getMinutes(),
        maxTime.getSeconds()
      );
  
      var timeleft = maxTime.getTime() - new Date().getTime();
      var days = Math.floor(timeleft / (1000 * 60 * 60 * 24));
      var percentage = 100 - ((100 * days) / parseInt(item.dataset.batchDuration));

      if(start_date_time > now) {
        item.querySelector('.starting-soon').classList.remove('d-none');
        itemHeading.classList.add('opacity-25');
      } else {
        if(maxTime > now && batch_enabled_desktop == false) {
          countdown(item, maxTime);
          batch_enabled_desktop = true;
          itemHeading.querySelector('h5').classList.add('fw-bold');
          itemProgressDesktop.style.width = percentage + '%';
        } else {
          if(batch_enabled_desktop == true) {
            item.querySelector('.starting-soon').classList.remove('d-none');
            itemHeading.classList.add('opacity-25');
          } else {
            item.querySelector('.finished').classList.remove('d-none');
            itemHeading.classList.add('text-decoration-line-through');
            itemProgressDesktop.style.width = '100%';
          }
        }
      }
    }
  });
});

function countdown(item, maxTime) {
  var countDownDate = maxTime.getTime();
  var timeleft = countDownDate - new Date().getTime();
  if(timeleft > 0) {
    var days = Math.floor(timeleft / (1000 * 60 * 60 * 24));
    var hours = Math.floor((timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((timeleft % (1000 * 60)) / 1000);
    
    if(hours<10) hours = '0' + hours;
    if(days<10) days = '0' + days;
    if(minutes<10) minutes = '0' + minutes;
    if(seconds<10) seconds = '0' + seconds;

    item.querySelector('.days span').innerHTML = days;
    item.querySelector('.hours span').innerHTML = hours;
    item.querySelector('.minutes span').innerHTML = minutes;
    item.querySelector('.seconds span').innerHTML = seconds;
  
    var cdownId = item.dataset.blockId;
    if(item.classList.contains('d-md-none')) cdownId = cdownId + 'mobile';
    
    try {
      eval('POLTimer' + cdownId );
    } catch (e) {
      eval('POLTimer' + cdownId + '=setInterval(countdown, 1000, item, maxTime);');
    }
    if(item.querySelector('.batch-countdown.invisible')) item.querySelector('.batch-countdown.invisible').classList.remove('invisible');
  }
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["presentation"] && !window.DesignMode) return;
  try {
    
var presentations = document.querySelectorAll('section.presentation .presentation');
presentations.forEach((item) => {
  item.addEventListener('slide.bs.carousel', event => {
    var activeSlide = event.relatedTarget;
    if(activeSlide.dataset.sliderId) {
      var sliderSwiper = document.querySelector("#" + activeSlide.dataset.sliderId + ' .swiper-initialized');
      sliderSwiper.swiper.slideToLoop(activeSlide.dataset.sliderImageNumber);
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-gallery"]) return;
  try {
    
var product_gallery_thumbs = document.querySelector("#product-gallery-thumbs");
if(product_gallery_thumbs){
  var product_gallery_thumbs_swiper = new Swiper("#product-gallery-thumbs", {
    direction: "vertical",
    slidesPerView: "auto",
    autoHeight: true,
    freeMode: true,
    watchSlidesProgress: true,
    mousewheel: true
  });
}

var header = document.querySelector('header.section-header');
var product_gallery = document.querySelector('#product-gallery');
var screenWidth = window.matchMedia("(max-width: 749px)");
if(product_gallery_thumbs) {
  var product_gallery_swiper = new Swiper(product_gallery, {
    direction: "vertical",
    autoHeight: true,
    slidesPerView: 1,
    mousewheel: false,
    thumbs: {
      swiper: product_gallery_thumbs_swiper
    },
    pagination: {
      el: ".swiper-pagination-product-gallery",
      dynamicBullets: true
    },
    on: {
      afterInit: function (swiper) {
        swiper.el.classList.remove('invisible');
        resizeDots(swiper);
      },
      slideNextTransitionStart: function (swiper) {
        if(screenWidth.matches == true) {
          header.classList.remove('scrolled-up');
          header.classList.add('scrolled-down');
        }
      },
      slidePrevTransitionStart: function (swiper) {
        if(screenWidth.matches == true) {
          header.classList.add('scrolled-up','on-top');
          header.classList.remove('scrolled-down');
        }
      }
    }
  });
} else {
  var product_gallery_swiper = new Swiper(product_gallery, {
    direction: "vertical",
    autoHeight: true,
    slidesPerView: 1,
    mousewheel: false,
    pagination: {
      el: ".swiper-pagination-product-gallery",
      dynamicBullets: true
    },
    on: {
      afterInit: function (swiper) {
        swiper.el.classList.remove('invisible');
        resizeDots(swiper);
      },
      slideNextTransitionStart: function (swiper) {
        if(screenWidth.matches == true) {
          header.classList.remove('scrolled-up');
          header.classList.add('scrolled-down');
        }
      },
      slidePrevTransitionStart: function (swiper) {
        if(screenWidth.matches == true) {
          header.classList.add('scrolled-up','on-top');
          header.classList.remove('scrolled-down');
        }
      }
    }
  });
}

function resizeDots(swiper) {
  var product_info = document.querySelector('.product-info');
  var product_gallery = document.querySelector('#product-gallery');
  var product_gallery_real_size = product_gallery.offsetHeight;
  var outside_height = window.innerHeight - product_info.offsetHeight;
  var swiper_pagination_bottom = product_gallery_real_size - outside_height + 8;
  // if(acc_bar && !acc_bar.classList.contains('d-none')) swiper_pagination_bottom = swiper_pagination_bottom + 35;
  if(product_gallery_real_size > outside_height) swiper.el.style.setProperty('--swiper-pagination-bottom', swiper_pagination_bottom + 'px');
}

var product_reviews = document.querySelector('#product-reviews');
var indicator = new WheelIndicator({
  elem: document.querySelector('#product-gallery'),
  callback: function(e){
    if(e.direction == 'up') {
      product_gallery_swiper.slidePrev();
    } else {
      var slideNext = product_gallery_swiper.slideNext();
      if(!slideNext) product_reviews.scrollIntoView();
    }
  }
});
  
var horizontal_scroll_galleries = document.querySelectorAll('.horizontal-scroll-gallery');
horizontal_scroll_galleries.forEach((item)=>{
  var next_button = item.querySelector('.swiper-button-next');
  var prev_button = item.querySelector('.swiper-button-prev');
  var pagination = item.querySelector('.swiper-pagination');
  var horizontal_gallery_swiper = new Swiper(item, {
    slidesPerView: 1,
    autoHeight: true,
    loop: true,
    navigation: {
      nextEl: next_button,
      prevEl: prev_button
    },
    pagination: {
      el: pagination,
      dynamicBullets: true
    }
  });
});

// Zoom-in ECom images 
var zoomInModal = document.getElementById('zoomin-modal'); 
if (zoomInModal) {
  zoomInModal.addEventListener('show.bs.modal', event => {
    var modalBody = zoomInModal.querySelector('.modal-body');
    modalBody.innerHTML = '';
    modalBody.insertAdjacentHTML('beforeEnd', event.relatedTarget.innerHTML);
    modalBody.insertAdjacentHTML('beforeEnd', event.relatedTarget.innerHTML);
    modalBody.querySelector('img:first-child').classList.add('h-auto','d-none','d-md-block');
    modalBody.querySelector('img:last-child').classList.add('w-auto','d-md-none');
    pinchZoom(modalBody.querySelector('img:last-child'));
  }); 

  var pinchZoom = (imageElement) => {
    var imageElementScale = 1;
  
    var start = {};
  
    // Calculate distance between two fingers
    var distance = (event) => {
      return Math.hypot(event.touches[0].pageX - event.touches[1].pageX, event.touches[0].pageY - event.touches[1].pageY);
    };
  
    imageElement.addEventListener('touchstart', (event) => {
      
      if (event.touches.length === 2) {
        event.preventDefault(); // Prevent page scroll
  
        // Calculate where the fingers have started on the X and Y axis
        start.x = (event.touches[0].pageX + event.touches[1].pageX) / 2;
        start.y = (event.touches[0].pageY + event.touches[1].pageY) / 2;
        start.distance = distance(event);
      }
    });
  
    imageElement.addEventListener('touchmove', (event) => {
      
      if (event.touches.length === 2) {
        event.preventDefault(); // Prevent page scroll
        var scale;
  
        // Safari provides event.scale as two fingers move on the screen
        // For other browsers just calculate the scale manually
        if (event.scale) {
          scale = event.scale;
        } else {
          var deltaDistance = distance(event);
          scale = deltaDistance / start.distance;
        }
  
        imageElementScale = Math.min(Math.max(1, scale), 4);
  
        // Calculate how much the fingers have moved on the X and Y axis
        var deltaX = (((event.touches[0].pageX + event.touches[1].pageX) / 2) - start.x) * 2; // x2 for accelarated movement
        var deltaY = (((event.touches[0].pageY + event.touches[1].pageY) / 2) - start.y) * 2; // x2 for accelarated movement
  
        // Transform the image to make it grow and move with fingers
        var transform = `translate3d(${deltaX}px, ${deltaY}px, 0) scale(${imageElementScale})`;
        imageElement.style.transform = transform;
        imageElement.style.WebkitTransform = transform;
        imageElement.style.zIndex = "9999"; 
      }
    }); 
  
    imageElement.addEventListener('touchend', (event) => {
      // Reset image to it's original format 
      // imageElement.style.transform = "";
      // imageElement.style.WebkitTransform = "";
      // imageElement.style.zIndex = "";
    });
  }
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-info"]) return;
  try {
    
function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

var new_selector_selected_size = document.querySelector('.oc-select-your-size-btn span');
var new_selector_add_to_cart = document.querySelector('.oc-add-to-cart');
var new_selector_add_to_cart_submit = document.querySelector('.oc-add-to-cart-submit');
var product_forms = document.querySelectorAll("body.template-product #product-info form.shopify-product-form");
var selectedGender = getCookie('selected_gender');
if(selectedGender != "") {
  product_forms.forEach((item)=>{
    var input_gender = item.querySelector('input[data-gender="'+selectedGender+'"]');
    if(input_gender) input_gender.checked = true;
  });
}

var selectedApparel = getCookie('selected_apparel');
if(selectedApparel != "") {
  product_forms.forEach((item)=>{
    var input_selected_apparel = item.querySelector('input[data-selected-apparel-size="'+selectedApparel+'"]');
    if(input_selected_apparel) {
      input_selected_apparel.checked = true;
      checkPreorderShippingDateField(input_selected_apparel);
    }
  });
}

var selectedSneaker = getCookie('selected_sneaker');
if(selectedSneaker != "") {
  product_forms.forEach((item)=>{
    var input_selected_sneaker = item.querySelector('input[data-selected-sneaker-size="'+selectedSneaker+'"]');
    if(input_selected_sneaker) {
      input_selected_sneaker.checked = true;
      if(new_selector_selected_size) {
        new_selector_selected_size.innerHTML = input_selected_sneaker.nextElementSibling.querySelector('span').innerHTML;
        if(item.disabled == true) {
          new_selector_add_to_cart_submit.classList.add('d-none');
          new_selector_add_to_cart.classList.remove('d-none');
        } else {
          new_selector_add_to_cart_submit.classList.remove('d-none');
          new_selector_add_to_cart.classList.add('d-none');
        }
      }
      checkPreorderShippingDateField(input_selected_sneaker);
    }
  });
}

function checkPreorderShippingDateField(radio_input) {
  var itemForm = radio_input.closest('form');
  if(radio_input.dataset.variantEstimatedDelivery) {
    var preorder_product = itemForm.querySelector('input[data-preorder-product]');
    if(preorder_product) {
      preorder_product.checked = true;
      var preorder_shipping_date = itemForm.querySelector('input[name="items[1][properties][Shipping Pre-order]"]');
      preorder_shipping_date.removeAttribute('disabled');
    }
    var preorder_property = itemForm.querySelector('input.shipping-preorder[data-variant-estimated-delivery="'+radio_input.dataset.variantEstimatedDelivery+'"]');
    if(radio_input.checked == true) preorder_property.removeAttribute('disabled');
  } else clearPreorderProperties(itemForm);
}

var radio_inputs = document.querySelectorAll('form.shopify-product-form input[type="radio"]');
radio_inputs.forEach((item)=>{
  item.addEventListener('change', (event) => {
    if(item.dataset.selectedGender) setCookie('selected_gender',item.dataset.selectedGender,7);
    if(item.dataset.selectedSneakerSize) setCookie('selected_sneaker',item.dataset.selectedSneakerSize,7);
    if(item.dataset.selectedApparelSize) setCookie('selected_apparel',item.dataset.selectedApparelSize,7);
    checkPreorderShippingDateField(item);
    if(new_selector_selected_size) {
      new_selector_selected_size.innerHTML = item.nextElementSibling.querySelector('span').innerHTML;
      if(item.disabled == true) {
        new_selector_add_to_cart_submit.classList.add('d-none');
        new_selector_add_to_cart.classList.remove('d-none');
      } else {
        new_selector_add_to_cart_submit.classList.remove('d-none');
        new_selector_add_to_cart.classList.add('d-none');
      }
    }
  });
});

var url = new URL(window.location);
var radio_inputs_disabled_labels = document.querySelectorAll('form.shopify-product-form input[type="radio"]:disabled + label');
radio_inputs_disabled_labels.forEach((item)=>{
  item.addEventListener('mouseover', (event) => {
    var itemForm = item.closest('form');
    url.searchParams.set("variant", itemForm.querySelector('#'+item.getAttribute('for')).value);
    history.replaceState({}, '', url.href);
    itemForm.querySelector('.sold_out_checkbox').click();
    // history.pushState(null, '', url);
  });
});

var notify_me_button = document.querySelector('button.notify-me');
if(notify_me_button) {
  var itemForm = notify_me_button.closest('form');
  notify_me_button.addEventListener('mouseover', (event) => {
    url.searchParams.set("variant", notify_me_button.dataset.variantId);
    history.replaceState({}, '', url.href);
    itemForm.querySelector('.sold_out_checkbox').click();
  });
}

function clearPreorderProperties(itemForm) {
  var preorder_product = itemForm.querySelector('input[data-preorder-product]');
  if(preorder_product) {
    preorder_product.checked = false;
    var preorder_shipping_date = itemForm.querySelector('input[name="items[1][properties][Shipping Pre-order]"]:not(disabled)');
    preorder_shipping_date.setAttribute('disabled','true');
  }
  var preorder_properties = itemForm.querySelectorAll('input.shipping-preorder[data-variant-estimated-delivery]');
  preorder_properties.forEach((item)=>{
    item.setAttribute('disabled','true');
  });
}

var estimated_delivery = document.querySelector('span strong.estimated-delivery');
if(estimated_delivery) {
  var current_country = Shopify.country;
  ShipupETA.init({ publicApiKey: 'M7FgKbRMmERpYu3hE61Djw', estimationMode: 'range' }).fetchPredictions({
    destination: {
      country_code: current_country,
    }
  })
  .then(predictions => {
    var delivery_date = '';
    var safe_date = '';
    var date_format_options = { weekday: 'short', day: 'numeric', month: 'short' };
    if(current_country == 'HK' || current_country == 'JP' || current_country == 'SG' || current_country == 'AU' || current_country == 'CA') {
      delivery_date = new Date(predictions[0].delivery_date);
      safe_date = new Date(predictions[0].safe_delivery_date);
    } else if(current_country == 'GB') {
      delivery_date = new Date(predictions[18].delivery_date);
      safe_date = new Date(predictions[18].safe_delivery_date);
    } else if(current_country == 'US') {
      delivery_date = new Date(predictions.bestEstimation.delivery_date);
      safe_date = new Date(predictions[11].safe_delivery_date);
    } else {
      delivery_date = new Date(predictions[5].delivery_date);
      safe_date = new Date(predictions[5].safe_delivery_date);
    }
    estimated_delivery.innerHTML = delivery_date.toLocaleDateString("en-US", date_format_options) + ' - ' + safe_date.toLocaleDateString("en-US", date_format_options);
  })
  .catch(error => {
    console.error('Error', error);
  });
}
 
var accessory_modals = document.querySelectorAll('body.template-product .accessory-modal');
accessory_modals.forEach((item) => {
  item.addEventListener('show.bs.modal', event => {
    var a_carousel = item.querySelector('.carousel');
    a_carousel_b = new bootstrap.Carousel(a_carousel);
    a_carousel_b.to(0);
  });
});

var product_colors = document.querySelector('body.template-product #product-info .product-colors');
product_colors.addEventListener('click', (e) => {
  if(e.target.classList.contains('product-color-link')){
    e.preventDefault();
    var productUrl = e.target.getAttribute('href');
    if(e.target.nodeName == 'IMG') productUrl = e.target.closest('a').getAttribute('href');
    if(e.target.nodeName == 'STRONG') productUrl = e.target.closest('a').getAttribute('href');
    window.location.replace(productUrl); 
  }
});

var bundle_random_inputs = document.querySelectorAll('input[name$="[properties][_bundle]"]');
if(bundle_random_inputs) change_bundle_random(); 
function change_bundle_random() {
  var new_random = Number(new Date).toString(36)
  bundle_random_inputs.forEach((item)=>{
    item.value = new_random;
  });
}
  
var product_forms = document.querySelectorAll("body.template-product #product-info form.shopify-product-form");
var cart_offcanvas = new bootstrap.Offcanvas('#cart-offcanvas');
var sizeSelectorOffcanvas = document.querySelector('#sizeSelectorOffcanvas');
if(sizeSelectorOffcanvas) sizeSelectorOffcanvasB = new bootstrap.Offcanvas('#sizeSelectorOffcanvas');
product_forms.forEach((item)=>{
  item.onsubmit = function (e) {
    e.preventDefault();
    var productIds = item.dataset.productIds.split(',');
    if(productIds.length>1) {
      fbq('track', 'AddToCart', {
        'content_ids': item.dataset.productIds.split(','),
        'currency': Shopify.currency.active,
        'num_items': item.dataset.itemCount,
        'value': item.dataset.productPrice 
      });
    }  
    item.classList.add('loading');
    var formData = new FormData(item);
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(response => {
      item.classList.remove('loading');
      if(sizeSelectorOffcanvas) sizeSelectorOffcanvasB.hide();
      cart_offcanvas._element.classList.add('load-the-cart');
      cart_offcanvas.show();
      if(bundle_random_inputs) change_bundle_random(); 
    })
    .catch((error) => {
      console.error('Error:', error);
    }); 
  } 
});

// Related Products
var handleIntersection = (entries, observer) => {
  if (!entries[0].isIntersecting) return;

  observer.unobserve(productRecommendationsSection);

  var url = productRecommendationsSection.dataset.url;

  fetch(url)
    .then(response => response.text())
    .then(text => {
      var html = document.createElement('div');
      html.innerHTML = text;
      var recommendations = html.querySelector('.related-products-carousel');
 
      if (recommendations && recommendations.innerHTML.trim().length) {
        productRecommendationsSection.innerHTML = recommendations.innerHTML;

        var swiper_button_next = productRecommendationsSection.querySelector('.swiper-button-next');
        var swiper_button_prev = productRecommendationsSection.querySelector('.swiper-button-prev');
        var swiper_scrollbar = productRecommendationsSection.querySelector('.swiper-scrollbar');
        var recommendations_carousel_options = {
          slidesPerView: productRecommendationsSection.dataset.slidesPerRowMobile,
          mousewheel: {
            forceToAxis: true
          },
          breakpoints: {
            768: {
              slidesPerView: productRecommendationsSection.dataset.slidesPerRowDesktop
            }
          },
          navigation: {
            nextEl: swiper_button_next,
            prevEl: swiper_button_prev,
          },
          scrollbar: {
            el: swiper_scrollbar,
            draggable: true,
          }
        };
        var recommendations_carousel_swiper = new Swiper(productRecommendationsSection, recommendations_carousel_options);
        
      }
    })
    .catch(e => {
      console.error(e);
    });
};

var productRecommendationsSection = document.querySelector('.related-products-carousel');
var observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

if(productRecommendationsSection) observer.observe(productRecommendationsSection);

// Mobile Swipe Up and Down
var product_info_section = document.querySelector('#product-info');
var section = new URLSearchParams(location.search).get('section');
var product_reviews_section = document.querySelector('#product-reviews');
var mainContentSection = document.querySelector('main#MainContent');
var mainContentSectionRow = document.querySelector('main#MainContent>section.row');
var header = document.querySelector('header.section-header');
var acc_bar = document.querySelector('section.announcement-bar');
var body = document.querySelector('body');
var product_gallery_swiper = document.querySelector('#product-gallery'); 
function mobileScreenDetect(screenWidth) {
  if (screenWidth.matches) { // If media query matches
    var acc_bar = document.querySelector('section.announcement-bar');
    // if(acc_bar) acc_bar.classList.add('d-none'); 
    var product_info_wrapper = document.querySelector('.product-info');
    var footer = document.querySelector('footer.footer');
    var product_show_info_button = document.querySelector('#show-product-info');
    footer.classList.add('d-none');
    var body = document.querySelector('body');
    body.classList.add('overflow-hidden');
    // Put reviews in modal
    var reviewsModal = document.getElementById('reviews-modal');
    reviewsModal.addEventListener('show.bs.modal', event => {
      var product_reviews = document.querySelector('#ReviewsWidget');
      var reviews_modal_body = reviewsModal.querySelector('#reviews-modal .modal-body');
      reviews_modal_body.appendChild(product_reviews);
    });

    function scrollToTop() {
      setTimeout(function() {
        window.scrollTo(0,0);
      }, 100);
    }

    var last_scroll_top = 0;
    window.addEventListener('scroll', function() {
      var scroll_top = window.scrollY;
      if(scroll_top <= 0) {
        closeStickyContent();
      }
      last_scroll_top = scroll_top;
    });
    
    var stickyOpened = false;
    var countOpen = 0;
    function openStickyContent() {
      stickyOpened = true;
      product_info_wrapper.classList.remove('sticky-bottom-sm');
      footer.classList.remove('d-none');
      body.classList.remove('overflow-hidden');
      if(product_show_info_button) product_show_info_button.classList.add('d-none');
      mainContentSection.classList.add('opened');
      // product_info_section.scrollIntoView();
      if(acc_bar) {
        window.scrollTo({
          behavior: 'smooth',
          top:
            product_info_section.getBoundingClientRect().top -
            document.body.getBoundingClientRect().top -
            acc_bar.offsetHeight,
        });
      } else {
        window.scrollTo({
          behavior: 'smooth',
          top:
            product_info_section.getBoundingClientRect().top -
            document.body.getBoundingClientRect().top
        });
      }
      countOpen++;
    }
    
    function closeStickyContent() {
      stickyOpened = false;
      product_info_wrapper.classList.add('sticky-bottom-sm');
      footer.classList.add('d-none');
      body.classList.add('overflow-hidden');
      if(product_show_info_button) product_show_info_button.classList.remove('d-none');
      mainContentSection.classList.remove('opened');
      scrollToTop();
    }
    
    var diffTouches = 0;
    var product_gallery_swiper = document.querySelector('#product-gallery').swiper;
    product_gallery_swiper.on('touchEnd', function (swiper, event) {
      if(swiper.slides.length == (swiper.realIndex + 1) && swiper.touchesDirection == 'next' && diffTouches != swiper.touches.diff) openStickyContent();
      diffTouches = swiper.touches.diff;
    });

    document.querySelectorAll('.product-info-button').forEach((item)=>{
      item.addEventListener("click", function() {
        openStickyContent();
      });
    });

    function makeButtonDraggable(elmnt) {
      var pos1 = 0,
          pos2 = 0,
          pos3 = 0,
          pos4 = 0
          contentScreenPosition = 0;

      elmnt.ontouchstart = dragMouseDown; //added touch event
    
      function dragMouseDown(e) {
        e = e || window.event;
        var whatIsTarget = e.target.nodeName;
        var targetClassList = e.target.classList;
        if(stickyOpened == false) {
          if(whatIsTarget != 'BUTTON' && whatIsTarget != 'IMG' && whatIsTarget != 'A' && whatIsTarget != 'SPAN' && !targetClassList.contains('offcanvas-backdrop') && !targetClassList.contains('gift-card-send-form') && !targetClassList.contains('gender-selector')) e.preventDefault();
        }
       
        if (e.type == 'touchstart' || e.type == 'touchmove' || e.type == 'touchend' || e.type == 'touchcancel') {
          var evt = (typeof e.originalEvent === 'undefined') ? e : e.originalEvent;
          var touch = evt.touches[0] || evt.changedTouches[0];
          y = touch.pageY;
          pos1 = touch.clientY;
        }

        pos4 = y;
        document.ontouchend = closeDragElement;
        document.ontouchmove = elementDrag;
      }
    
      function elementDrag(e) {
          e = e || window.event;
          whatIsTarget = e.target.nodeName;
          if(stickyOpened == false) {
            if(whatIsTarget != 'BUTTON' && whatIsTarget != 'IMG') e.preventDefault();
          }
    
          if (e.type == 'touchstart' || e.type == 'touchmove' || e.type == 'touchend' || e.type == 'touchcancel') {
            var evt = (typeof e.originalEvent === 'undefined') ? e : e.originalEvent;
            var touch = evt.touches[0] || evt.changedTouches[0];
            y = touch.pageY;
            pos3 = touch.clientY;
          }
          
          pos2 = pos4 - y;
          pos4 = y;

          yDiff = pos3 - pos1;
          if ( yDiff > 0 ) {
              // if(stickyOpened == true) {
              //   if(yDiff > 50) {
              //     closeStickyContent();
              //   }
              // }
          } else {
              if(stickyOpened == false) {
                if(yDiff < -50) {
                  if(sizeSelectorOffcanvas) {
                    if(!sizeSelectorOffcanvas.classList.contains('show')) openStickyContent();
                  } else {
                    openStickyContent();
                  }
                }
              }
          }
      }
    
      function closeDragElement() {
          document.ontouchcancel = null; //added touch event
          document.ontouchend = null; //added touch event
          document.ontouchmove = null; //added touch event
      }
    }

    makeButtonDraggable(product_info_section);

  } else {
    document.querySelectorAll('.product-info-button').forEach((item)=>{
      item.addEventListener("click", function() {
        product_info_section.scrollIntoView();
      });
    });
    var product_reviews_button = document.querySelector('#product-reviews-button');
    if(product_reviews_button) {
      product_reviews_button.addEventListener("click", function(){
        product_reviews_section.scrollIntoView();
      });
    }
    header.classList.add('position-static');
    if(section == 'product-reviews' && product_reviews_section) product_reviews_section.scrollIntoView();
    mainContentSectionRow.classList.add('m-auto');
    resizeProductInfo();
    window.addEventListener("resize", resizeProductInfo); 
  }  
}

var screenWidth = window.matchMedia("(max-width: 749px)");
mobileScreenDetect(screenWidth);
screenWidth.addListener(mobileScreenDetect);

function resizeProductInfo() {
  var visibleArea = 0;
  if(acc_bar) visibleArea = window.innerHeight - (header.offsetHeight + acc_bar.offsetHeight);
  else visibleArea = window.innerHeight - (header.offsetHeight);
  var productGalleryHeight = product_gallery_swiper.offsetHeight;
  if(visibleArea < productGalleryHeight) {
    product_gallery_swiper.style.height = visibleArea + 'px'; 
    var newWidthGallery = (visibleArea*4)/5;
    var newWidth = (newWidthGallery * 100)/53.47;
    mainContentSectionRow.style.width = newWidth + 'px';
  }
}

var bisModal = document.querySelector('#backInStockModal');
if(bisModal) {
  var bisform = bisModal.querySelector('#back-in-stock-form');
  var entered_email = bisform.querySelector('input[type="email"]');
  var buttonSubmit = bisform.querySelector('button.btn-primary');
  var buttonLoading = bisform.querySelector('button.btn-secondary');
  var notify_form = bisModal.querySelector('#notify-form');
  var notify_success = bisModal.querySelector('#notify-success');

  bisModal.addEventListener('show.bs.modal', event => {
    var targetButton = event.relatedTarget;
    var variantId = targetButton.dataset.variantId;
    
    bisform.onsubmit = function (e) {
      e.preventDefault();
      
      if(entered_email.value!="" && variantId) {
        buttonLoading.classList.remove('d-none');
        buttonSubmit.classList.add('d-none');
        var payload = {
          "data": {
            "type": "back-in-stock-subscription",
            "attributes": {
              "profile": {
                "data": {
                    "type": "profile",
                    "attributes": {
                        "email": entered_email.value,
                    }
                  }
              },
              "channels": ["EMAIL"],
            },
            "relationships": {
              "variant": {
                "data": {
                  "type": "catalog-variant",
                  "id": "$shopify:::$default:::" + variantId
                }
              }
            }
          }
        }
        
        var requestOptions = {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
            "revision":"2024-06-15"
          },
          body: JSON.stringify(payload),
        };
        
        fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=UQuVPh",requestOptions)
          .then(result => {
            closeForm();
          })
          .catch(error => {
            closeForm();
            console.log('error', error);
          });
      }
  
      function closeForm(){
        notify_form.classList.add('d-none');
        notify_success.classList.remove('d-none');
        
        var bisModal_closeButton = bisModal.querySelector('.btn-close');
        setTimeout(function() { bisModal_closeButton.click() }, 1500);
      }
    }
  });
  
  bisModal.addEventListener('hidden.bs.modal', event => {
    notify_form.classList.remove('d-none');
    notify_success.classList.add('d-none');
    buttonLoading.classList.add('d-none');
    buttonSubmit.classList.remove('d-none');
  });
}
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rewards-v2-modals"] && !window.DesignMode) return;
  try {
    
var rewards_modals = document.querySelectorAll('section.rewards-v2-modal .rewards-modal');
rewards_modals.forEach((item) => {
  item.addEventListener('show.bs.modal', event => {
    var targetButton = event.relatedTarget;
    if(item.classList.contains('accessory-modal')) {
      var rewards_section_id = targetButton.dataset.rewardsSectionId;
      item.dataset.rewardsSectionId = rewards_section_id;
      var accessory_index = targetButton.dataset.accessoryIndex;
      item.dataset.accessoryIndex = accessory_index;
      var active_accessory = item.querySelector('.container.accessory[data-accessory-index="'+accessory_index+'"]');
      active_accessory.classList.remove('d-none');
      var active_carousel = item.querySelector('.carousel[data-accessory-index="'+accessory_index+'"]');
      trigger_for_mobile(active_carousel);
    } else {
      var main_product_index = targetButton.getAttribute('data-main-product-index');
      var active_carousel = item.querySelector('.main-product-photos.carousel[data-main-product-index="'+main_product_index+'"]');
      active_carousel.classList.remove('d-none');
      trigger_for_mobile(active_carousel);
    }
  });
  item.addEventListener('hidden.bs.modal', event => {
    var activated_accessory = item.querySelector('.container.accessory:not(.d-none)');
    if(activated_accessory) activated_accessory.classList.add('d-none');
    var active_main_carousel = item.querySelector('.main-product-photos.carousel:not(.d-none)');
    if(active_main_carousel) active_main_carousel.classList.add('d-none');
  });
});

var accessory_color_buttons = document.querySelectorAll('section.rewards-v2-modal button.accessory-color');
accessory_color_buttons.forEach((item) => {
  var accessory_modal = item.closest('.accessory-modal');
  item.addEventListener('click', (e) => {
    var accessory_index = item.dataset.accessoryIndex;
    var accessory_modal = item.closest('.accessory-modal');
    var activated_accessory = accessory_modal.querySelector('.container.accessory:not(.d-none)');
    if(activated_accessory) activated_accessory.classList.add('d-none');
    var active_accessory = accessory_modal.querySelector('.container.accessory[data-accessory-index="'+accessory_index+'"]');
    active_accessory.classList.remove('d-none');
    var active_carousel = accessory_modal.querySelector('.carousel[data-accessory-index="'+accessory_index+'"]');
    trigger_for_mobile(active_carousel);
  });
});

var accessory_labels = document.querySelectorAll('section.rewards-v2-modal button.accessory');
accessory_labels.forEach((item)=>{
  item.addEventListener('click', (e) => {
    var rewards_section_id = item.closest('.accessory-modal').dataset.rewardsSectionId;
    var rewards_form = document.querySelector('form#rewards-form-'+rewards_section_id);
    var label = rewards_form.querySelector('label[data-accessory-index="'+item.dataset.accessoryIndex+'"]');
    label.click();
    if(item.classList.contains('add-other-color')) {
      var other_selected_color = rewards_form.querySelector('input[data-accessory-main-index="'+item.dataset.accessoryMainIndex+'"][data-color-selected]');
      if(other_selected_color) other_selected_color.removeAttribute('data-color-selected');
      var label_input = rewards_form.querySelector('input[data-accessory-index="'+item.dataset.accessoryIndex+'"]')
      label_input.dataset.colorSelected = 'true';
    }
  });
});

function trigger_for_mobile(carousel){
  active_carousel = new bootstrap.Carousel(carousel);
  active_carousel.to(0);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rewards-v2"] && !window.DesignMode) return;
  try {
    
var estimated_delivery = document.querySelectorAll('strong.estimated-delivery'); 
if(estimated_delivery.length>0) {
  var current_country = Shopify.country;
  ShipupETA.init({ publicApiKey: 'M7FgKbRMmERpYu3hE61Djw', estimationMode: 'range' }).fetchPredictions({
    destination: {
      country_code: current_country,
    }
  })
  .then(predictions => {
    var delivery_date = '';
    var safe_date = '';
    var date_format_options = { weekday: 'short', day: 'numeric', month: 'short' };
    if(current_country == 'HK' || current_country == 'JP' || current_country == 'SG' || current_country == 'AU' || current_country == 'CA') {
      delivery_date = new Date(predictions[0].delivery_date);
      safe_date = new Date(predictions[0].safe_delivery_date);
    } else if(current_country == 'GB') {
      delivery_date = new Date(predictions[18].delivery_date);
      safe_date = new Date(predictions[18].safe_delivery_date);
    } else {
      delivery_date = new Date(predictions[5].delivery_date);
      safe_date = new Date(predictions[5].safe_delivery_date);
    }
    estimated_delivery.forEach((item)=>{  
      item.innerHTML = delivery_date.toLocaleDateString("en-US", date_format_options) + ' - ' + safe_date.toLocaleDateString("en-US", date_format_options);
    });
  })
  .catch(error => {
    console.error('Error', error);
  });
}

var inputs = document.querySelectorAll('section.rewards-v2 input[type="radio"]');
inputs.forEach((item) => {
  var rewards_section = item.closest('section');
  var rewards_form = rewards_section.querySelector('form');
  var accessory_limit = rewards_form.dataset.accessorySelectLimit;
  item.addEventListener('click', (e) => {
    if(item.classList.contains('accessory')) {
      var accessory_last_select_number = parseInt(rewards_form.dataset.accessoryLastSelectNumber);
      last_checked_same_index = rewards_form.querySelector('input.accessory[type="radio"][data-last-select-number][data-accessory-main-index="'+item.dataset.accessoryMainIndex+'"]');
      if(last_checked_same_index) {
        item.dataset.lastSelectNumber = last_checked_same_index.dataset.lastSelectNumber;
        last_checked_same_index.removeAttribute('data-last-select-number');
        item.checked = true;
      } else {
        last_checked = rewards_form.querySelector('input.accessory[type="radio"][data-last-select-number="'+(accessory_last_select_number-accessory_limit)+'"]');
        if(last_checked) {
          last_checked.checked = false;
          last_checked.removeAttribute('data-last-select-number');
        }
        item.checked = true;
        item.dataset.lastSelectNumber = accessory_last_select_number;
        if(last_checked) accessory_last_select_number++;
        rewards_form.dataset.accessoryLastSelectNumber = accessory_last_select_number;
      }
      change_rewards_layout(rewards_section);
    } else if(item.classList.contains('main-product')){
      var main_product_id = item.dataset.mainProductId + ',';
      if(item.checked==true) {
        if(item.dataset.productTitle) rewards_form.style.setProperty('--product-title', "'"+item.dataset.productTitle+"'");
        var main_product_id = item.dataset.mainProductId + ',';
        var accessories_labels = rewards_form.querySelectorAll('label[data-accessory-main-product-ids*="'+main_product_id+'"][data-accessory-main-color="false"]');
        accessories_labels.forEach((ac_item)=>{
          var ac_item_wrapper = ac_item.closest('.accessories');
          var other_main_color = ac_item_wrapper.querySelector('label[data-accessory-main-index="'+ac_item.dataset.accessoryMainIndex+'"][data-accessory-main-color="true"]');
          if(ac_item.dataset.disabled!="") {
            other_main_color.dataset.accessoryMainColor = 'false';
            ac_item.dataset.accessoryMainColor = 'true';
          }
        });
        var selected_accessories = rewards_form.querySelectorAll('input.accessory:checked');
        selected_accessories.forEach((ac_item)=>{
          if(!ac_item.dataset.colorSelected) {
            var real_main_color = rewards_form.querySelector('.accessories-main label[data-accessory-main-index="'+ac_item.dataset.accessoryMainIndex+'"][data-accessory-main-color="true"]');
            real_main_color.click();
          }
        });
        change_rewards_layout(rewards_section);
      }
    }
  });
});

function change_rewards_layout(rewards_section) {
  var rewards_form = rewards_section.querySelector('form');
  var selected_accessories = rewards_form.querySelectorAll('input.accessory[type="radio"]:checked');
  if(selected_accessories.length > 0) {
    rewards_form.style.setProperty('--accessory-size', "'+ "+selected_accessories.length+"'");
    rewards_form.dataset.accessorySize = selected_accessories.length;
  } else {
    rewards_form.removeAttribute('data-accessory-size');
  }
  calculate_prices(rewards_section);
}

function buildThresholdList() {
  let thresholds = [];
  let numSteps = 20;

  for (let i = 1.0; i <= numSteps; i++) {
    let ratio = i / numSteps;
    thresholds.push(ratio);
  }

  thresholds.push(0);
  return thresholds;
}

var options = {
  root: null,
  rootMargin: "0px",
  threshold: buildThresholdList(),
};

var observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    var more_button = entry.target.closest('section').querySelector('button.more');
    if (entry.isIntersecting) {
      if (entry.intersectionRatio >= 0.35) {
        more_button.classList.add('d-none');
      } else {
        more_button.classList.remove('d-none');
      }
    } else {
      more_button.classList.remove('d-none');
    }
  })
},options);

var accessories_more_labels = document.querySelectorAll('label.accessory-more');
accessories_more_labels.forEach((item)=>{
  observer.observe(item);
});

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
 
function calculate_prices(rewards_section) {
  var rewards_product_form = rewards_section.querySelector('form.rewards-form');
  Shopify.money_format = rewards_product_form.dataset.currencySymbol + "{{amount}}";
  var selected_products = rewards_product_form.querySelectorAll('input[type="radio"]:checked');
  var main_product_handle_input = rewards_product_form.querySelector('input.main-product-handle');
  var accessories_handle_input = rewards_product_form.querySelector('input.accessories');
  accessories_handle_input.value = '';
  var bundle_full_price = 0;
  var bundle_discounted_price = 0;
  var productIdsMeta = '';
  var itemCountMeta = 0;
  var cameFromAd = getCookie('camefromad_sd_summer');
  var welcome_banner = rewards_product_form.querySelector('.welcome-banner');
  var welcome_banner_active = true;
  selected_products.forEach((item)=>{
    productIdsMeta = productIdsMeta + ',' + item.value;
    itemCountMeta = itemCountMeta + 1;
    bundle_full_price = bundle_full_price + parseInt(item.dataset.fullPrice);
    var discounted_price = parseInt(item.dataset.fullPrice);
    if(cameFromAd == 'yes') {
      if(item.dataset.discountedPriceSd) {
        discounted_price = parseInt(item.dataset.discountedPriceSd);
        if(welcome_banner) welcome_banner_active = false;
      }
    }
    if(item.dataset.discountedPrice) discounted_price = parseInt(item.dataset.discountedPrice);
    bundle_discounted_price = bundle_discounted_price + discounted_price;
    var selected_main_product_handle = item.dataset.mainProductHandle;
    if(selected_main_product_handle) {
      main_product_handle_input.value = selected_main_product_handle;
      if(item.dataset.discountedPrice) welcome_banner_active = false;
    }
    var selected_accessory_handle = item.dataset.accessoryHandle;
    if(selected_accessory_handle) accessories_handle_input.value = accessories_handle_input.value + '|' + selected_accessory_handle;
  });
  var shaped_full_price = Shopify.formatMoney(bundle_full_price).replace('.00','');
  var shaped_discounted_price = Shopify.formatMoney(bundle_discounted_price).replace('.00','');
  var bundle_price_h6 = rewards_section.querySelector('h6.bundle-price');
  var bundle_price_offcanvas = rewards_section.querySelector('span.bundle-price');
  var discount_percentage = 100-Math.round((bundle_discounted_price*100)/bundle_full_price);
  if(discount_percentage==0) discount_percentage=1;
  var shaped_price = shaped_full_price;
  if(shaped_full_price != shaped_discounted_price) shaped_price = '<strong>'+shaped_discounted_price+'</strong><s class="text-secondary ms-2">'+shaped_full_price+'</s><strong class="text-danger ms-2">('+discount_percentage+'% off)</strong>';
  bundle_price_h6.innerHTML = shaped_price;
  if(bundle_price_offcanvas) bundle_price_offcanvas.innerHTML = shaped_price;
  if(welcome_banner) {
    welcome_banner.querySelector('span').innerHTML = Shopify.formatMoney(bundle_discounted_price - (bundle_discounted_price*0.1)).replace('.00','');
    if(welcome_banner_active == false) welcome_banner.classList.add('d-none');
    else welcome_banner.classList.remove('d-none');
  }
  rewards_product_form.dataset.productIds = productIdsMeta.substring(1);
  rewards_product_form.dataset.itemCount = itemCountMeta;
  rewards_product_form.dataset.bundleTotalPrice = bundle_discounted_price.toString().substring(0, bundle_discounted_price.toString().length - 2);
}

var accessory_labels = document.querySelectorAll('section.rewards-v2 label.accessory');
accessory_labels.forEach((item)=>{
  var rewards_form = item.closest('form');
  item.addEventListener('click', (e) => {
    var label_input = rewards_form.querySelector('input#'+item.getAttribute('for'));
    if(label_input && label_input.checked) e.preventDefault();
  });
});

var product_forms = document.querySelectorAll("section.rewards-v2 form.shopify-product-form");
var cart_offcanvas = new bootstrap.Offcanvas('#cart-offcanvas');
product_forms.forEach((product_form)=> { 
  product_form.onsubmit = function (e) { 
    if(typeof fbq == 'function') {
      fbq('track', 'AddToCart', {
        'content_category': 'Backpacks',
        'content_ids': product_form.dataset.productIds.split(',').map(Number),
        'currency': Shopify.currency.active,
        'num_items': product_form.dataset.itemCount,
        'value': product_form.dataset.bundleTotalPrice
      });
    }
    var accessories_offcanvas = bootstrap.Offcanvas.getInstance(product_form.querySelector('.offcanvas.accessories'));
    e.preventDefault();
    product_form.classList.add('loading');
    var formData = new FormData(product_form);
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(response => {
      product_form.classList.remove('loading');
      if(accessories_offcanvas) accessories_offcanvas.hide();
      cart_offcanvas._element.classList.add('load-the-cart');
      cart_offcanvas.show();
    })
    .catch((error) => {
      console.error('Error:', error);
    }); 
  }
});

var color_handle = window.location.hash;
if(color_handle) {
  color_handle = color_handle.replace('#','');
  var label_color_handles = document.querySelectorAll('label[data-color-handle="'+color_handle+'"]');
  label_color_handles.forEach((item)=>{
    var itemForm = item.closest('form');
    if(item.dataset.disabled !== undefined) {
      var first_available = item.closest('.main-colors').querySelector('label:not([data-disabled])');
      if(first_available) first_available.click();
      else itemForm.classList.add('sold-out');
    } else {
      item.click();
    }
    itemForm.classList.remove('loading');
  });
  if(label_color_handles.length==0) selectFirstColors();
} else {
  selectFirstColors();
}

function selectFirstColors() {
  var label_first_colors = document.querySelectorAll('label.first-color');
  label_first_colors.forEach((item)=>{
    itemForm = item.closest('form');
    if(item.dataset.disabled !== undefined) {
      var first_available = item.closest('.main-colors').querySelector('label:not([data-disabled])');
      if(first_available) first_available.click();
      else itemForm.classList.add('sold-out');
    } else {
      item.click();
    }
    itemForm.classList.remove('loading');
  });
}

var forms_limited = document.querySelectorAll('section.rewards-v2 form[data-accessory-select-limit]');
forms_limited.forEach((item)=>{
  var accessories = item.querySelectorAll('.accessories.offcanvas label');
  var accessory_limit = parseInt(item.dataset.accessorySelectLimit);
  var last_select_number = 0;
  accessories.forEach((ac_item)=>{
    is_visible = window.getComputedStyle(ac_item).display;
    if(is_visible == 'block' && !ac_item.disabled) {
      var ac_input = item.querySelector('input.accessory#'+ac_item.getAttribute('for'));
      if(last_select_number < accessory_limit) {
        ac_input.checked = true;
        ac_input.dataset.lastSelectNumber = last_select_number;
        item.dataset.accessoryLastSelectNumber = (last_select_number+1);
        last_select_number++;
      }
    }
  });
  change_rewards_layout(item.closest('section'));
});
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rewards-v3"] && !window.DesignMode) return;
  try {
    
var estimated_delivery = document.querySelectorAll('strong.estimated-delivery'); 
if(estimated_delivery.length>0) {
  var current_country = Shopify.country;
  ShipupETA.init({ publicApiKey: 'M7FgKbRMmERpYu3hE61Djw', estimationMode: 'range' }).fetchPredictions({
    destination: {
      country_code: current_country,
    }
  })
  .then(predictions => {
    var delivery_date = '';
    var safe_date = '';
    var date_format_options = { weekday: 'short', day: 'numeric', month: 'short' };
    if(current_country == 'HK' || current_country == 'JP' || current_country == 'SG' || current_country == 'AU' || current_country == 'CA') {
      delivery_date = new Date(predictions[0].delivery_date);
      safe_date = new Date(predictions[0].safe_delivery_date);
    } else if(current_country == 'GB') {
      delivery_date = new Date(predictions[18].delivery_date);
      safe_date = new Date(predictions[18].safe_delivery_date);
    } else {
      delivery_date = new Date(predictions[5].delivery_date);
      safe_date = new Date(predictions[5].safe_delivery_date);
    }
    estimated_delivery.forEach((item)=>{  
      item.innerHTML = delivery_date.toLocaleDateString("en-US", date_format_options) + ' - ' + safe_date.toLocaleDateString("en-US", date_format_options);
    });
  })
  .catch(error => {
    console.error('Error', error);
  });
}

var inputs = document.querySelectorAll('section.rewards-v3 input[type="radio"]');
inputs.forEach((item) => {
  var rewards_section = item.closest('section');
  var rewards_form = rewards_section.querySelector('form');
  item.addEventListener('click', (e) => {
    calculate_prices(rewards_section);
    if(item.classList.contains('accessory')) {
      var accessory_index = item.dataset.accessoryIndex;
      var accessory_main_index = item.dataset.accessoryMainIndex;
      var last_checked_true = rewards_form.querySelector('input.accessory[type="radio"][data-accessory-main-index="'+accessory_main_index+'"][data-was-checked="true"]:not([data-accessory-index="'+accessory_index+'"])');
      if(last_checked_true) last_checked_true.dataset.wasChecked="false";
      if (item.dataset.wasChecked == "false"){
        item.dataset.wasChecked = "true";
        item.checked =true;
        calculate_prices(rewards_section);
      } else {
        item.dataset.wasChecked = "false";
        item.checked =false;
        calculate_prices(rewards_section);
      }
    } else if(item.classList.contains('main-product')){
      var main_product_id = item.dataset.mainProductId + ',';
      if(item.checked==true) {
        var main_product_id = item.dataset.mainProductId + ',';
        var accessories_labels = rewards_form.querySelectorAll('label[data-accessory-main-product-ids*="'+main_product_id+'"][data-accessory-main-color="false"]');
        accessories_labels.forEach((ac_item)=>{
          var ac_item_wrapper = ac_item.closest('.accessories');
          var other_main_color = ac_item_wrapper.querySelector('label[data-accessory-main-index="'+ac_item.dataset.accessoryMainIndex+'"][data-accessory-main-color="true"]');
          if(ac_item.dataset.disabled!="") {
            other_main_color.dataset.accessoryMainColor = 'false';
            ac_item.dataset.accessoryMainColor = 'true';
          }
        });
        var selected_accessories = rewards_form.querySelectorAll('input.accessory:checked');
        selected_accessories.forEach((ac_item)=>{
          if(!ac_item.dataset.colorSelected) {
            var real_main_color = rewards_form.querySelector('.accessories-main label[data-accessory-main-index="'+ac_item.dataset.accessoryMainIndex+'"][data-accessory-main-color="true"]');
            var real_main_color_input = rewards_form.querySelector('input.accessory#'+real_main_color.getAttribute('for'));
            if(real_main_color_input.checked == false) real_main_color.click();
          }
        });
      }
    }
    var selected_accessories = rewards_form.querySelectorAll('input.accessory[type="radio"]:checked');
    if(item.dataset.productTitle) rewards_form.style.setProperty('--product-title', "'"+item.dataset.productTitle+"'");
    if(selected_accessories.length > 0) {
      rewards_form.style.setProperty('--accessory-size', "'+ "+selected_accessories.length+"'");
      rewards_form.dataset.accessorySize = selected_accessories.length;
    } else {
      rewards_form.removeAttribute('data-accessory-size');
    }
  });
});

var accessory_labels = document.querySelectorAll('section.rewards-v3 label.accessory');
accessory_labels.forEach((item)=>{
  var rewards_form = item.closest('form');
  item.addEventListener('click', (e) => {
    var label_input = rewards_form.querySelector('input#'+item.getAttribute('for'));
    if(item.classList.contains('add-other-color')) {
      var other_selected_color = rewards_form.querySelector('input[data-accessory-main-index="'+item.dataset.accessoryMainIndex+'"][data-color-selected]');
      if(other_selected_color) other_selected_color.removeAttribute('data-color-selected');
      label_input.dataset.colorSelected = 'true';
    }
  });
});

var accessory_color_buttons = document.querySelectorAll('section.rewards-v3 button.accessory-color');
accessory_color_buttons.forEach((item) => {
  var accessory_modal = item.closest('.accessory-modal');
  item.addEventListener('click', (e) => {
    var active_index = item.dataset.accessoryIndex;
    accessory_modal.dataset.accessoryIndex = active_index;
    var active_carousel = accessory_modal.querySelector('.carousel[data-accessory-index="'+active_index+'"]');
    trigger_for_mobile(active_carousel);
  });
});

function buildThresholdList() {
  let thresholds = [];
  let numSteps = 20;

  for (let i = 1.0; i <= numSteps; i++) {
    let ratio = i / numSteps;
    thresholds.push(ratio);
  }

  thresholds.push(0);
  return thresholds;
}

var options = {
  root: null,
  rootMargin: "0px",
  threshold: buildThresholdList(),
};

var observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    var more_button = entry.target.closest('section').querySelector('button.more');
    if (entry.isIntersecting) {
      if (entry.intersectionRatio >= 0.35) {
        more_button.classList.add('d-none');
      } else {
        more_button.classList.remove('d-none');
      }
    } else {
      more_button.classList.remove('d-none');
    }
  })
},options);

var accessories_more_labels = document.querySelectorAll('label.accessory-more');
accessories_more_labels.forEach((item)=>{
  observer.observe(item);
});

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
  
function calculate_prices(rewards_section) {
  var rewards_product_form = rewards_section.querySelector('form.rewards-form');
  Shopify.money_format = rewards_product_form.dataset.currencySymbol + "{{amount}}";
  var selected_products = rewards_product_form.querySelectorAll('input[type="radio"]:checked');
  var main_product_handle_input = rewards_product_form.querySelector('input.main-product-handle');
  var accessories_handle_input = rewards_product_form.querySelector('input.accessories');
  accessories_handle_input.value = '';
  var bundle_full_price = 0;
  var bundle_discounted_price = 0;
  var productIdsMeta = '';
  var itemCountMeta = 0;
  var cameFromAd = getCookie('camefromad_sd_summer');
  var welcome_banner = rewards_product_form.querySelector('.welcome-banner');
  var welcome_banner_active = true;
  selected_products.forEach((item)=>{
    productIdsMeta = productIdsMeta + ',' + item.value;
    itemCountMeta = itemCountMeta + 1;
    bundle_full_price = bundle_full_price + parseInt(item.dataset.fullPrice);
    var discounted_price = parseInt(item.dataset.fullPrice);
    if(cameFromAd == 'yes') {
      if(item.dataset.discountedPriceSd) {
        discounted_price = parseInt(item.dataset.discountedPriceSd);
        if(welcome_banner) welcome_banner_active = false;
      }
    }
    if(item.dataset.discountedPrice) discounted_price = parseInt(item.dataset.discountedPrice);
    bundle_discounted_price = bundle_discounted_price + discounted_price;
    var selected_main_product_handle = item.dataset.mainProductHandle;
    if(selected_main_product_handle) {
      main_product_handle_input.value = selected_main_product_handle;
      if(item.dataset.discountedPrice) welcome_banner_active = false;
    }
    var selected_accessory_handle = item.dataset.accessoryHandle;
    if(selected_accessory_handle) accessories_handle_input.value = accessories_handle_input.value + '|' + selected_accessory_handle;
  });
  var shaped_full_price = Shopify.formatMoney(bundle_full_price).replace('.00','');
  var shaped_discounted_price = Shopify.formatMoney(bundle_discounted_price).replace('.00','');
  var bundle_price_h6 = rewards_section.querySelector('h6.bundle-price');
  var bundle_price_offcanvas = rewards_section.querySelector('span.bundle-price');
  var discount_percentage = 100-Math.round((bundle_discounted_price*100)/bundle_full_price);
  var shaped_price = shaped_full_price;
  if(shaped_full_price != shaped_discounted_price) shaped_price = '<strong>'+shaped_discounted_price+'</strong><s class="text-secondary ms-2">'+shaped_full_price+'</s><strong class="text-danger ms-2">('+discount_percentage+'% off)</strong>';
  bundle_price_h6.innerHTML = shaped_price;
  if(bundle_price_offcanvas) bundle_price_offcanvas.innerHTML = shaped_price;
  if(welcome_banner) {
    welcome_banner.querySelector('span').innerHTML = Shopify.formatMoney(bundle_discounted_price - (bundle_discounted_price*0.1)).replace('.00','');
    if(welcome_banner_active == false) welcome_banner.classList.add('d-none');
    else welcome_banner.classList.remove('d-none');
  }
  rewards_product_form.dataset.productIds = productIdsMeta.substring(1);
  rewards_product_form.dataset.itemCount = itemCountMeta;
  rewards_product_form.dataset.bundleTotalPrice = bundle_discounted_price.toString().substring(0, bundle_discounted_price.toString().length - 2);
}

var product_forms = document.querySelectorAll("section.rewards-v3 form.shopify-product-form");
var cart_offcanvas = new bootstrap.Offcanvas('#cart-offcanvas');
product_forms.forEach((product_form)=> { 
  product_form.onsubmit = function (e) { 
    if(typeof fbq == 'function') {
      fbq('track', 'AddToCart', {
        'content_category': 'Backpacks',
        'content_ids': product_form.dataset.productIds.split(',').map(Number),
        'currency': Shopify.currency.active,
        'num_items': product_form.dataset.itemCount,
        'value': product_form.dataset.bundleTotalPrice
      });
    }
    var accessories_offcanvas = bootstrap.Offcanvas.getInstance(product_form.querySelector('.offcanvas.accessories'));
    e.preventDefault();
    product_form.classList.add('loading');
    var formData = new FormData(product_form);
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(response => {
      product_form.classList.remove('loading');
      if(accessories_offcanvas) accessories_offcanvas.hide();
      cart_offcanvas._element.classList.add('load-the-cart');
      cart_offcanvas.show();
    })
    .catch((error) => {
      console.error('Error:', error);
    }); 
  }
});

var rewards_modals = document.querySelectorAll('section.rewards-v3 .rewards-modal');
rewards_modals.forEach((item) => {
  item.addEventListener('show.bs.modal', event => {
    var targetButton = event.relatedTarget;
    if(item.classList.contains('accessory-modal')) {
      var rewards_section_id = targetButton.dataset.rewardsSectionId;
      item.dataset.rewardsSectionId = rewards_section_id;
      var accessory_index = targetButton.dataset.accessoryIndex;
      
      item.dataset.accessoryIndex = accessory_index;
      var active_accessory = item.querySelector('.container.accessory[data-accessory-index="'+accessory_index+'"]');
      active_accessory.classList.remove('d-none');
      var active_carousel = item.querySelector('.carousel[data-accessory-index="'+accessory_index+'"]');
      trigger_for_mobile(active_carousel);
    } else {
      var main_product_index = targetButton.getAttribute('data-main-product-index');
      var active_carousel = item.querySelector('.main-product-photos.carousel[data-main-product-index="'+main_product_index+'"]');
      active_carousel.classList.remove('d-none');
      trigger_for_mobile(active_carousel);
    }
  });
  item.addEventListener('hidden.bs.modal', event => {
    var activated_accessory = item.querySelector('.container.accessory:not(.d-none)');
    if(activated_accessory) activated_accessory.classList.add('d-none');
    var active_main_carousel = item.querySelector('.main-product-photos.carousel:not(.d-none)');
    if(active_main_carousel) active_main_carousel.classList.add('d-none');
  });
});

var accessory_color_buttons = document.querySelectorAll('section.rewards-v3 button.accessory-color');
accessory_color_buttons.forEach((item) => {
  var accessory_modal = item.closest('.accessory-modal');
  item.addEventListener('click', (e) => {
    var accessory_index = item.dataset.accessoryIndex;
    var accessory_modal = item.closest('.accessory-modal');
    var activated_accessory = accessory_modal.querySelector('.container.accessory:not(.d-none)');
    if(activated_accessory) activated_accessory.classList.add('d-none');
    var active_accessory = accessory_modal.querySelector('.container.accessory[data-accessory-index="'+accessory_index+'"]');
    active_accessory.classList.remove('d-none');
    var active_carousel = accessory_modal.querySelector('.carousel[data-accessory-index="'+accessory_index+'"]');
    trigger_for_mobile(active_carousel);
  });
});

var accessory_labels = document.querySelectorAll('section.rewards-v3 button.accessory');
accessory_labels.forEach((item)=>{
  item.addEventListener('click', (e) => {
    var rewards_section_id = item.closest('.accessory-modal').dataset.rewardsSectionId;
    var rewards_form = document.querySelector('form#rewards-form-'+rewards_section_id);
    var label = rewards_form.querySelector('label[data-accessory-index="'+item.dataset.accessoryIndex+'"]');
    label.click();
    if(item.classList.contains('add-other-color')) {
      var other_selected_color = rewards_form.querySelector('input[data-accessory-main-index="'+item.dataset.accessoryMainIndex+'"][data-color-selected]');
      if(other_selected_color) other_selected_color.removeAttribute('data-color-selected');
      var label_input = rewards_form.querySelector('input[data-accessory-index="'+item.dataset.accessoryIndex+'"]')
      label_input.dataset.colorSelected = 'true';
    }
  });
});

function trigger_for_mobile(carousel){
  active_carousel = new bootstrap.Carousel(carousel);
  active_carousel.to(0);
}

var color_handle = window.location.hash;
if(color_handle) {
  color_handle = color_handle.replace('#','');
  var label_color_handles = document.querySelectorAll('label[data-color-handle="'+color_handle+'"]');
  label_color_handles.forEach((item)=>{
    var itemForm = item.closest('form');
    if(item.dataset.disabled !== undefined) {
      var first_available = item.closest('.main-colors').querySelector('label:not([data-disabled])');
      if(first_available) first_available.click();
      else itemForm.classList.add('sold-out');
    } else {
      item.click();
    }
    itemForm.classList.remove('loading');
  });
  if(label_color_handles.length==0) selectFirstColors();
} else {
  selectFirstColors();
}

function selectFirstColors() {
  var label_first_colors = document.querySelectorAll('label.first-color');
  label_first_colors.forEach((item)=>{
    itemForm = item.closest('form');
    if(item.dataset.disabled !== undefined) {
      var first_available = item.closest('.main-colors').querySelector('label:not([data-disabled])');
      if(first_available) first_available.click();
      else itemForm.classList.add('sold-out');
    } else {
      item.click();
    }
    itemForm.classList.remove('loading');
  });
}
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-offcanvas"]) return;
  try {
    
var search_offcanvas = document.querySelector('#searchOffcanvas');
var search_offcanvas_loading = search_offcanvas.querySelector('.loading');
var search_offcanvas_body = search_offcanvas.querySelector('.offcanvas-body');
var search_offcanvas_body_results = search_offcanvas_body.querySelector('#results-container');
var search_offcanvas_body_filters_sort_wrapper = search_offcanvas_body_results.querySelector('#filters-sort-wrapper');
var search_offcanvas_body_filters_sort = search_offcanvas_body_results.querySelector('#filters-sort-search');
var search_offcanvas_body_results_products = search_offcanvas_body_results.querySelector('#results-products');
var search_offcanvas_body_results_products_loading = search_offcanvas_body_results.querySelector('.results-loading');
var search_form = search_offcanvas.querySelector('#searchOffcanvas #search-form');
var input_term = search_form.querySelector('input[type="text"]');
var search_canvas_home = search_offcanvas_body.querySelector('#search-home');
var search_offcanvas_popular_searches = search_canvas_home.querySelector('#popular-search');

var carousel = search_canvas_home.querySelector('.recommended-products-collection-carousel');
if(carousel) {
  var swiper_button_next = carousel.querySelector('.swiper-button-next');
  var swiper_button_prev = carousel.querySelector('.swiper-button-prev');
  var swiper_scrollbar = carousel.querySelector('.swiper-scrollbar');
  var carousel_options = {
    slidesPerView: carousel.dataset.slidesPerRowMobile,
    mousewheel: {
      forceToAxis: true
    },
    breakpoints: {
      768: {
        slidesPerView: carousel.dataset.slidesPerRowDesktop
      },
      1200: {
        slidesPerView: parseInt(carousel.dataset.slidesPerRowDesktop) + 1
      }
    },
    navigation: {
      nextEl: swiper_button_next,
      prevEl: swiper_button_prev,
    },
    scrollbar: {
      el: swiper_scrollbar,
      draggable: true,
    }
  };
  var carousel_swiper = new Swiper(carousel, carousel_options);
}

search_offcanvas_popular_searches.addEventListener('click', (e) => {
  var targetElement = e.target;
  if(targetElement.nodeName == 'BUTTON') {
    search_offcanvas_loading.classList.remove('d-none');
    input_term.value = targetElement.innerHTML;
    search_url = search_form.action + '?section_id=collection-search&q=' + input_term.value;
    do_search(search_url);
  }
});

search_offcanvas.addEventListener('shown.bs.offcanvas', event => {
  input_term.focus();
});
  
search_form.onsubmit = function (e) {
  e.preventDefault();
}

function throttleInterval(time, func) {
  if (!time || typeof time !== "number" || time < 0) {
      return func;
  }

  var throttleTimer = null;
  var lastState = null;
  var eventCounter = 0;
  var args = [];

  return function() {
    args = arguments;
    eventCounter++;
    if (!throttleTimer) {
      throttleTimer = setInterval(function() {
        if (eventCounter == lastState) {
          clearInterval(throttleTimer);
          throttleTimer = null;
          return;
        }

        lastState = eventCounter;
        func.apply(null, args);
      }, time);
    }
  }
}

var search_url = ''

function price_slider_init(price_slider) {
  var price_slider_start = parseInt(price_slider.dataset.start);
  var price_slider_end = parseInt(price_slider.dataset.end);
  var searchParams = new URLSearchParams(search_url);
  var priceGte = searchParams.get('filter.v.price.gte');
  var priceLte = searchParams.get('filter.v.price.lte');
  if(priceGte) price_slider_start = parseInt(priceGte);
  if(priceLte) price_slider_end = parseInt(priceLte);
  noUiSlider.create(price_slider, {
    start: [price_slider_start, price_slider_end],
    connect: true,
    range: {
      'min': 0,
      'max': parseInt(price_slider.dataset.max)
    },
    tooltips: [
      { to: function(value) { return price_slider.dataset.currencySymbol + String(value).split('.')[0]; } },
      { to: function(value) { return price_slider.dataset.currencySymbol + String(value).split('.')[0]; } }
    ],
  }).on('change',function(e){
    var selected_price_start = e[0];
    var selected_price_end = e[1];
    searchParams.set("filter.v.price.gte", selected_price_start);
    searchParams.set("filter.v.price.lte", selected_price_end);
    do_search(search_url + '&' + searchParams.toString());
  });
}

input_term.addEventListener("input", function(){
  if(input_term.value.length > 1){
    search_offcanvas_loading.classList.remove('d-none');
  } else {
    search_offcanvas_body_results_products.innerHTML = '';
    search_offcanvas_body_filters_sort.innerHTML = '';
    search_offcanvas.classList.remove('h-100');
    search_offcanvas_loading.classList.add('d-none');
    search_canvas_home.classList.remove('d-none');
  }
});

input_term.addEventListener("input", throttleInterval(750, function(evt) {
  if(input_term.value.length > 1){
    search_url = search_form.action + '?section_id=collection-search&q=' + input_term.value;
    do_search(search_url);
  }
}));

search_offcanvas_body_filters_sort_wrapper.addEventListener('click', (e) => {
  var targetNodeName = e.target.nodeName;
  var targetClassList = e.target.classList;
  var search_offcanvas_body_filters_sort_accordion = search_offcanvas_body_filters_sort.querySelector('#accordionPanelsFilters');
  if(targetNodeName == 'A') {
    if(targetClassList.contains('reload-page')) return false; 
    e.preventDefault();
    search_offcanvas_loading.classList.remove('d-none');
    if(targetClassList.contains('clear-all')) {
      search_url = search_form.action + '?section_id=collection-search&q=' + input_term.value;
      search_offcanvas_body_filters_sort_accordion.classList.add('d-none');
      search_offcanvas_body_filters_sort.querySelector('.filters-button').classList.remove('active');
    } else search_url = e.target.href + '&section_id=collection-search';
    do_search(search_url);
  } else if(targetClassList.contains('sort-item')) {
    if(targetNodeName == 'INPUT') do_search(search_url + '&sort_by=' + e.target.parentNode.dataset.sortValue);
    else do_search(search_url + '&sort_by=' + e.target.dataset.sortValue);
  } else if(targetClassList.contains('filters-button')) {
    search_offcanvas_body_filters_sort_accordion.classList.toggle('d-none');
    targetClassList.toggle('active');
  } else if(targetClassList.contains('apply-filters')) {
    search_offcanvas_body_filters_sort_accordion.classList.add('d-none');
    search_offcanvas_body_filters_sort.querySelector('.filters-button').classList.remove('active');
  }
});

var current_page = 1;

search_offcanvas_body.addEventListener("scroll", (event) => {
  var next_products_wrapper = search_offcanvas_body_results_products.querySelector('#next-products');
  if(!next_products_wrapper) return false;
  var top = next_products_wrapper.getBoundingClientRect().top;
  var left = next_products_wrapper.getBoundingClientRect().left;
  var bottom = next_products_wrapper.getBoundingClientRect().bottom;
  var right = next_products_wrapper.getBoundingClientRect().right;
  var innerHeight = window.innerHeight;
  var innerWidth = window.innerWidth;
  var isVisible = ((top > 0 && top < innerHeight) || (bottom > 0 && bottom < innerHeight)) && ((left > 0 && left < innerWidth) || (right > 0 && right < innerWidth));
  if(isVisible) {
    current_page++;
    next_products_wrapper.remove();
    search_offcanvas_body_results_products_loading.classList.remove('d-none');
    
    fetch(search_url + '&page=' + current_page)
    .then(function(response) {
      return response.text();
    })
    .then(function(response_body) {
      var searchParams = new URLSearchParams(search_url);
      var response_body = new DOMParser().parseFromString(response_body, "text/html");
      var new_products = response_body.querySelector('#products');
      var priceGte = searchParams.get('filter.v.price.gte');
      var priceLte = searchParams.get('filter.v.price.lte');
      if(priceGte && priceLte) {
        if(!search_offcanvas_body_results_products.querySelector("#products .product-card-wrapper:last-child")) {
          createProductWrapper = search_offcanvas_body_results_products.createElement("div");
          createProductWrapper.classList.add('product-card-wrapper','temp');
          search_offcanvas_body_results_products.querySelector("#products").appendChild(createProductWrapper);
        }
        new_products.querySelectorAll("#products .product-card-wrapper[data-real-price]").forEach((item)=>{
          if(parseInt(item.dataset.realPrice) > parseInt(priceLte)) item.remove();
          if(parseInt(item.dataset.realPrice) < parseInt(priceGte)) item.remove();
        });
      }
      search_offcanvas_body_results_products.querySelector("#products .product-card-wrapper:last-child").insertAdjacentHTML("afterend", new_products.innerHTML);
      var tempwrapper = search_offcanvas_body_results_products.querySelector("#products .product-card-wrapper.temp");
      if(tempwrapper) tempwrapper.remove();
      search_offcanvas_body_results_products_loading.classList.add('d-none');
    });
  }
});

function do_search(url) {
  var searchParams = new URLSearchParams(url);
  if(input_term.value != "") {
    search_canvas_home.classList.add('d-none');
    current_page = 1;
    search_offcanvas_body_results.scrollIntoView();
    fetch(url, {
    }).then(function(response) {
      return response.text();
    })
    .then(function(response_body) {
      var response_body = new DOMParser().parseFromString(response_body, "text/html");
      search_offcanvas_body_filters_sort.querySelectorAll('.filter').forEach((item)=>{
        var filter_item = response_body.querySelector("#filters-sort-search .filter#"+item.getAttribute('id'));
        if(filter_item && item.classList.contains('show')) {
          filter_item.closest('.accordion-item').querySelector('h2 button').classList.remove('collapsed');
          filter_item.classList.add('show');
        }
      });
      var search_offcanvas_body_filters_accordion = search_offcanvas_body_filters_sort.querySelector('#accordionPanelsFilters');
      if(search_offcanvas_body_filters_accordion) {
        if(!search_offcanvas_body_filters_accordion.classList.contains('d-none')) response_body.querySelector('#accordionPanelsFilters').classList.remove('d-none');
        if(search_offcanvas_body_filters_sort.querySelector('.filters-button').classList.contains('active')) response_body.querySelector('.filters-button').classList.add('active');
      }
      search_offcanvas_body_filters_sort.innerHTML = response_body.querySelector('#filters-sort-search').innerHTML;
      var new_price_slider = search_offcanvas_body_filters_sort.querySelector('#price-slider');
      if(new_price_slider) price_slider_init(new_price_slider);
      var priceGte = searchParams.get('filter.v.price.gte');
      var priceLte = searchParams.get('filter.v.price.lte');
      if(priceGte && priceLte) {
        response_body.querySelectorAll("#products .product-card-wrapper[data-real-price]").forEach((item)=>{
          if(parseInt(item.dataset.realPrice) > parseInt(priceLte)) item.remove();
          if(parseInt(item.dataset.realPrice) < parseInt(priceGte)) item.remove();
        });
        search_offcanvas_body_filters_sort.querySelector("#clear-all").classList.remove('d-none');
      }
      search_offcanvas_body_results_products.innerHTML = response_body.querySelector('#results-products').innerHTML;
      search_offcanvas.classList.add('h-100');
      search_offcanvas_loading.classList.add('d-none');
    });
  }
}
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sequence-scroll"] && !window.DesignMode) return;
  try {
    
var colors = document.querySelector('section.scroll-sequence-canvas-container .rounded-pill');
if(colors) {
  colors.addEventListener("click", function (e) {
    if(e.target.classList.contains('slide-product-color')) {
      var newHash = e.target.dataset.color;
      var sequenceContainer = document.querySelector('.scroll-sequence-canvas-container');
      var newColor = sequenceContainer.querySelector('canvas[data-color="'+newHash+'"]');
      var newColorButton = sequenceContainer.querySelector('.slide-product-color[data-color="'+newHash+'"]');
      var firstColor = sequenceContainer.querySelector('canvas:not([data-color="'+newHash+'"])');
      var firstColorButton = sequenceContainer.querySelector('.slide-product-color:not([data-color="'+newHash+'"])');
      if(newColor) {
        firstColor.classList.add('d-none');
        firstColorButton.classList.remove('border-dark');
        firstColorButton.classList.add('border-white');
        newColor.classList.remove('d-none');
        newColorButton.classList.remove('border-white');
        newColorButton.classList.add('border-dark');
      }
    }
  });
}
window.addEventListener("hashchange", function (event) {
  var newHash = window.location.hash.replace('#','');
  var sequenceContainer = document.querySelector('.scroll-sequence-canvas-container');
  var newColor = sequenceContainer.querySelector('canvas[data-color="'+newHash+'"]');
  var newColorButton = sequenceContainer.querySelector('.slide-product-color[data-color="'+newHash+'"]');
  var firstColor = sequenceContainer.querySelector('canvas:not([data-color="'+newHash+'"])');
  var firstColorButton = sequenceContainer.querySelector('.slide-product-color:not([data-color="'+newHash+'"])');
  if(newColor) {
    firstColor.classList.add('d-none');
    firstColorButton.classList.remove('border-dark');
    firstColorButton.classList.add('border-white');
    newColor.classList.remove('d-none');
    newColorButton.classList.remove('border-white');
    newColorButton.classList.add('border-dark');
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider"] && !window.DesignMode) return;
  try {
    
var sliders = document.querySelectorAll('.slider-carousel');
sliders.forEach((slider) => {
  var background_wrapper = slider.closest('.background');
  if(background_wrapper.dataset.gsapAnimation === 'true') {
    var section_wrapper = slider.closest('section');
    var bg_color = window.getComputedStyle(background_wrapper).getPropertyValue('--bg-color');
    section_wrapper.classList.add('gsap-animation-bg');
    section_wrapper.style = '--bg-color: ' + bg_color;
  }
  var swiper_button_next = slider.querySelector('.swiper-button-next');
  var swiper_button_prev = slider.querySelector('.swiper-button-prev');
  var swiper_scrollbar = slider.querySelector('.swiper-scrollbar');
  var pagination = slider.querySelector('.swiper-pagination');
  var only_active_video = slider.dataset.videoOnlyActive;
  var slider_options = {
    slidesPerView: parseInt(slider.dataset.slidesPerRowMobile),
    loop: (slider.dataset.slidesLoop === 'true'),
    centeredSlides: (slider.dataset.slidesCentered === 'true'),
    freeMode: (slider.dataset.freeMode === 'true'),
    allowTouchMove: (slider.dataset.freeMode === 'false'),
    effect: slider.dataset.effectType,
    hashNavigation: {
      enabled: (slider.dataset.hashNavigation === 'true'),
      watchState: (slider.dataset.hashNavigation === 'true')
    },
    mousewheel: {
      forceToAxis: true
    },
    breakpoints: { 
      768: {
        slidesPerView: slider.dataset.slidesPerRowDesktop
      }
    },
    navigation: {
      nextEl: swiper_button_next,
      prevEl: swiper_button_prev,
    },
    scrollbar: {
      el: swiper_scrollbar,
      draggable: true,
    },
    pagination: {
      el: pagination,
      dynamicBullets: true
    },
    on: {
      slideChangeTransitionEnd: function (swiper) {
        if(only_active_video=='true') change_videos_states(swiper);
      }
    }
  };
  var carousel_swiper = new Swiper(slider, slider_options);
});

function change_videos_states(swiper) {
  swiper.slidesEl.querySelectorAll('.swiper-slide').forEach((item)=>{
    var is_active = item.classList.contains('swiper-slide-active');
    var slider_videos = item.querySelectorAll('video');
    slider_videos.forEach((item)=>{
      if(is_active) item.play();
      else item.pause();
    });
  });
}

var videoModals = document.querySelectorAll('.video-modal');
videoModals.forEach((item)=>{
  var video_in_modal = item.querySelector('video');
  item.addEventListener('show.bs.modal', event => {
    video_in_modal.play();
  });
  item.addEventListener('hide.bs.modal', event => {
    video_in_modal.pause();
    video_in_modal.currentTime = 0;
  });
});
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-menu"] && !window.DesignMode) return;
  try {
    
var metaEvent = document.querySelector('a[data-event-type]');
if(metaEvent) {
  metaEvent.addEventListener('click', (e) => {
    if(typeof fbq == 'function') {
      fbq('track', 'AddToCart', { 
        'content_category': metaEvent.dataset.contentCategory,
        'content_ids': metaEvent.dataset.contentId,
        'currency': metaEvent.dataset.currency,
        'num_items': 1,
        'value': metaEvent.dataset.productValue
      }); 
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-content"] && !window.DesignMode) return;
  try {
    
document.querySelectorAll('section.tabbed-content').forEach((item)=>{
  item.addEventListener("click", function(e) {
    var targetElement = e.target;
    if(targetElement.classList.contains('btn-close')) {
      item.querySelector('.nav-link.active').classList.remove('active');
      item.querySelector('.tab-pane.active.show').classList.remove('active','show');
      item.querySelectorAll('.nav-link').forEach((nav_item)=>{
        nav_item.classList.add('stalled');
      });
    } else if(targetElement.classList.contains('inside-the-link')) {
      item.querySelectorAll('.nav-link').forEach((nav_item)=>{
        nav_item.classList.remove('stalled');
      });
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["terra-path"]) return;
  try {
    
  var terra_animation = document.querySelector('.terra-animation');
  var circle = terra_animation.querySelector("#circle");
  var circle_tooltip = circle.querySelector(".place-name");
  var km = circle_tooltip.querySelector(".km");
  var place_name = circle_tooltip.querySelector(".place");
  var justWear = document.querySelector('#just-wear-em');
  if(justWear) {
    justWear.querySelectorAll('video').forEach((item)=>{
      item.currentTime = 0;
    });
  }
  var justWearPlayed = false;

  window.onscroll = (event) => {
    var pageyoffset = window.pageYOffset + (window.innerHeight / 2);
    var percentage = ((pageyoffset*100)/terra_animation.dataset.offsetY)-4;
    var currentKm = 0;
    if(window.pageYOffset == 0) percentage = 0;
    if(percentage > 98) percentage = 98;
    
    circle.style.offsetDistance = percentage + '%';
    currentKm = Math.round((percentage*18535)/100);
    km.setAttribute('style','--num: '+ currentKm);

    if(percentage == 0) circle_tooltip.classList.add('first-bcn');
    else circle_tooltip.classList.remove('first-bcn');
    
    var placeName = '';

    if(currentKm == 0 && currentKm < 21) placeName = 'BCN';
    else if(currentKm > 789 && currentKm < 857) placeName = 'City of Guatemala';
    else if(currentKm > 2625 && currentKm < 2693) placeName = 'Antigua, Guatemala';
    else if(currentKm > 4356 && currentKm < 4408) placeName = 'Acatenango Volcano';
    else if(currentKm > 7632 && currentKm < 7691) placeName = 'Lake Atitlán';
    else if(currentKm > 9612 && currentKm < 9666) placeName = 'Mountains of the Mines';
    else if(currentKm > 10583 && currentKm < 10642) placeName = 'Caves of Jul Iq';
    else if(currentKm > 12890 && currentKm < 12945) placeName = 'Caves of Bombil Pek';
    else if(currentKm > 14863 && currentKm < 14925) placeName = 'Caves of Bombil Pek';
    else if(currentKm > 15832 && currentKm < 15891) placeName = 'Rio Dulce';
    else if(currentKm > 16496 && currentKm < 16550) placeName = 'City of Guatemala';
    else if(currentKm > 18145) placeName = 'BCN';
    place_name.innerHTML = placeName;

    if(percentage == 98) {
      if(justWear) {
        justWear.querySelectorAll('video').forEach((item)=>{
          if(justWearPlayed == false) item.play();
        });
        justWearPlayed = true;
      }
    } else {
      if(justWear) {
        justWear.querySelectorAll('video').forEach((item)=>{
          item.pause();
          item.currentTime = 0;
        });
        justWearPlayed = false;
      }
    }
  
    if(circle_tooltip.classList.contains('fadeout')) circle_tooltip.classList.remove('fadeout');
    circle_tooltip.classList.add('fadein');
    if(placeName == '') circle_tooltip.classList.remove('in-place');
    else circle_tooltip.classList.add('in-place');
    setTimeout(() => {
        if(!circle_tooltip.classList.contains('in-place')) {
            circle_tooltip.classList.add('fadeout');
            circle_tooltip.classList.remove('fadein');
        }
    }, 1000);
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tf-nation-header"] && !window.DesignMode) return;
  try {
    
function makeStickerDraggable(elmnt) {
  var pos1 = 0,
      pos2 = 0,
      pos3 = 0,
      pos4 = 0;

  elmnt.onmousedown = dragMouseDown;
  elmnt.ontouchstart = dragMouseDown; //added touch event

  function dragMouseDown(e) {
      e = e || window.event;
      e.preventDefault();
     
      if (e.type == 'touchstart' || e.type == 'touchmove' || e.type == 'touchend' || e.type == 'touchcancel') {
          var evt = (typeof e.originalEvent === 'undefined') ? e : e.originalEvent;
          var touch = evt.touches[0] || evt.changedTouches[0];
          x = touch.pageX;
          y = touch.pageY;
      } else if (e.type == 'mousedown' || e.type == 'mouseup' || e.type == 'mousemove' || e.type == 'mouseover' || e.type == 'mouseout' || e.type == 'mouseenter' || e.type == 'mouseleave') {
          x = e.clientX;
          y = e.clientY;
      }

      // get the mouse cursor position at startup:
      pos3 = x;
      pos4 = y;
      document.onmouseup = closeDragElement;
      document.ontouchend = closeDragElement;
      // call a function whenever the cursor moves:
      document.onmousemove = elementDrag;
      document.ontouchmove = elementDrag;
  }

  function elementDrag(e) {
      e = e || window.event;
      e.preventDefault();

      if (e.type == 'touchstart' || e.type == 'touchmove' || e.type == 'touchend' || e.type == 'touchcancel') {
          var evt = (typeof e.originalEvent === 'undefined') ? e : e.originalEvent;
          var touch = evt.touches[0] || evt.changedTouches[0];
          x = touch.pageX;
          y = touch.pageY;
      } else if (e.type == 'mousedown' || e.type == 'mouseup' || e.type == 'mousemove' || e.type == 'mouseover' || e.type == 'mouseout' || e.type == 'mouseenter' || e.type == 'mouseleave') {
          x = e.clientX;
          y = e.clientY;
      }

      // calculate the new cursor position:
      pos1 = pos3 - x;
      pos2 = pos4 - y;
      pos3 = x;
      pos4 = y;
      // set the element's new position:
      elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
      elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
  }

  function closeDragElement() {
      // stop moving when mouse button is released:
      document.onmouseup = null;
      document.ontouchcancel = null; //added touch event
      document.ontouchend = null; //added touch event
      document.onmousemove = null;
      document.ontouchmove = null; //added touch event
  }
}
var stickers = document.querySelectorAll('.tf-nation-header .sticker');
stickers.forEach((sticker) => {
  makeStickerDraggable(sticker);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tf-nation-referral-link"] && !window.DesignMode) return;
  try {
    
var copyTextButton = document.querySelector("button#copyTextButton");
copyTextButton.onclick = function(){
  var copyText = copyTextButton.getAttribute("data-text-to-copy");
  var copiedText = copyTextButton.getAttribute("data-copied-text");
  navigator.clipboard.writeText(copyText);
  if(copiedText) copyTextButton.innerHTML = copiedText;
}
  

  } catch(e) { console.error(e); }
})();
})();
